if ("undefined" == typeof jQuery) throw new Error("Bootstrap's JavaScript requires jQuery"); + function(a) {
    "use strict";
    var b = a.fn.jquery.split(" ")[0].split(".");
    if (b[0] < 2 && b[1] < 9 || 1 == b[0] && 9 == b[1] && b[2] < 1) throw new Error("Bootstrap's JavaScript requires jQuery version 1.9.1 or higher")
}(jQuery), + function(a) {
    "use strict";

    function b() {
        var a = document.createElement("bootstrap"),
            b = {
                WebkitTransition: "webkitTransitionEnd",
                MozTransition: "transitionend",
                OTransition: "oTransitionEnd otransitionend",
                transition: "transitionend"
            };
        for (var c in b)
            if (void 0 !== a.style[c]) return {
                end: b[c]
            };
        return !1
    }
    a.fn.emulateTransitionEnd = function(b) {
        var c = !1,
            d = this;
        a(this).one("bsTransitionEnd", function() {
            c = !0
        });
        var e = function() {
            c || a(d).trigger(a.support.transition.end)
        };
        return setTimeout(e, b), this
    }, a(function() {
        a.support.transition = b(), a.support.transition && (a.event.special.bsTransitionEnd = {
            bindType: a.support.transition.end,
            delegateType: a.support.transition.end,
            handle: function(b) {
                return a(b.target).is(this) ? b.handleObj.handler.apply(this, arguments) : void 0
            }
        })
    })
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        return this.each(function() {
            var c = a(this),
                e = c.data("bs.alert");
            e || c.data("bs.alert", e = new d(this)), "string" == typeof b && e[b].call(c)
        })
    }
    var c = '[data-dismiss="alert"]',
        d = function(b) {
            a(b).on("click", c, this.close)
        };
    d.VERSION = "3.3.5", d.TRANSITION_DURATION = 150, d.prototype.close = function(b) {
        function c() {
            g.detach().trigger("closed.bs.alert").remove()
        }
        var e = a(this),
            f = e.attr("data-target");
        f || (f = e.attr("href"), f = f && f.replace(/.*(?=#[^\s]*$)/, ""));
        var g = a(f);
        b && b.preventDefault(), g.length || (g = e.closest(".alert")), g.trigger(b = a.Event("close.bs.alert")), b.isDefaultPrevented() || (g.removeClass("in"), a.support.transition && g.hasClass("fade") ? g.one("bsTransitionEnd", c).emulateTransitionEnd(d.TRANSITION_DURATION) : c())
    };
    var e = a.fn.alert;
    a.fn.alert = b, a.fn.alert.Constructor = d, a.fn.alert.noConflict = function() {
        return a.fn.alert = e, this
    }, a(document).on("click.bs.alert.data-api", c, d.prototype.close)
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        return this.each(function() {
            var d = a(this),
                e = d.data("bs.button"),
                f = "object" == typeof b && b;
            e || d.data("bs.button", e = new c(this, f)), "toggle" == b ? e.toggle() : b && e.setState(b)
        })
    }
    var c = function(b, d) {
        this.$element = a(b), this.options = a.extend({}, c.DEFAULTS, d), this.isLoading = !1
    };
    c.VERSION = "3.3.5", c.DEFAULTS = {
        loadingText: "loading..."
    }, c.prototype.setState = function(b) {
        var c = "disabled",
            d = this.$element,
            e = d.is("input") ? "val" : "html",
            f = d.data();
        b += "Text", null == f.resetText && d.data("resetText", d[e]()), setTimeout(a.proxy(function() {
            d[e](null == f[b] ? this.options[b] : f[b]), "loadingText" == b ? (this.isLoading = !0, d.addClass(c).attr(c, c)) : this.isLoading && (this.isLoading = !1, d.removeClass(c).removeAttr(c))
        }, this), 0)
    }, c.prototype.toggle = function() {
        var a = !0,
            b = this.$element.closest('[data-toggle="buttons"]');
        if (b.length) {
            var c = this.$element.find("input");
            "radio" == c.prop("type") ? (c.prop("checked") && (a = !1), b.find(".active").removeClass("active"), this.$element.addClass("active")) : "checkbox" == c.prop("type") && (c.prop("checked") !== this.$element.hasClass("active") && (a = !1), this.$element.toggleClass("active")), c.prop("checked", this.$element.hasClass("active")), a && c.trigger("change")
        } else this.$element.attr("aria-pressed", !this.$element.hasClass("active")), this.$element.toggleClass("active")
    };
    var d = a.fn.button;
    a.fn.button = b, a.fn.button.Constructor = c, a.fn.button.noConflict = function() {
        return a.fn.button = d, this
    }, a(document).on("click.bs.button.data-api", '[data-toggle^="button"]', function(c) {
        var d = a(c.target);
        d.hasClass("btn") || (d = d.closest(".btn")), b.call(d, "toggle"), a(c.target).is('input[type="radio"]') || a(c.target).is('input[type="checkbox"]') || c.preventDefault()
    }).on("focus.bs.button.data-api blur.bs.button.data-api", '[data-toggle^="button"]', function(b) {
        a(b.target).closest(".btn").toggleClass("focus", /^focus(in)?$/.test(b.type))
    })
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        return this.each(function() {
            var d = a(this),
                e = d.data("bs.carousel"),
                f = a.extend({}, c.DEFAULTS, d.data(), "object" == typeof b && b),
                g = "string" == typeof b ? b : f.slide;
            e || d.data("bs.carousel", e = new c(this, f)), "number" == typeof b ? e.to(b) : g ? e[g]() : f.interval && e.pause().cycle()
        })
    }
    var c = function(b, c) {
        this.$element = a(b), this.$indicators = this.$element.find(".carousel-indicators"), this.options = c, this.paused = null, this.sliding = null, this.interval = null, this.$active = null, this.$items = null, this.options.keyboard && this.$element.on("keydown.bs.carousel", a.proxy(this.keydown, this)), "hover" == this.options.pause && !("ontouchstart" in document.documentElement) && this.$element.on("mouseenter.bs.carousel", a.proxy(this.pause, this)).on("mouseleave.bs.carousel", a.proxy(this.cycle, this))
    };
    c.VERSION = "3.3.5", c.TRANSITION_DURATION = 600, c.DEFAULTS = {
        interval: 5e3,
        pause: "hover",
        wrap: !0,
        keyboard: !0
    }, c.prototype.keydown = function(a) {
        if (!/input|textarea/i.test(a.target.tagName)) {
            switch (a.which) {
                case 37:
                    this.prev();
                    break;
                case 39:
                    this.next();
                    break;
                default:
                    return
            }
            a.preventDefault()
        }
    }, c.prototype.cycle = function(b) {
        return b || (this.paused = !1), this.interval && clearInterval(this.interval), this.options.interval && !this.paused && (this.interval = setInterval(a.proxy(this.next, this), this.options.interval)), this
    }, c.prototype.getItemIndex = function(a) {
        return this.$items = a.parent().children(".item"), this.$items.index(a || this.$active)
    }, c.prototype.getItemForDirection = function(a, b) {
        var c = this.getItemIndex(b),
            d = "prev" == a && 0 === c || "next" == a && c == this.$items.length - 1;
        if (d && !this.options.wrap) return b;
        var e = "prev" == a ? -1 : 1,
            f = (c + e) % this.$items.length;
        return this.$items.eq(f)
    }, c.prototype.to = function(a) {
        var b = this,
            c = this.getItemIndex(this.$active = this.$element.find(".item.active"));
        return a > this.$items.length - 1 || 0 > a ? void 0 : this.sliding ? this.$element.one("slid.bs.carousel", function() {
            b.to(a)
        }) : c == a ? this.pause().cycle() : this.slide(a > c ? "next" : "prev", this.$items.eq(a))
    }, c.prototype.pause = function(b) {
        return b || (this.paused = !0), this.$element.find(".next, .prev").length && a.support.transition && (this.$element.trigger(a.support.transition.end), this.cycle(!0)), this.interval = clearInterval(this.interval), this
    }, c.prototype.next = function() {
        return this.sliding ? void 0 : this.slide("next")
    }, c.prototype.prev = function() {
        return this.sliding ? void 0 : this.slide("prev")
    }, c.prototype.slide = function(b, d) {
        var e = this.$element.find(".item.active"),
            f = d || this.getItemForDirection(b, e),
            g = this.interval,
            h = "next" == b ? "left" : "right",
            i = this;
        if (f.hasClass("active")) return this.sliding = !1;
        var j = f[0],
            k = a.Event("slide.bs.carousel", {
                relatedTarget: j,
                direction: h
            });
        if (this.$element.trigger(k), !k.isDefaultPrevented()) {
            if (this.sliding = !0, g && this.pause(), this.$indicators.length) {
                this.$indicators.find(".active").removeClass("active");
                var l = a(this.$indicators.children()[this.getItemIndex(f)]);
                l && l.addClass("active")
            }
            var m = a.Event("slid.bs.carousel", {
                relatedTarget: j,
                direction: h
            });
            return a.support.transition && this.$element.hasClass("slide") ? (f.addClass(b), f[0].offsetWidth, e.addClass(h), f.addClass(h), e.one("bsTransitionEnd", function() {
                f.removeClass([b, h].join(" ")).addClass("active"), e.removeClass(["active", h].join(" ")), i.sliding = !1, setTimeout(function() {
                    i.$element.trigger(m)
                }, 0)
            }).emulateTransitionEnd(c.TRANSITION_DURATION)) : (e.removeClass("active"), f.addClass("active"), this.sliding = !1, this.$element.trigger(m)), g && this.cycle(), this
        }
    };
    var d = a.fn.carousel;
    a.fn.carousel = b, a.fn.carousel.Constructor = c, a.fn.carousel.noConflict = function() {
        return a.fn.carousel = d, this
    };
    var e = function(c) {
        var d, e = a(this),
            f = a(e.attr("data-target") || (d = e.attr("href")) && d.replace(/.*(?=#[^\s]+$)/, ""));
        if (f.hasClass("carousel")) {
            var g = a.extend({}, f.data(), e.data()),
                h = e.attr("data-slide-to");
            h && (g.interval = !1), b.call(f, g), h && f.data("bs.carousel").to(h), c.preventDefault()
        }
    };
    a(document).on("click.bs.carousel.data-api", "[data-slide]", e).on("click.bs.carousel.data-api", "[data-slide-to]", e), a(window).on("load", function() {
        a('[data-ride="carousel"]').each(function() {
            var c = a(this);
            b.call(c, c.data())
        })
    })
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        var c, d = b.attr("data-target") || (c = b.attr("href")) && c.replace(/.*(?=#[^\s]+$)/, "");
        return a(d)
    }

    function c(b) {
        return this.each(function() {
            var c = a(this),
                e = c.data("bs.collapse"),
                f = a.extend({}, d.DEFAULTS, c.data(), "object" == typeof b && b);
            !e && f.toggle && /show|hide/.test(b) && (f.toggle = !1), e || c.data("bs.collapse", e = new d(this, f)), "string" == typeof b && e[b]()
        })
    }
    var d = function(b, c) {
        this.$element = a(b), this.options = a.extend({}, d.DEFAULTS, c), this.$trigger = a('[data-toggle="collapse"][href="#' + b.id + '"],[data-toggle="collapse"][data-target="#' + b.id + '"]'), this.transitioning = null, this.options.parent ? this.$parent = this.getParent() : this.addAriaAndCollapsedClass(this.$element, this.$trigger), this.options.toggle && this.toggle()
    };
    d.VERSION = "3.3.5", d.TRANSITION_DURATION = 350, d.DEFAULTS = {
        toggle: !0
    }, d.prototype.dimension = function() {
        var a = this.$element.hasClass("width");
        return a ? "width" : "height"
    }, d.prototype.show = function() {
        if (!this.transitioning && !this.$element.hasClass("in")) {
            var b, e = this.$parent && this.$parent.children(".panel").children(".in, .collapsing");
            if (!(e && e.length && (b = e.data("bs.collapse"), b && b.transitioning))) {
                var f = a.Event("show.bs.collapse");
                if (this.$element.trigger(f), !f.isDefaultPrevented()) {
                    e && e.length && (c.call(e, "hide"), b || e.data("bs.collapse", null));
                    var g = this.dimension();
                    this.$element.removeClass("collapse").addClass("collapsing")[g](0).attr("aria-expanded", !0), this.$trigger.removeClass("collapsed").attr("aria-expanded", !0), this.transitioning = 1;
                    var h = function() {
                        this.$element.removeClass("collapsing").addClass("collapse in")[g](""), this.transitioning = 0, this.$element.trigger("shown.bs.collapse")
                    };
                    if (!a.support.transition) return h.call(this);
                    var i = a.camelCase(["scroll", g].join("-"));
                    this.$element.one("bsTransitionEnd", a.proxy(h, this)).emulateTransitionEnd(d.TRANSITION_DURATION)[g](this.$element[0][i])
                }
            }
        }
    }, d.prototype.hide = function() {
        if (!this.transitioning && this.$element.hasClass("in")) {
            var b = a.Event("hide.bs.collapse");
            if (this.$element.trigger(b), !b.isDefaultPrevented()) {
                var c = this.dimension();
                this.$element[c](this.$element[c]())[0].offsetHeight, this.$element.addClass("collapsing").removeClass("collapse in").attr("aria-expanded", !1), this.$trigger.addClass("collapsed").attr("aria-expanded", !1), this.transitioning = 1;
                var e = function() {
                    this.transitioning = 0, this.$element.removeClass("collapsing").addClass("collapse").trigger("hidden.bs.collapse")
                };
                return a.support.transition ? void this.$element[c](0).one("bsTransitionEnd", a.proxy(e, this)).emulateTransitionEnd(d.TRANSITION_DURATION) : e.call(this)
            }
        }
    }, d.prototype.toggle = function() {
        this[this.$element.hasClass("in") ? "hide" : "show"]()
    }, d.prototype.getParent = function() {
        return a(this.options.parent).find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]').each(a.proxy(function(c, d) {
            var e = a(d);
            this.addAriaAndCollapsedClass(b(e), e)
        }, this)).end()
    }, d.prototype.addAriaAndCollapsedClass = function(a, b) {
        var c = a.hasClass("in");
        a.attr("aria-expanded", c), b.toggleClass("collapsed", !c).attr("aria-expanded", c)
    };
    var e = a.fn.collapse;
    a.fn.collapse = c, a.fn.collapse.Constructor = d, a.fn.collapse.noConflict = function() {
        return a.fn.collapse = e, this
    }, a(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function(d) {
        var e = a(this);
        e.attr("data-target") || d.preventDefault();
        var f = b(e),
            g = f.data("bs.collapse"),
            h = g ? "toggle" : e.data();
        c.call(f, h)
    })
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        var c = b.attr("data-target");
        c || (c = b.attr("href"), c = c && /#[A-Za-z]/.test(c) && c.replace(/.*(?=#[^\s]*$)/, ""));
        var d = c && a(c);
        return d && d.length ? d : b.parent()
    }

    function c(c) {
        c && 3 === c.which || (a(e).remove(), a(f).each(function() {
            var d = a(this),
                e = b(d),
                f = {
                    relatedTarget: this
                };
            e.hasClass("open") && (c && "click" == c.type && /input|textarea/i.test(c.target.tagName) && a.contains(e[0], c.target) || (e.trigger(c = a.Event("hide.bs.dropdown", f)), c.isDefaultPrevented() || (d.attr("aria-expanded", "false"), e.removeClass("open").trigger("hidden.bs.dropdown", f))))
        }))
    }

    function d(b) {
        return this.each(function() {
            var c = a(this),
                d = c.data("bs.dropdown");
            d || c.data("bs.dropdown", d = new g(this)), "string" == typeof b && d[b].call(c)
        })
    }
    var e = ".dropdown-backdrop",
        f = '[data-toggle="dropdown"]',
        g = function(b) {
            a(b).on("click.bs.dropdown", this.toggle)
        };
    g.VERSION = "3.3.5", g.prototype.toggle = function(d) {
        var e = a(this);
        if (!e.is(".disabled, :disabled")) {
            var f = b(e),
                g = f.hasClass("open");
            if (c(), !g) {
                "ontouchstart" in document.documentElement && !f.closest(".navbar-nav").length && a(document.createElement("div")).addClass("dropdown-backdrop").insertAfter(a(this)).on("click", c);
                var h = {
                    relatedTarget: this
                };
                if (f.trigger(d = a.Event("show.bs.dropdown", h)), d.isDefaultPrevented()) return;
                e.trigger("focus").attr("aria-expanded", "true"), f.toggleClass("open").trigger("shown.bs.dropdown", h)
            }
            return !1
        }
    }, g.prototype.keydown = function(c) {
        if (/(38|40|27|32)/.test(c.which) && !/input|textarea/i.test(c.target.tagName)) {
            var d = a(this);
            if (c.preventDefault(), c.stopPropagation(), !d.is(".disabled, :disabled")) {
                var e = b(d),
                    g = e.hasClass("open");
                if (!g && 27 != c.which || g && 27 == c.which) return 27 == c.which && e.find(f).trigger("focus"), d.trigger("click");
                var h = " li:not(.disabled):visible a",
                    i = e.find(".dropdown-menu" + h);
                if (i.length) {
                    var j = i.index(c.target);
                    38 == c.which && j > 0 && j--, 40 == c.which && j < i.length - 1 && j++, ~j || (j = 0), i.eq(j).trigger("focus")
                }
            }
        }
    };
    var h = a.fn.dropdown;
    a.fn.dropdown = d, a.fn.dropdown.Constructor = g, a.fn.dropdown.noConflict = function() {
        return a.fn.dropdown = h, this
    }, a(document).on("click.bs.dropdown.data-api", c).on("click.bs.dropdown.data-api", ".dropdown form", function(a) {
        a.stopPropagation()
    }).on("click.bs.dropdown.data-api", f, g.prototype.toggle).on("keydown.bs.dropdown.data-api", f, g.prototype.keydown).on("keydown.bs.dropdown.data-api", ".dropdown-menu", g.prototype.keydown)
}(jQuery), + function(a) {
    "use strict";

    function b(b, d) {
        return this.each(function() {
            var e = a(this),
                f = e.data("bs.modal"),
                g = a.extend({}, c.DEFAULTS, e.data(), "object" == typeof b && b);
            f || e.data("bs.modal", f = new c(this, g)), "string" == typeof b ? f[b](d) : g.show && f.show(d)
        })
    }
    var c = function(b, c) {
        this.options = c, this.$body = a(document.body), this.$element = a(b), this.$dialog = this.$element.find(".modal-dialog"), this.$backdrop = null, this.isShown = null, this.originalBodyPad = null, this.scrollbarWidth = 0, this.ignoreBackdropClick = !1, this.options.remote && this.$element.find(".modal-content").load(this.options.remote, a.proxy(function() {
            this.$element.trigger("loaded.bs.modal")
        }, this))
    };
    c.VERSION = "3.3.5", c.TRANSITION_DURATION = 300, c.BACKDROP_TRANSITION_DURATION = 150, c.DEFAULTS = {
        backdrop: !0,
        keyboard: !0,
        show: !0
    }, c.prototype.toggle = function(a) {
        return this.isShown ? this.hide() : this.show(a)
    }, c.prototype.show = function(b) {
        var d = this,
            e = a.Event("show.bs.modal", {
                relatedTarget: b
            });
        this.$element.trigger(e), this.isShown || e.isDefaultPrevented() || (this.isShown = !0, this.checkScrollbar(), this.setScrollbar(), this.$body.addClass("modal-open"), this.escape(), this.resize(), this.$element.on("click.dismiss.bs.modal", '[data-dismiss="modal"]', a.proxy(this.hide, this)), this.$dialog.on("mousedown.dismiss.bs.modal", function() {
            d.$element.one("mouseup.dismiss.bs.modal", function(b) {
                a(b.target).is(d.$element) && (d.ignoreBackdropClick = !0)
            })
        }), this.backdrop(function() {
            var e = a.support.transition && d.$element.hasClass("fade");
            d.$element.parent().length || d.$element.appendTo(d.$body), d.$element.show().scrollTop(0), d.adjustDialog(), e && d.$element[0].offsetWidth, d.$element.addClass("in"), d.enforceFocus();
            var f = a.Event("shown.bs.modal", {
                relatedTarget: b
            });
            e ? d.$dialog.one("bsTransitionEnd", function() {
                d.$element.trigger("focus").trigger(f)
            }).emulateTransitionEnd(c.TRANSITION_DURATION) : d.$element.trigger("focus").trigger(f)
        }))
    }, c.prototype.hide = function(b) {
        b && b.preventDefault(), b = a.Event("hide.bs.modal"), this.$element.trigger(b), this.isShown && !b.isDefaultPrevented() && (this.isShown = !1, this.escape(), this.resize(), a(document).off("focusin.bs.modal"), this.$element.removeClass("in").off("click.dismiss.bs.modal").off("mouseup.dismiss.bs.modal"), this.$dialog.off("mousedown.dismiss.bs.modal"), a.support.transition && this.$element.hasClass("fade") ? this.$element.one("bsTransitionEnd", a.proxy(this.hideModal, this)).emulateTransitionEnd(c.TRANSITION_DURATION) : this.hideModal())
    }, c.prototype.enforceFocus = function() {
        a(document).off("focusin.bs.modal").on("focusin.bs.modal", a.proxy(function(a) {
            this.$element[0] === a.target || this.$element.has(a.target).length || this.$element.trigger("focus")
        }, this))
    }, c.prototype.escape = function() {
        this.isShown && this.options.keyboard ? this.$element.on("keydown.dismiss.bs.modal", a.proxy(function(a) {
            27 == a.which && this.hide()
        }, this)) : this.isShown || this.$element.off("keydown.dismiss.bs.modal")
    }, c.prototype.resize = function() {
        this.isShown ? a(window).on("resize.bs.modal", a.proxy(this.handleUpdate, this)) : a(window).off("resize.bs.modal")
    }, c.prototype.hideModal = function() {
        var a = this;
        this.$element.hide(), this.backdrop(function() {
            a.$body.removeClass("modal-open"), a.resetAdjustments(), a.resetScrollbar(), a.$element.trigger("hidden.bs.modal")
        })
    }, c.prototype.removeBackdrop = function() {
        this.$backdrop && this.$backdrop.remove(), this.$backdrop = null
    }, c.prototype.backdrop = function(b) {
        var d = this,
            e = this.$element.hasClass("fade") ? "fade" : "";
        if (this.isShown && this.options.backdrop) {
            var f = a.support.transition && e;
            if (this.$backdrop = a(document.createElement("div")).addClass("modal-backdrop " + e).appendTo(this.$body), this.$element.on("click.dismiss.bs.modal", a.proxy(function(a) {
                    return this.ignoreBackdropClick ? void(this.ignoreBackdropClick = !1) : void(a.target === a.currentTarget && ("static" == this.options.backdrop ? this.$element[0].focus() : this.hide()))
                }, this)), f && this.$backdrop[0].offsetWidth, this.$backdrop.addClass("in"), !b) return;
            f ? this.$backdrop.one("bsTransitionEnd", b).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : b()
        } else if (!this.isShown && this.$backdrop) {
            this.$backdrop.removeClass("in");
            var g = function() {
                d.removeBackdrop(), b && b()
            };
            a.support.transition && this.$element.hasClass("fade") ? this.$backdrop.one("bsTransitionEnd", g).emulateTransitionEnd(c.BACKDROP_TRANSITION_DURATION) : g()
        } else b && b()
    }, c.prototype.handleUpdate = function() {
        this.adjustDialog()
    }, c.prototype.adjustDialog = function() {
        var a = this.$element[0].scrollHeight > document.documentElement.clientHeight;
        this.$element.css({
            paddingLeft: !this.bodyIsOverflowing && a ? this.scrollbarWidth : "",
            paddingRight: this.bodyIsOverflowing && !a ? this.scrollbarWidth : ""
        })
    }, c.prototype.resetAdjustments = function() {
        this.$element.css({
            paddingLeft: "",
            paddingRight: ""
        })
    }, c.prototype.checkScrollbar = function() {
        var a = window.innerWidth;
        if (!a) {
            var b = document.documentElement.getBoundingClientRect();
            a = b.right - Math.abs(b.left)
        }
        this.bodyIsOverflowing = document.body.clientWidth < a, this.scrollbarWidth = this.measureScrollbar()
    }, c.prototype.setScrollbar = function() {
        var a = parseInt(this.$body.css("padding-right") || 0, 10);
        this.originalBodyPad = document.body.style.paddingRight || "", this.bodyIsOverflowing && this.$body.css("padding-right", a + this.scrollbarWidth)
    }, c.prototype.resetScrollbar = function() {
        this.$body.css("padding-right", this.originalBodyPad)
    }, c.prototype.measureScrollbar = function() {
        var a = document.createElement("div");
        a.className = "modal-scrollbar-measure", this.$body.append(a);
        var b = a.offsetWidth - a.clientWidth;
        return this.$body[0].removeChild(a), b
    };
    var d = a.fn.modal;
    a.fn.modal = b, a.fn.modal.Constructor = c, a.fn.modal.noConflict = function() {
        return a.fn.modal = d, this
    }, a(document).on("click.bs.modal.data-api", '[data-toggle="modal"]', function(c) {
        var d = a(this),
            e = d.attr("href"),
            f = a(d.attr("data-target") || e && e.replace(/.*(?=#[^\s]+$)/, "")),
            g = f.data("bs.modal") ? "toggle" : a.extend({
                remote: !/#/.test(e) && e
            }, f.data(), d.data());
        d.is("a") && c.preventDefault(), f.one("show.bs.modal", function(a) {
            a.isDefaultPrevented() || f.one("hidden.bs.modal", function() {
                d.is(":visible") && d.trigger("focus")
            })
        }), b.call(f, g, this)
    })
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        return this.each(function() {
            var d = a(this),
                e = d.data("bs.tooltip"),
                f = "object" == typeof b && b;
            (e || !/destroy|hide/.test(b)) && (e || d.data("bs.tooltip", e = new c(this, f)), "string" == typeof b && e[b]())
        })
    }
    var c = function(a, b) {
        this.type = null, this.options = null, this.enabled = null, this.timeout = null, this.hoverState = null, this.$element = null, this.inState = null, this.init("tooltip", a, b)
    };
    c.VERSION = "3.3.5", c.TRANSITION_DURATION = 150, c.DEFAULTS = {
        animation: !0,
        placement: "top",
        selector: !1,
        template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
        trigger: "hover focus",
        title: "",
        delay: 0,
        html: !1,
        container: !1,
        viewport: {
            selector: "body",
            padding: 0
        }
    }, c.prototype.init = function(b, c, d) {
        if (this.enabled = !0, this.type = b, this.$element = a(c), this.options = this.getOptions(d), this.$viewport = this.options.viewport && a(a.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : this.options.viewport.selector || this.options.viewport), this.inState = {
                click: !1,
                hover: !1,
                focus: !1
            }, this.$element[0] instanceof document.constructor && !this.options.selector) throw new Error("`selector` option must be specified when initializing " + this.type + " on the window.document object!");
        for (var e = this.options.trigger.split(" "), f = e.length; f--;) {
            var g = e[f];
            if ("click" == g) this.$element.on("click." + this.type, this.options.selector, a.proxy(this.toggle, this));
            else if ("manual" != g) {
                var h = "hover" == g ? "mouseenter" : "focusin",
                    i = "hover" == g ? "mouseleave" : "focusout";
                this.$element.on(h + "." + this.type, this.options.selector, a.proxy(this.enter, this)), this.$element.on(i + "." + this.type, this.options.selector, a.proxy(this.leave, this))
            }
        }
        this.options.selector ? this._options = a.extend({}, this.options, {
            trigger: "manual",
            selector: ""
        }) : this.fixTitle()
    }, c.prototype.getDefaults = function() {
        return c.DEFAULTS
    }, c.prototype.getOptions = function(b) {
        return b = a.extend({}, this.getDefaults(), this.$element.data(), b), b.delay && "number" == typeof b.delay && (b.delay = {
            show: b.delay,
            hide: b.delay
        }), b
    }, c.prototype.getDelegateOptions = function() {
        var b = {},
            c = this.getDefaults();
        return this._options && a.each(this._options, function(a, d) {
            c[a] != d && (b[a] = d)
        }), b
    }, c.prototype.enter = function(b) {
        var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
        return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusin" == b.type ? "focus" : "hover"] = !0), c.tip().hasClass("in") || "in" == c.hoverState ? void(c.hoverState = "in") : (clearTimeout(c.timeout), c.hoverState = "in", c.options.delay && c.options.delay.show ? void(c.timeout = setTimeout(function() {
            "in" == c.hoverState && c.show()
        }, c.options.delay.show)) : c.show())
    }, c.prototype.isInStateTrue = function() {
        for (var a in this.inState)
            if (this.inState[a]) return !0;
        return !1
    }, c.prototype.leave = function(b) {
        var c = b instanceof this.constructor ? b : a(b.currentTarget).data("bs." + this.type);
        return c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c)), b instanceof a.Event && (c.inState["focusout" == b.type ? "focus" : "hover"] = !1), c.isInStateTrue() ? void 0 : (clearTimeout(c.timeout), c.hoverState = "out", c.options.delay && c.options.delay.hide ? void(c.timeout = setTimeout(function() {
            "out" == c.hoverState && c.hide()
        }, c.options.delay.hide)) : c.hide())
    }, c.prototype.show = function() {
        var b = a.Event("show.bs." + this.type);
        if (this.hasContent() && this.enabled) {
            this.$element.trigger(b);
            var d = a.contains(this.$element[0].ownerDocument.documentElement, this.$element[0]);
            if (b.isDefaultPrevented() || !d) return;
            var e = this,
                f = this.tip(),
                g = this.getUID(this.type);
            this.setContent(), f.attr("id", g), this.$element.attr("aria-describedby", g), this.options.animation && f.addClass("fade");
            var h = "function" == typeof this.options.placement ? this.options.placement.call(this, f[0], this.$element[0]) : this.options.placement,
                i = /\s?auto?\s?/i,
                j = i.test(h);
            j && (h = h.replace(i, "") || "top"), f.detach().css({
                top: 0,
                left: 0,
                display: "block"
            }).addClass(h).data("bs." + this.type, this), this.options.container ? f.appendTo(this.options.container) : f.insertAfter(this.$element), this.$element.trigger("inserted.bs." + this.type);
            var k = this.getPosition(),
                l = f[0].offsetWidth,
                m = f[0].offsetHeight;
            if (j) {
                var n = h,
                    o = this.getPosition(this.$viewport);
                h = "bottom" == h && k.bottom + m > o.bottom ? "top" : "top" == h && k.top - m < o.top ? "bottom" : "right" == h && k.right + l > o.width ? "left" : "left" == h && k.left - l < o.left ? "right" : h, f.removeClass(n).addClass(h)
            }
            var p = this.getCalculatedOffset(h, k, l, m);
            this.applyPlacement(p, h);
            var q = function() {
                var a = e.hoverState;
                e.$element.trigger("shown.bs." + e.type), e.hoverState = null, "out" == a && e.leave(e)
            };
            a.support.transition && this.$tip.hasClass("fade") ? f.one("bsTransitionEnd", q).emulateTransitionEnd(c.TRANSITION_DURATION) : q()
        }
    }, c.prototype.applyPlacement = function(b, c) {
        var d = this.tip(),
            e = d[0].offsetWidth,
            f = d[0].offsetHeight,
            g = parseInt(d.css("margin-top"), 10),
            h = parseInt(d.css("margin-left"), 10);
        isNaN(g) && (g = 0), isNaN(h) && (h = 0), b.top += g, b.left += h, a.offset.setOffset(d[0], a.extend({
            using: function(a) {
                d.css({
                    top: Math.round(a.top),
                    left: Math.round(a.left)
                })
            }
        }, b), 0), d.addClass("in");
        var i = d[0].offsetWidth,
            j = d[0].offsetHeight;
        "top" == c && j != f && (b.top = b.top + f - j);
        var k = this.getViewportAdjustedDelta(c, b, i, j);
        k.left ? b.left += k.left : b.top += k.top;
        var l = /top|bottom/.test(c),
            m = l ? 2 * k.left - e + i : 2 * k.top - f + j,
            n = l ? "offsetWidth" : "offsetHeight";
        d.offset(b), this.replaceArrow(m, d[0][n], l)
    }, c.prototype.replaceArrow = function(a, b, c) {
        this.arrow().css(c ? "left" : "top", 50 * (1 - a / b) + "%").css(c ? "top" : "left", "")
    }, c.prototype.setContent = function() {
        var a = this.tip(),
            b = this.getTitle();
        a.find(".tooltip-inner")[this.options.html ? "html" : "text"](b), a.removeClass("fade in top bottom left right")
    }, c.prototype.hide = function(b) {
        function d() {
            "in" != e.hoverState && f.detach(), e.$element.removeAttr("aria-describedby").trigger("hidden.bs." + e.type), b && b()
        }
        var e = this,
            f = a(this.$tip),
            g = a.Event("hide.bs." + this.type);
        return this.$element.trigger(g), g.isDefaultPrevented() ? void 0 : (f.removeClass("in"), a.support.transition && f.hasClass("fade") ? f.one("bsTransitionEnd", d).emulateTransitionEnd(c.TRANSITION_DURATION) : d(), this.hoverState = null, this)
    }, c.prototype.fixTitle = function() {
        var a = this.$element;
        (a.attr("title") || "string" != typeof a.attr("data-original-title")) && a.attr("data-original-title", a.attr("title") || "").attr("title", "")
    }, c.prototype.hasContent = function() {
        return this.getTitle()
    }, c.prototype.getPosition = function(b) {
        b = b || this.$element;
        var c = b[0],
            d = "BODY" == c.tagName,
            e = c.getBoundingClientRect();
        null == e.width && (e = a.extend({}, e, {
            width: e.right - e.left,
            height: e.bottom - e.top
        }));
        var f = d ? {
                top: 0,
                left: 0
            } : b.offset(),
            g = {
                scroll: d ? document.documentElement.scrollTop || document.body.scrollTop : b.scrollTop()
            },
            h = d ? {
                width: a(window).width(),
                height: a(window).height()
            } : null;
        return a.extend({}, e, g, h, f)
    }, c.prototype.getCalculatedOffset = function(a, b, c, d) {
        return "bottom" == a ? {
            top: b.top + b.height,
            left: b.left + b.width / 2 - c / 2
        } : "top" == a ? {
            top: b.top - d,
            left: b.left + b.width / 2 - c / 2
        } : "left" == a ? {
            top: b.top + b.height / 2 - d / 2,
            left: b.left - c
        } : {
            top: b.top + b.height / 2 - d / 2,
            left: b.left + b.width
        }
    }, c.prototype.getViewportAdjustedDelta = function(a, b, c, d) {
        var e = {
            top: 0,
            left: 0
        };
        if (!this.$viewport) return e;
        var f = this.options.viewport && this.options.viewport.padding || 0,
            g = this.getPosition(this.$viewport);
        if (/right|left/.test(a)) {
            var h = b.top - f - g.scroll,
                i = b.top + f - g.scroll + d;
            h < g.top ? e.top = g.top - h : i > g.top + g.height && (e.top = g.top + g.height - i)
        } else {
            var j = b.left - f,
                k = b.left + f + c;
            j < g.left ? e.left = g.left - j : k > g.right && (e.left = g.left + g.width - k)
        }
        return e
    }, c.prototype.getTitle = function() {
        var a, b = this.$element,
            c = this.options;
        return a = b.attr("data-original-title") || ("function" == typeof c.title ? c.title.call(b[0]) : c.title)
    }, c.prototype.getUID = function(a) {
        do a += ~~(1e6 * Math.random()); while (document.getElementById(a));
        return a
    }, c.prototype.tip = function() {
        if (!this.$tip && (this.$tip = a(this.options.template), 1 != this.$tip.length)) throw new Error(this.type + " `template` option must consist of exactly 1 top-level element!");
        return this.$tip
    }, c.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".tooltip-arrow")
    }, c.prototype.enable = function() {
        this.enabled = !0
    }, c.prototype.disable = function() {
        this.enabled = !1
    }, c.prototype.toggleEnabled = function() {
        this.enabled = !this.enabled
    }, c.prototype.toggle = function(b) {
        var c = this;
        b && (c = a(b.currentTarget).data("bs." + this.type), c || (c = new this.constructor(b.currentTarget, this.getDelegateOptions()), a(b.currentTarget).data("bs." + this.type, c))), b ? (c.inState.click = !c.inState.click, c.isInStateTrue() ? c.enter(c) : c.leave(c)) : c.tip().hasClass("in") ? c.leave(c) : c.enter(c)
    }, c.prototype.destroy = function() {
        var a = this;
        clearTimeout(this.timeout), this.hide(function() {
            a.$element.off("." + a.type).removeData("bs." + a.type), a.$tip && a.$tip.detach(), a.$tip = null, a.$arrow = null, a.$viewport = null
        })
    };
    var d = a.fn.tooltip;
    a.fn.tooltip = b, a.fn.tooltip.Constructor = c, a.fn.tooltip.noConflict = function() {
        return a.fn.tooltip = d, this
    }
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        return this.each(function() {
            var d = a(this),
                e = d.data("bs.popover"),
                f = "object" == typeof b && b;
            (e || !/destroy|hide/.test(b)) && (e || d.data("bs.popover", e = new c(this, f)), "string" == typeof b && e[b]())
        })
    }
    var c = function(a, b) {
        this.init("popover", a, b)
    };
    if (!a.fn.tooltip) throw new Error("Popover requires tooltip.js");
    c.VERSION = "3.3.5", c.DEFAULTS = a.extend({}, a.fn.tooltip.Constructor.DEFAULTS, {
        placement: "right",
        trigger: "click",
        content: "",
        template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
    }), c.prototype = a.extend({}, a.fn.tooltip.Constructor.prototype), c.prototype.constructor = c, c.prototype.getDefaults = function() {
        return c.DEFAULTS
    }, c.prototype.setContent = function() {
        var a = this.tip(),
            b = this.getTitle(),
            c = this.getContent();
        a.find(".popover-title")[this.options.html ? "html" : "text"](b), a.find(".popover-content").children().detach().end()[this.options.html ? "string" == typeof c ? "html" : "append" : "text"](c), a.removeClass("fade top bottom left right in"), a.find(".popover-title").html() || a.find(".popover-title").hide()
    }, c.prototype.hasContent = function() {
        return this.getTitle() || this.getContent()
    }, c.prototype.getContent = function() {
        var a = this.$element,
            b = this.options;
        return a.attr("data-content") || ("function" == typeof b.content ? b.content.call(a[0]) : b.content)
    }, c.prototype.arrow = function() {
        return this.$arrow = this.$arrow || this.tip().find(".arrow")
    };
    var d = a.fn.popover;
    a.fn.popover = b, a.fn.popover.Constructor = c, a.fn.popover.noConflict = function() {
        return a.fn.popover = d, this
    }
}(jQuery), + function(a) {
    "use strict";

    function b(c, d) {
        this.$body = a(document.body), this.$scrollElement = a(a(c).is(document.body) ? window : c), this.options = a.extend({}, b.DEFAULTS, d), this.selector = (this.options.target || "") + " .nav li > a", this.offsets = [], this.targets = [], this.activeTarget = null, this.scrollHeight = 0, this.$scrollElement.on("scroll.bs.scrollspy", a.proxy(this.process, this)), this.refresh(), this.process()
    }

    function c(c) {
        return this.each(function() {
            var d = a(this),
                e = d.data("bs.scrollspy"),
                f = "object" == typeof c && c;
            e || d.data("bs.scrollspy", e = new b(this, f)), "string" == typeof c && e[c]()
        })
    }
    b.VERSION = "3.3.5", b.DEFAULTS = {
        offset: 10
    }, b.prototype.getScrollHeight = function() {
        return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
    }, b.prototype.refresh = function() {
        var b = this,
            c = "offset",
            d = 0;
        this.offsets = [], this.targets = [], this.scrollHeight = this.getScrollHeight(), a.isWindow(this.$scrollElement[0]) || (c = "position", d = this.$scrollElement.scrollTop()), this.$body.find(this.selector).map(function() {
            var b = a(this),
                e = b.data("target") || b.attr("href"),
                f = /^#./.test(e) && a(e);
            return f && f.length && f.is(":visible") && [
                [f[c]().top + d, e]
            ] || null
        }).sort(function(a, b) {
            return a[0] - b[0]
        }).each(function() {
            b.offsets.push(this[0]), b.targets.push(this[1])
        })
    }, b.prototype.process = function() {
        var a, b = this.$scrollElement.scrollTop() + this.options.offset,
            c = this.getScrollHeight(),
            d = this.options.offset + c - this.$scrollElement.height(),
            e = this.offsets,
            f = this.targets,
            g = this.activeTarget;
        if (this.scrollHeight != c && this.refresh(), b >= d) return g != (a = f[f.length - 1]) && this.activate(a);
        if (g && b < e[0]) return this.activeTarget = null, this.clear();
        for (a = e.length; a--;) g != f[a] && b >= e[a] && (void 0 === e[a + 1] || b < e[a + 1]) && this.activate(f[a])
    }, b.prototype.activate = function(b) {
        this.activeTarget = b, this.clear();
        var c = this.selector + '[data-target="' + b + '"],' + this.selector + '[href="' + b + '"]',
            d = a(c).parents("li").addClass("active");
        d.parent(".dropdown-menu").length && (d = d.closest("li.dropdown").addClass("active")),
            d.trigger("activate.bs.scrollspy")
    }, b.prototype.clear = function() {
        a(this.selector).parentsUntil(this.options.target, ".active").removeClass("active")
    };
    var d = a.fn.scrollspy;
    a.fn.scrollspy = c, a.fn.scrollspy.Constructor = b, a.fn.scrollspy.noConflict = function() {
        return a.fn.scrollspy = d, this
    }, a(window).on("load.bs.scrollspy.data-api", function() {
        a('[data-spy="scroll"]').each(function() {
            var b = a(this);
            c.call(b, b.data())
        })
    })
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        return this.each(function() {
            var d = a(this),
                e = d.data("bs.tab");
            e || d.data("bs.tab", e = new c(this)), "string" == typeof b && e[b]()
        })
    }
    var c = function(b) {
        this.element = a(b)
    };
    c.VERSION = "3.3.5", c.TRANSITION_DURATION = 150, c.prototype.show = function() {
        var b = this.element,
            c = b.closest("ul:not(.dropdown-menu)"),
            d = b.data("target");
        if (d || (d = b.attr("href"), d = d && d.replace(/.*(?=#[^\s]*$)/, "")), !b.parent("li").hasClass("active")) {
            var e = c.find(".active:last a"),
                f = a.Event("hide.bs.tab", {
                    relatedTarget: b[0]
                }),
                g = a.Event("show.bs.tab", {
                    relatedTarget: e[0]
                });
            if (e.trigger(f), b.trigger(g), !g.isDefaultPrevented() && !f.isDefaultPrevented()) {
                var h = a(d);
                this.activate(b.closest("li"), c), this.activate(h, h.parent(), function() {
                    e.trigger({
                        type: "hidden.bs.tab",
                        relatedTarget: b[0]
                    }), b.trigger({
                        type: "shown.bs.tab",
                        relatedTarget: e[0]
                    })
                })
            }
        }
    }, c.prototype.activate = function(b, d, e) {
        function f() {
            g.removeClass("active").find("> .dropdown-menu > .active").removeClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !1), b.addClass("active").find('[data-toggle="tab"]').attr("aria-expanded", !0), h ? (b[0].offsetWidth, b.addClass("in")) : b.removeClass("fade"), b.parent(".dropdown-menu").length && b.closest("li.dropdown").addClass("active").end().find('[data-toggle="tab"]').attr("aria-expanded", !0), e && e()
        }
        var g = d.find("> .active"),
            h = e && a.support.transition && (g.length && g.hasClass("fade") || !!d.find("> .fade").length);
        g.length && h ? g.one("bsTransitionEnd", f).emulateTransitionEnd(c.TRANSITION_DURATION) : f(), g.removeClass("in")
    };
    var d = a.fn.tab;
    a.fn.tab = b, a.fn.tab.Constructor = c, a.fn.tab.noConflict = function() {
        return a.fn.tab = d, this
    };
    var e = function(c) {
        c.preventDefault(), b.call(a(this), "show")
    };
    a(document).on("click.bs.tab.data-api", '[data-toggle="tab"]', e).on("click.bs.tab.data-api", '[data-toggle="pill"]', e)
}(jQuery), + function(a) {
    "use strict";

    function b(b) {
        return this.each(function() {
            var d = a(this),
                e = d.data("bs.affix"),
                f = "object" == typeof b && b;
            e || d.data("bs.affix", e = new c(this, f)), "string" == typeof b && e[b]()
        })
    }
    var c = function(b, d) {
        this.options = a.extend({}, c.DEFAULTS, d), this.$target = a(this.options.target).on("scroll.bs.affix.data-api", a.proxy(this.checkPosition, this)).on("click.bs.affix.data-api", a.proxy(this.checkPositionWithEventLoop, this)), this.$element = a(b), this.affixed = null, this.unpin = null, this.pinnedOffset = null, this.checkPosition()
    };
    c.VERSION = "3.3.5", c.RESET = "affix affix-top affix-bottom", c.DEFAULTS = {
        offset: 0,
        target: window
    }, c.prototype.getState = function(a, b, c, d) {
        var e = this.$target.scrollTop(),
            f = this.$element.offset(),
            g = this.$target.height();
        if (null != c && "top" == this.affixed) return c > e ? "top" : !1;
        if ("bottom" == this.affixed) return null != c ? e + this.unpin <= f.top ? !1 : "bottom" : a - d >= e + g ? !1 : "bottom";
        var h = null == this.affixed,
            i = h ? e : f.top,
            j = h ? g : b;
        return null != c && c >= e ? "top" : null != d && i + j >= a - d ? "bottom" : !1
    }, c.prototype.getPinnedOffset = function() {
        if (this.pinnedOffset) return this.pinnedOffset;
        this.$element.removeClass(c.RESET).addClass("affix");
        var a = this.$target.scrollTop(),
            b = this.$element.offset();
        return this.pinnedOffset = b.top - a
    }, c.prototype.checkPositionWithEventLoop = function() {
        setTimeout(a.proxy(this.checkPosition, this), 1)
    }, c.prototype.checkPosition = function() {
        if (this.$element.is(":visible")) {
            var b = this.$element.height(),
                d = this.options.offset,
                e = d.top,
                f = d.bottom,
                g = Math.max(a(document).height(), a(document.body).height());
            "object" != typeof d && (f = e = d), "function" == typeof e && (e = d.top(this.$element)), "function" == typeof f && (f = d.bottom(this.$element));
            var h = this.getState(g, b, e, f);
            if (this.affixed != h) {
                null != this.unpin && this.$element.css("top", "");
                var i = "affix" + (h ? "-" + h : ""),
                    j = a.Event(i + ".bs.affix");
                if (this.$element.trigger(j), j.isDefaultPrevented()) return;
                this.affixed = h, this.unpin = "bottom" == h ? this.getPinnedOffset() : null, this.$element.removeClass(c.RESET).addClass(i).trigger(i.replace("affix", "affixed") + ".bs.affix")
            }
            "bottom" == h && this.$element.offset({
                top: g - b - f
            })
        }
    };
    var d = a.fn.affix;
    a.fn.affix = b, a.fn.affix.Constructor = c, a.fn.affix.noConflict = function() {
        return a.fn.affix = d, this
    }, a(window).on("load", function() {
        a('[data-spy="affix"]').each(function() {
            var c = a(this),
                d = c.data();
            d.offset = d.offset || {}, null != d.offsetBottom && (d.offset.bottom = d.offsetBottom), null != d.offsetTop && (d.offset.top = d.offsetTop), b.call(c, d)
        })
    })
}(jQuery), "function" != typeof Object.create && (Object.create = function(a) {
        function b() {}
        return b.prototype = a, new b
    }),
    function(a, b, c, d) {
        var e = {
            init: function(b, c) {
                var d = this;
                d.elem = c, d.$elem = a(c), d.imageSrc = d.$elem.data("zoom-image") ? d.$elem.data("zoom-image") : d.$elem.attr("src"), d.options = a.extend({}, a.fn.elevateZoom.options, b), d.options.tint && (d.options.lensColour = "none", d.options.lensOpacity = "1"), "inner" == d.options.zoomType && (d.options.showLens = !1), d.$elem.parent().removeAttr("title").removeAttr("alt"), d.zoomImage = d.imageSrc, d.refresh(1), a("#" + d.options.gallery + " a").click(function(b) {
                    return d.options.galleryActiveClass && (a("#" + d.options.gallery + " a").removeClass(d.options.galleryActiveClass), a(this).addClass(d.options.galleryActiveClass)), b.preventDefault(), a(this).data("zoom-image") ? d.zoomImagePre = a(this).data("zoom-image") : d.zoomImagePre = a(this).data("image"), d.swaptheimage(a(this).data("image"), d.zoomImagePre), !1
                })
            },
            refresh: function(a) {
                var b = this;
                setTimeout(function() {
                    b.fetch(b.imageSrc)
                }, a || b.options.refresh)
            },
            fetch: function(a) {
                var b = this,
                    c = new Image;
                c.onload = function() {
                    b.largeWidth = c.width, b.largeHeight = c.height, b.startZoom(), b.currentImage = b.imageSrc, b.options.onZoomedImageLoaded(b.$elem)
                }, c.src = a
            },
            startZoom: function() {
                var b = this;
                if (b.nzWidth = b.$elem.width(), b.nzHeight = b.$elem.height(), b.isWindowActive = !1, b.isLensActive = !1, b.isTintActive = !1, b.overWindow = !1, b.options.imageCrossfade && (b.zoomWrap = b.$elem.wrap('<div style="height:' + b.nzHeight + "px;width:" + b.nzWidth + 'px;" class="zoomWrapper" />'), b.$elem.css("position", "absolute")), b.zoomLock = 1, b.scrollingLock = !1, b.changeBgSize = !1, b.currentZoomLevel = b.options.zoomLevel, b.nzOffset = b.$elem.offset(), b.widthRatio = b.largeWidth / b.currentZoomLevel / b.nzWidth, b.heightRatio = b.largeHeight / b.currentZoomLevel / b.nzHeight, "window" == b.options.zoomType && (b.zoomWindowStyle = "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " + String(b.options.zoomWindowBgColour) + ";width: " + String(b.options.zoomWindowWidth) + "px;height: " + String(b.options.zoomWindowHeight) + "px;float: left;background-size: " + b.largeWidth / b.currentZoomLevel + "px " + b.largeHeight / b.currentZoomLevel + "px;display: none;z-index:100;border: " + String(b.options.borderSize) + "px solid " + b.options.borderColour + ";background-repeat: no-repeat;position: absolute;"), "inner" == b.options.zoomType) {
                    var c = b.$elem.css("border-left-width");
                    b.zoomWindowStyle = "overflow: hidden;margin-left: " + String(c) + ";margin-top: " + String(c) + ";background-position: 0px 0px;width: " + String(b.nzWidth) + "px;height: " + String(b.nzHeight) + "px;float: left;display: none;cursor:" + b.options.cursor + ";px solid " + b.options.borderColour + ";background-repeat: no-repeat;position: absolute;"
                }
                "window" == b.options.zoomType && (lensHeight = b.nzHeight < b.options.zoomWindowWidth / b.widthRatio ? b.nzHeight : String(b.options.zoomWindowHeight / b.heightRatio), lensWidth = b.largeWidth < b.options.zoomWindowWidth ? b.nzWidth : b.options.zoomWindowWidth / b.widthRatio, b.lensStyle = "background-position: 0px 0px;width: " + String(b.options.zoomWindowWidth / b.widthRatio) + "px;height: " + String(b.options.zoomWindowHeight / b.heightRatio) + "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" + b.options.lensOpacity + ";filter: alpha(opacity = " + 100 * b.options.lensOpacity + "); zoom:1;width:" + lensWidth + "px;height:" + lensHeight + "px;background-color:" + b.options.lensColour + ";cursor:" + b.options.cursor + ";border: " + b.options.lensBorderSize + "px solid " + b.options.lensBorderColour + ";background-repeat: no-repeat;position: absolute;"), b.tintStyle = "display: block;position: absolute;background-color: " + b.options.tintColour + ";filter:alpha(opacity=0);opacity: 0;width: " + b.nzWidth + "px;height: " + b.nzHeight + "px;", b.lensRound = "", "lens" == b.options.zoomType && (b.lensStyle = "background-position: 0px 0px;float: left;display: none;border: " + String(b.options.borderSize) + "px solid " + b.options.borderColour + ";width:" + String(b.options.lensSize) + "px;height:" + String(b.options.lensSize) + "px;background-repeat: no-repeat;position: absolute;"), "round" == b.options.lensShape && (b.lensRound = "border-top-left-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;border-top-right-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;border-bottom-left-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;border-bottom-right-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;"), b.zoomContainer = a('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' + b.nzOffset.left + "px;top:" + b.nzOffset.top + "px;height:" + b.nzHeight + "px;width:" + b.nzWidth + 'px;"></div>'), a("body").append(b.zoomContainer), b.options.containLensZoom && "lens" == b.options.zoomType && b.zoomContainer.css("overflow", "hidden"), "inner" != b.options.zoomType && (b.zoomLens = a("<div class='zoomLens' style='" + b.lensStyle + b.lensRound + "'>&nbsp;</div>").appendTo(b.zoomContainer).click(function() {
                    b.$elem.trigger("click")
                }), b.options.tint && (b.tintContainer = a("<div/>").addClass("tintContainer"), b.zoomTint = a("<div class='zoomTint' style='" + b.tintStyle + "'></div>"), b.zoomLens.wrap(b.tintContainer), b.zoomTintcss = b.zoomLens.after(b.zoomTint), b.zoomTintImage = a('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' + b.nzWidth + "px; height: " + b.nzHeight + 'px;" src="' + b.imageSrc + '">').appendTo(b.zoomLens).click(function() {
                    b.$elem.trigger("click")
                }))), isNaN(b.options.zoomWindowPosition) ? b.zoomWindow = a("<div style='z-index:999;left:" + b.windowOffsetLeft + "px;top:" + b.windowOffsetTop + "px;" + b.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function() {
                    b.$elem.trigger("click")
                }) : b.zoomWindow = a("<div style='z-index:999;left:" + b.windowOffsetLeft + "px;top:" + b.windowOffsetTop + "px;" + b.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo(b.zoomContainer).click(function() {
                    b.$elem.trigger("click")
                }), b.zoomWindowContainer = a("<div/>").addClass("zoomWindowContainer").css("width", b.options.zoomWindowWidth), b.zoomWindow.wrap(b.zoomWindowContainer), "lens" == b.options.zoomType && b.zoomLens.css({
                    backgroundImage: "url('" + b.imageSrc + "')"
                }), "window" == b.options.zoomType && b.zoomWindow.css({
                    backgroundImage: "url('" + b.imageSrc + "')"
                }), "inner" == b.options.zoomType && b.zoomWindow.css({
                    backgroundImage: "url('" + b.imageSrc + "')"
                }), b.$elem.bind("touchmove", function(a) {
                    a.preventDefault(), b.setPosition(a.originalEvent.touches[0] || a.originalEvent.changedTouches[0])
                }), b.zoomContainer.bind("touchmove", function(a) {
                    "inner" == b.options.zoomType && b.showHideWindow("show"), a.preventDefault(), b.setPosition(a.originalEvent.touches[0] || a.originalEvent.changedTouches[0])
                }), b.zoomContainer.bind("touchend", function(a) {
                    b.showHideWindow("hide"), b.options.showLens && b.showHideLens("hide"), b.options.tint && "inner" != b.options.zoomType && b.showHideTint("hide")
                }), b.$elem.bind("touchend", function(a) {
                    b.showHideWindow("hide"), b.options.showLens && b.showHideLens("hide"), b.options.tint && "inner" != b.options.zoomType && b.showHideTint("hide")
                }), b.options.showLens && (b.zoomLens.bind("touchmove", function(a) {
                    a.preventDefault(), b.setPosition(a.originalEvent.touches[0] || a.originalEvent.changedTouches[0])
                }), b.zoomLens.bind("touchend", function(a) {
                    b.showHideWindow("hide"), b.options.showLens && b.showHideLens("hide"), b.options.tint && "inner" != b.options.zoomType && b.showHideTint("hide")
                })), b.$elem.bind("mousemove", function(a) {
                    0 == b.overWindow && b.setElements("show"), (b.lastX !== a.clientX || b.lastY !== a.clientY) && (b.setPosition(a), b.currentLoc = a), b.lastX = a.clientX, b.lastY = a.clientY
                }), b.zoomContainer.bind("mousemove", function(a) {
                    0 == b.overWindow && b.setElements("show"), (b.lastX !== a.clientX || b.lastY !== a.clientY) && (b.setPosition(a), b.currentLoc = a), b.lastX = a.clientX, b.lastY = a.clientY
                }), "inner" != b.options.zoomType && b.zoomLens.bind("mousemove", function(a) {
                    (b.lastX !== a.clientX || b.lastY !== a.clientY) && (b.setPosition(a), b.currentLoc = a), b.lastX = a.clientX, b.lastY = a.clientY
                }), b.options.tint && "inner" != b.options.zoomType && b.zoomTint.bind("mousemove", function(a) {
                    (b.lastX !== a.clientX || b.lastY !== a.clientY) && (b.setPosition(a), b.currentLoc = a), b.lastX = a.clientX, b.lastY = a.clientY
                }), "inner" == b.options.zoomType && b.zoomWindow.bind("mousemove", function(a) {
                    (b.lastX !== a.clientX || b.lastY !== a.clientY) && (b.setPosition(a), b.currentLoc = a), b.lastX = a.clientX, b.lastY = a.clientY
                }), b.zoomContainer.add(b.$elem).mouseenter(function() {
                    0 == b.overWindow && b.setElements("show")
                }).mouseleave(function() {
                    b.scrollLock || b.setElements("hide")
                }), "inner" != b.options.zoomType && b.zoomWindow.mouseenter(function() {
                    b.overWindow = !0, b.setElements("hide")
                }).mouseleave(function() {
                    b.overWindow = !1
                }), b.minZoomLevel = b.options.minZoomLevel ? b.options.minZoomLevel : 2 * b.options.scrollZoomIncrement, b.options.scrollZoom && b.zoomContainer.add(b.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll", function(c) {
                    b.scrollLock = !0, clearTimeout(a.data(this, "timer")), a.data(this, "timer", setTimeout(function() {
                        b.scrollLock = !1
                    }, 250));
                    var d = c.originalEvent.wheelDelta || -1 * c.originalEvent.detail;
                    return c.stopImmediatePropagation(), c.stopPropagation(), c.preventDefault(), d / 120 > 0 ? b.currentZoomLevel >= b.minZoomLevel && b.changeZoomLevel(b.currentZoomLevel - b.options.scrollZoomIncrement) : b.options.maxZoomLevel ? b.currentZoomLevel <= b.options.maxZoomLevel && b.changeZoomLevel(parseFloat(b.currentZoomLevel) + b.options.scrollZoomIncrement) : b.changeZoomLevel(parseFloat(b.currentZoomLevel) + b.options.scrollZoomIncrement), !1
                })
            },
            setElements: function(a) {
                return this.options.zoomEnabled ? ("show" == a && this.isWindowSet && ("inner" == this.options.zoomType && this.showHideWindow("show"), "window" == this.options.zoomType && this.showHideWindow("show"), this.options.showLens && this.showHideLens("show"), this.options.tint && "inner" != this.options.zoomType && this.showHideTint("show")), void("hide" == a && ("window" == this.options.zoomType && this.showHideWindow("hide"), this.options.tint || this.showHideWindow("hide"), this.options.showLens && this.showHideLens("hide"), this.options.tint && this.showHideTint("hide")))) : !1
            },
            setPosition: function(a) {
                return this.options.zoomEnabled ? (this.nzHeight = this.$elem.height(), this.nzWidth = this.$elem.width(), this.nzOffset = this.$elem.offset(), this.options.tint && "inner" != this.options.zoomType && (this.zoomTint.css({
                    top: 0
                }), this.zoomTint.css({
                    left: 0
                })), this.options.responsive && !this.options.scrollZoom && this.options.showLens && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.largeWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.widthRatio = this.largeWidth / this.nzWidth, this.heightRatio = this.largeHeight / this.nzHeight, "lens" != this.options.zoomType && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.options.zoomWindowWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight), this.options.tint && (this.zoomTintImage.css("width", this.nzWidth), this.zoomTintImage.css("height", this.nzHeight))), "lens" == this.options.zoomType && this.zoomLens.css({
                    width: String(this.options.lensSize) + "px",
                    height: String(this.options.lensSize) + "px"
                })), this.zoomContainer.css({
                    top: this.nzOffset.top
                }), this.zoomContainer.css({
                    left: this.nzOffset.left
                }), this.mouseLeft = parseInt(a.pageX - this.nzOffset.left), this.mouseTop = parseInt(a.pageY - this.nzOffset.top), "window" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.zoomLens.height() / 2, this.Eboppos = this.mouseTop > this.nzHeight - this.zoomLens.height() / 2 - 2 * this.options.lensBorderSize, this.Eloppos = this.mouseLeft < 0 + this.zoomLens.width() / 2, this.Eroppos = this.mouseLeft > this.nzWidth - this.zoomLens.width() / 2 - 2 * this.options.lensBorderSize), "inner" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.nzHeight / 2 / this.heightRatio, this.Eboppos = this.mouseTop > this.nzHeight - this.nzHeight / 2 / this.heightRatio, this.Eloppos = this.mouseLeft < 0 + this.nzWidth / 2 / this.widthRatio, this.Eroppos = this.mouseLeft > this.nzWidth - this.nzWidth / 2 / this.widthRatio - 2 * this.options.lensBorderSize), void(0 >= this.mouseLeft || 0 > this.mouseTop || this.mouseLeft > this.nzWidth || this.mouseTop > this.nzHeight ? this.setElements("hide") : (this.options.showLens && (this.lensLeftPos = String(this.mouseLeft - this.zoomLens.width() / 2), this.lensTopPos = String(this.mouseTop - this.zoomLens.height() / 2)), this.Etoppos && (this.lensTopPos = 0), this.Eloppos && (this.tintpos = this.lensLeftPos = this.windowLeftPos = 0), "window" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)), "inner" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.nzWidth - 2 * this.options.lensBorderSize)), "lens" == this.options.zoomType && (this.windowLeftPos = String(-1 * ((a.pageX - this.nzOffset.left) * this.widthRatio - this.zoomLens.width() / 2)), this.windowTopPos = String(-1 * ((a.pageY - this.nzOffset.top) * this.heightRatio - this.zoomLens.height() / 2)), this.zoomLens.css({
                    backgroundPosition: this.windowLeftPos + "px " + this.windowTopPos + "px"
                }), this.changeBgSize && (this.nzHeight > this.nzWidth ? ("lens" == this.options.zoomType && this.zoomLens.css({
                    "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"
                }), this.zoomWindow.css({
                    "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"
                })) : ("lens" == this.options.zoomType && this.zoomLens.css({
                    "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"
                }), this.zoomWindow.css({
                    "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"
                })), this.changeBgSize = !1), this.setWindowPostition(a)), this.options.tint && "inner" != this.options.zoomType && this.setTintPosition(a), "window" == this.options.zoomType && this.setWindowPostition(a), "inner" == this.options.zoomType && this.setWindowPostition(a), this.options.showLens && (this.fullwidth && "lens" != this.options.zoomType && (this.lensLeftPos = 0), this.zoomLens.css({
                    left: this.lensLeftPos + "px",
                    top: this.lensTopPos + "px"
                }))))) : !1
            },
            showHideWindow: function(a) {
                "show" != a || this.isWindowActive || (this.options.zoomWindowFadeIn ? this.zoomWindow.stop(!0, !0, !1).fadeIn(this.options.zoomWindowFadeIn) : this.zoomWindow.show(), this.isWindowActive = !0), "hide" == a && this.isWindowActive && (this.options.zoomWindowFadeOut ? this.zoomWindow.stop(!0, !0).fadeOut(this.options.zoomWindowFadeOut) : this.zoomWindow.hide(), this.isWindowActive = !1)
            },
            showHideLens: function(a) {
                "show" != a || this.isLensActive || (this.options.lensFadeIn ? this.zoomLens.stop(!0, !0, !1).fadeIn(this.options.lensFadeIn) : this.zoomLens.show(), this.isLensActive = !0), "hide" == a && this.isLensActive && (this.options.lensFadeOut ? this.zoomLens.stop(!0, !0).fadeOut(this.options.lensFadeOut) : this.zoomLens.hide(), this.isLensActive = !1)
            },
            showHideTint: function(a) {
                "show" != a || this.isTintActive || (this.options.zoomTintFadeIn ? this.zoomTint.css({
                    opacity: this.options.tintOpacity
                }).animate().stop(!0, !0).fadeIn("slow") : (this.zoomTint.css({
                    opacity: this.options.tintOpacity
                }).animate(), this.zoomTint.show()), this.isTintActive = !0), "hide" == a && this.isTintActive && (this.options.zoomTintFadeOut ? this.zoomTint.stop(!0, !0).fadeOut(this.options.zoomTintFadeOut) : this.zoomTint.hide(), this.isTintActive = !1)
            },
            setLensPostition: function(a) {},
            setWindowPostition: function(b) {
                var c = this;
                if (isNaN(c.options.zoomWindowPosition)) c.externalContainer = a("#" + c.options.zoomWindowPosition), c.externalContainerWidth = c.externalContainer.width(), c.externalContainerHeight = c.externalContainer.height(), c.externalContainerOffset = c.externalContainer.offset(), c.windowOffsetTop = c.externalContainerOffset.top, c.windowOffsetLeft = c.externalContainerOffset.left;
                else switch (c.options.zoomWindowPosition) {
                    case 1:
                        c.windowOffsetTop = c.options.zoomWindowOffety, c.windowOffsetLeft = +c.nzWidth;
                        break;
                    case 2:
                        c.options.zoomWindowHeight > c.nzHeight && (c.windowOffsetTop = -1 * (c.options.zoomWindowHeight / 2 - c.nzHeight / 2), c.windowOffsetLeft = c.nzWidth);
                        break;
                    case 3:
                        c.windowOffsetTop = c.nzHeight - c.zoomWindow.height() - 2 * c.options.borderSize, c.windowOffsetLeft = c.nzWidth;
                        break;
                    case 4:
                        c.windowOffsetTop = c.nzHeight, c.windowOffsetLeft = c.nzWidth;
                        break;
                    case 5:
                        c.windowOffsetTop = c.nzHeight, c.windowOffsetLeft = c.nzWidth - c.zoomWindow.width() - 2 * c.options.borderSize;
                        break;
                    case 6:
                        c.options.zoomWindowHeight > c.nzHeight && (c.windowOffsetTop = c.nzHeight, c.windowOffsetLeft = -1 * (c.options.zoomWindowWidth / 2 - c.nzWidth / 2 + 2 * c.options.borderSize));
                        break;
                    case 7:
                        c.windowOffsetTop = c.nzHeight, c.windowOffsetLeft = 0;
                        break;
                    case 8:
                        c.windowOffsetTop = c.nzHeight, c.windowOffsetLeft = -1 * (c.zoomWindow.width() + 2 * c.options.borderSize);
                        break;
                    case 9:
                        c.windowOffsetTop = c.nzHeight - c.zoomWindow.height() - 2 * c.options.borderSize, c.windowOffsetLeft = -1 * (c.zoomWindow.width() + 2 * c.options.borderSize);
                        break;
                    case 10:
                        c.options.zoomWindowHeight > c.nzHeight && (c.windowOffsetTop = -1 * (c.options.zoomWindowHeight / 2 - c.nzHeight / 2), c.windowOffsetLeft = -1 * (c.zoomWindow.width() + 2 * c.options.borderSize));
                        break;
                    case 11:
                        c.windowOffsetTop = c.options.zoomWindowOffety, c.windowOffsetLeft = -1 * (c.zoomWindow.width() + 2 * c.options.borderSize);
                        break;
                    case 12:
                        c.windowOffsetTop = -1 * (c.zoomWindow.height() + 2 * c.options.borderSize), c.windowOffsetLeft = -1 * (c.zoomWindow.width() + 2 * c.options.borderSize);
                        break;
                    case 13:
                        c.windowOffsetTop = -1 * (c.zoomWindow.height() + 2 * c.options.borderSize), c.windowOffsetLeft = 0;
                        break;
                    case 14:
                        c.options.zoomWindowHeight > c.nzHeight && (c.windowOffsetTop = -1 * (c.zoomWindow.height() + 2 * c.options.borderSize), c.windowOffsetLeft = -1 * (c.options.zoomWindowWidth / 2 - c.nzWidth / 2 + 2 * c.options.borderSize));
                        break;
                    case 15:
                        c.windowOffsetTop = -1 * (c.zoomWindow.height() + 2 * c.options.borderSize), c.windowOffsetLeft = c.nzWidth - c.zoomWindow.width() - 2 * c.options.borderSize;
                        break;
                    case 16:
                        c.windowOffsetTop = -1 * (c.zoomWindow.height() + 2 * c.options.borderSize), c.windowOffsetLeft = c.nzWidth;
                        break;
                    default:
                        c.windowOffsetTop = c.options.zoomWindowOffety, c.windowOffsetLeft = c.nzWidth
                }
                c.isWindowSet = !0, c.windowOffsetTop += c.options.zoomWindowOffety, c.windowOffsetLeft += c.options.zoomWindowOffetx, c.zoomWindow.css({
                    top: c.windowOffsetTop
                }), c.zoomWindow.css({
                    left: c.windowOffsetLeft
                }), "inner" == c.options.zoomType && (c.zoomWindow.css({
                    top: 0
                }), c.zoomWindow.css({
                    left: 0
                })), c.windowLeftPos = String(-1 * ((b.pageX - c.nzOffset.left) * c.widthRatio - c.zoomWindow.width() / 2)), c.windowTopPos = String(-1 * ((b.pageY - c.nzOffset.top) * c.heightRatio - c.zoomWindow.height() / 2)), c.Etoppos && (c.windowTopPos = 0), c.Eloppos && (c.windowLeftPos = 0), c.Eboppos && (c.windowTopPos = -1 * (c.largeHeight / c.currentZoomLevel - c.zoomWindow.height())), c.Eroppos && (c.windowLeftPos = -1 * (c.largeWidth / c.currentZoomLevel - c.zoomWindow.width())), c.fullheight && (c.windowTopPos = 0), c.fullwidth && (c.windowLeftPos = 0), ("window" == c.options.zoomType || "inner" == c.options.zoomType) && (1 == c.zoomLock && (1 >= c.widthRatio && (c.windowLeftPos = 0), 1 >= c.heightRatio && (c.windowTopPos = 0)), c.largeHeight < c.options.zoomWindowHeight && (c.windowTopPos = 0), c.largeWidth < c.options.zoomWindowWidth && (c.windowLeftPos = 0), c.options.easing ? (c.xp || (c.xp = 0), c.yp || (c.yp = 0), c.loop || (c.loop = setInterval(function() {
                    c.xp += (c.windowLeftPos - c.xp) / c.options.easingAmount, c.yp += (c.windowTopPos - c.yp) / c.options.easingAmount, c.scrollingLock ? (clearInterval(c.loop), c.xp = c.windowLeftPos, c.yp = c.windowTopPos, c.xp = -1 * ((b.pageX - c.nzOffset.left) * c.widthRatio - c.zoomWindow.width() / 2), c.yp = -1 * ((b.pageY - c.nzOffset.top) * c.heightRatio - c.zoomWindow.height() / 2), c.changeBgSize && (c.nzHeight > c.nzWidth ? ("lens" == c.options.zoomType && c.zoomLens.css({
                        "background-size": c.largeWidth / c.newvalueheight + "px " + c.largeHeight / c.newvalueheight + "px"
                    }), c.zoomWindow.css({
                        "background-size": c.largeWidth / c.newvalueheight + "px " + c.largeHeight / c.newvalueheight + "px"
                    })) : ("lens" != c.options.zoomType && c.zoomLens.css({
                        "background-size": c.largeWidth / c.newvaluewidth + "px " + c.largeHeight / c.newvalueheight + "px"
                    }), c.zoomWindow.css({
                        "background-size": c.largeWidth / c.newvaluewidth + "px " + c.largeHeight / c.newvaluewidth + "px"
                    })), c.changeBgSize = !1), c.zoomWindow.css({
                        backgroundPosition: c.windowLeftPos + "px " + c.windowTopPos + "px"
                    }), c.scrollingLock = !1, c.loop = !1) : (c.changeBgSize && (c.nzHeight > c.nzWidth ? ("lens" == c.options.zoomType && c.zoomLens.css({
                        "background-size": c.largeWidth / c.newvalueheight + "px " + c.largeHeight / c.newvalueheight + "px"
                    }), c.zoomWindow.css({
                        "background-size": c.largeWidth / c.newvalueheight + "px " + c.largeHeight / c.newvalueheight + "px"
                    })) : ("lens" != c.options.zoomType && c.zoomLens.css({
                        "background-size": c.largeWidth / c.newvaluewidth + "px " + c.largeHeight / c.newvaluewidth + "px"
                    }), c.zoomWindow.css({
                        "background-size": c.largeWidth / c.newvaluewidth + "px " + c.largeHeight / c.newvaluewidth + "px"
                    })), c.changeBgSize = !1), c.zoomWindow.css({
                        backgroundPosition: c.xp + "px " + c.yp + "px"
                    }))
                }, 16))) : (c.changeBgSize && (c.nzHeight > c.nzWidth ? ("lens" == c.options.zoomType && c.zoomLens.css({
                    "background-size": c.largeWidth / c.newvalueheight + "px " + c.largeHeight / c.newvalueheight + "px"
                }), c.zoomWindow.css({
                    "background-size": c.largeWidth / c.newvalueheight + "px " + c.largeHeight / c.newvalueheight + "px"
                })) : ("lens" == c.options.zoomType && c.zoomLens.css({
                    "background-size": c.largeWidth / c.newvaluewidth + "px " + c.largeHeight / c.newvaluewidth + "px"
                }), c.largeHeight / c.newvaluewidth < c.options.zoomWindowHeight ? c.zoomWindow.css({
                    "background-size": c.largeWidth / c.newvaluewidth + "px " + c.largeHeight / c.newvaluewidth + "px"
                }) : c.zoomWindow.css({
                    "background-size": c.largeWidth / c.newvalueheight + "px " + c.largeHeight / c.newvalueheight + "px"
                })), c.changeBgSize = !1), c.zoomWindow.css({
                    backgroundPosition: c.windowLeftPos + "px " + c.windowTopPos + "px"
                })))
            },
            setTintPosition: function(a) {
                this.nzOffset = this.$elem.offset(), this.tintpos = String(-1 * (a.pageX - this.nzOffset.left - this.zoomLens.width() / 2)), this.tintposy = String(-1 * (a.pageY - this.nzOffset.top - this.zoomLens.height() / 2)), this.Etoppos && (this.tintposy = 0), this.Eloppos && (this.tintpos = 0), this.Eboppos && (this.tintposy = -1 * (this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize)), this.Eroppos && (this.tintpos = -1 * (this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)), this.options.tint && (this.fullheight && (this.tintposy = 0), this.fullwidth && (this.tintpos = 0), this.zoomTintImage.css({
                    left: this.tintpos + "px"
                }), this.zoomTintImage.css({
                    top: this.tintposy + "px"
                }))
            },
            swaptheimage: function(b, c) {
                var d = this,
                    e = new Image;
                d.options.loadingIcon && (d.spinner = a("<div style=\"background: url('" + d.options.loadingIcon + "') no-repeat center;height:" + d.nzHeight + "px;width:" + d.nzWidth + 'px;z-index: 2000;position: absolute; background-position: center center;"></div>'), d.$elem.after(d.spinner)), d.options.onImageSwap(d.$elem), e.onload = function() {
                    d.largeWidth = e.width, d.largeHeight = e.height, d.zoomImage = c, d.zoomWindow.css({
                        "background-size": d.largeWidth + "px " + d.largeHeight + "px"
                    }), d.zoomWindow.css({
                        "background-size": d.largeWidth + "px " + d.largeHeight + "px"
                    }), d.swapAction(b, c)
                }, e.src = c
            },
            swapAction: function(b, c) {
                var d = this,
                    e = new Image;
                if (e.onload = function() {
                        d.nzHeight = e.height, d.nzWidth = e.width, d.options.onImageSwapComplete(d.$elem), d.doneCallback()
                    }, e.src = b, d.currentZoomLevel = d.options.zoomLevel, d.options.maxZoomLevel = !1, "lens" == d.options.zoomType && d.zoomLens.css({
                        backgroundImage: "url('" + c + "')"
                    }), "window" == d.options.zoomType && d.zoomWindow.css({
                        backgroundImage: "url('" + c + "')"
                    }), "inner" == d.options.zoomType && d.zoomWindow.css({
                        backgroundImage: "url('" + c + "')"
                    }), d.currentImage = c, d.options.imageCrossfade) {
                    var f = d.$elem,
                        g = f.clone();
                    d.$elem.attr("src", b), d.$elem.after(g), g.stop(!0).fadeOut(d.options.imageCrossfade, function() {
                        a(this).remove()
                    }), d.$elem.width("auto").removeAttr("width"), d.$elem.height("auto").removeAttr("height"), f.fadeIn(d.options.imageCrossfade), d.options.tint && "inner" != d.options.zoomType && (f = d.zoomTintImage, g = f.clone(), d.zoomTintImage.attr("src", c), d.zoomTintImage.after(g), g.stop(!0).fadeOut(d.options.imageCrossfade, function() {
                        a(this).remove()
                    }), f.fadeIn(d.options.imageCrossfade), d.zoomTint.css({
                        height: d.$elem.height()
                    }), d.zoomTint.css({
                        width: d.$elem.width()
                    })), d.zoomContainer.css("height", d.$elem.height()), d.zoomContainer.css("width", d.$elem.width()), "inner" != d.options.zoomType || d.options.constrainType || (d.zoomWrap.parent().css("height", d.$elem.height()), d.zoomWrap.parent().css("width", d.$elem.width()), d.zoomWindow.css("height", d.$elem.height()), d.zoomWindow.css("width", d.$elem.width()))
                } else d.$elem.attr("src", b), d.options.tint && (d.zoomTintImage.attr("src", c), d.zoomTintImage.attr("height", d.$elem.height()), d.zoomTintImage.css({
                    height: d.$elem.height()
                }), d.zoomTint.css({
                    height: d.$elem.height()
                })), d.zoomContainer.css("height", d.$elem.height()), d.zoomContainer.css("width", d.$elem.width());
                d.options.imageCrossfade && (d.zoomWrap.css("height", d.$elem.height()), d.zoomWrap.css("width", d.$elem.width())), d.options.constrainType && ("height" == d.options.constrainType && (d.zoomContainer.css("height", d.options.constrainSize), d.zoomContainer.css("width", "auto"), d.options.imageCrossfade ? (d.zoomWrap.css("height", d.options.constrainSize), d.zoomWrap.css("width", "auto"), d.constwidth = d.zoomWrap.width()) : (d.$elem.css("height", d.options.constrainSize), d.$elem.css("width", "auto"), d.constwidth = d.$elem.width()), "inner" == d.options.zoomType && (d.zoomWrap.parent().css("height", d.options.constrainSize), d.zoomWrap.parent().css("width", d.constwidth), d.zoomWindow.css("height", d.options.constrainSize), d.zoomWindow.css("width", d.constwidth)), d.options.tint && (d.tintContainer.css("height", d.options.constrainSize), d.tintContainer.css("width", d.constwidth), d.zoomTint.css("height", d.options.constrainSize), d.zoomTint.css("width", d.constwidth), d.zoomTintImage.css("height", d.options.constrainSize), d.zoomTintImage.css("width", d.constwidth))), "width" == d.options.constrainType && (d.zoomContainer.css("height", "auto"), d.zoomContainer.css("width", d.options.constrainSize), d.options.imageCrossfade ? (d.zoomWrap.css("height", "auto"), d.zoomWrap.css("width", d.options.constrainSize), d.constheight = d.zoomWrap.height()) : (d.$elem.css("height", "auto"), d.$elem.css("width", d.options.constrainSize), d.constheight = d.$elem.height()), "inner" == d.options.zoomType && (d.zoomWrap.parent().css("height", d.constheight), d.zoomWrap.parent().css("width", d.options.constrainSize), d.zoomWindow.css("height", d.constheight), d.zoomWindow.css("width", d.options.constrainSize)), d.options.tint && (d.tintContainer.css("height", d.constheight), d.tintContainer.css("width", d.options.constrainSize), d.zoomTint.css("height", d.constheight), d.zoomTint.css("width", d.options.constrainSize), d.zoomTintImage.css("height", d.constheight), d.zoomTintImage.css("width", d.options.constrainSize))))
            },
            doneCallback: function() {
                this.options.loadingIcon && this.spinner.hide(), this.nzOffset = this.$elem.offset(), this.nzWidth = this.$elem.width(), this.nzHeight = this.$elem.height(), this.currentZoomLevel = this.options.zoomLevel, this.widthRatio = this.largeWidth / this.nzWidth, this.heightRatio = this.largeHeight / this.nzHeight, "window" == this.options.zoomType && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.options.zoomWindowWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.zoomLens && (this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight)))
            },
            getCurrentImage: function() {
                return this.zoomImage
            },
            getGalleryList: function() {
                var b = this;
                return b.gallerylist = [], b.options.gallery ? a("#" + b.options.gallery + " a").each(function() {
                    var c = "";
                    a(this).data("zoom-image") ? c = a(this).data("zoom-image") : a(this).data("image") && (c = a(this).data("image")), c == b.zoomImage ? b.gallerylist.unshift({
                        href: "" + c,
                        title: a(this).find("img").attr("title")
                    }) : b.gallerylist.push({
                        href: "" + c,
                        title: a(this).find("img").attr("title")
                    })
                }) : b.gallerylist.push({
                    href: "" + b.zoomImage,
                    title: a(this).find("img").attr("title")
                }), b.gallerylist
            },
            changeZoomLevel: function(a) {
                this.scrollingLock = !0, this.newvalue = parseFloat(a).toFixed(2), newvalue = parseFloat(a).toFixed(2), maxheightnewvalue = this.largeHeight / (this.options.zoomWindowHeight / this.nzHeight * this.nzHeight), maxwidthtnewvalue = this.largeWidth / (this.options.zoomWindowWidth / this.nzWidth * this.nzWidth), "inner" != this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / maxheightnewvalue / this.nzHeight, this.newvalueheight = maxheightnewvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / maxwidthtnewvalue / this.nzWidth, this.newvaluewidth = maxwidthtnewvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1), "lens" == this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.fullwidth = !0, this.newvaluewidth = maxheightnewvalue) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1))), "inner" == this.options.zoomType && (maxheightnewvalue = parseFloat(this.largeHeight / this.nzHeight).toFixed(2), maxwidthtnewvalue = parseFloat(this.largeWidth / this.nzWidth).toFixed(2), newvalue > maxheightnewvalue && (newvalue = maxheightnewvalue), newvalue > maxwidthtnewvalue && (newvalue = maxwidthtnewvalue), maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue > maxheightnewvalue ? maxheightnewvalue : newvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue > maxheightnewvalue ? maxheightnewvalue : newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue > maxwidthtnewvalue ? maxwidthtnewvalue : newvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1)), scrcontinue = !1, "inner" == this.options.zoomType && (this.nzWidth > this.nzHeight && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullwidth = this.fullheight = !0)), this.nzHeight > this.nzWidth && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullwidth = this.fullheight = !0))), "inner" != this.options.zoomType && (scrcontinue = !0), scrcontinue && (this.zoomLock = 0, this.changeZoom = !0, this.options.zoomWindowHeight / this.heightRatio <= this.nzHeight && (this.currentZoomLevel = this.newvalueheight, "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({
                    height: String(this.options.zoomWindowHeight / this.heightRatio) + "px"
                })), "lens" == this.options.zoomType || "inner" == this.options.zoomType) && (this.changeBgSize = !0), this.options.zoomWindowWidth / this.widthRatio <= this.nzWidth && ("inner" != this.options.zoomType && this.newvaluewidth > this.newvalueheight && (this.currentZoomLevel = this.newvaluewidth), "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({
                    width: String(this.options.zoomWindowWidth / this.widthRatio) + "px"
                })), "lens" == this.options.zoomType || "inner" == this.options.zoomType) && (this.changeBgSize = !0), "inner" == this.options.zoomType && (this.changeBgSize = !0, this.nzWidth > this.nzHeight && (this.currentZoomLevel = this.newvaluewidth), this.nzHeight > this.nzWidth && (this.currentZoomLevel = this.newvaluewidth))), this.setPosition(this.currentLoc)
            },
            closeAll: function() {
                self.zoomWindow && self.zoomWindow.hide(), self.zoomLens && self.zoomLens.hide(), self.zoomTint && self.zoomTint.hide()
            },
            changeState: function(a) {
                "enable" == a && (this.options.zoomEnabled = !0), "disable" == a && (this.options.zoomEnabled = !1)
            }
        };
        a.fn.elevateZoom = function(b) {
            return this.each(function() {
                var c = Object.create(e);
                c.init(b, this), a.data(this, "elevateZoom", c)
            })
        }, a.fn.elevateZoom.options = {
            zoomActivation: "hover",
            zoomEnabled: !0,
            preloading: 1,
            zoomLevel: 1,
            scrollZoom: !1,
            scrollZoomIncrement: .1,
            minZoomLevel: !1,
            maxZoomLevel: !1,
            easing: !1,
            easingAmount: 12,
            lensSize: 200,
            zoomWindowWidth: 400,
            zoomWindowHeight: 400,
            zoomWindowOffetx: 0,
            zoomWindowOffety: 0,
            zoomWindowPosition: 1,
            zoomWindowBgColour: "#fff",
            lensFadeIn: !1,
            lensFadeOut: !1,
            debug: !1,
            zoomWindowFadeIn: !1,
            zoomWindowFadeOut: !1,
            zoomWindowAlwaysShow: !1,
            zoomTintFadeIn: !1,
            zoomTintFadeOut: !1,
            borderSize: 4,
            showLens: !0,
            borderColour: "#888",
            lensBorderSize: 1,
            lensBorderColour: "#000",
            lensShape: "square",
            zoomType: "window",
            containLensZoom: !1,
            lensColour: "white",
            lensOpacity: .4,
            lenszoom: !1,
            tint: !1,
            tintColour: "#333",
            tintOpacity: .4,
            gallery: !1,
            galleryActiveClass: "zoomGalleryActive",
            imageCrossfade: !1,
            constrainType: !1,
            constrainSize: !1,
            loadingIcon: !1,
            cursor: "default",
            responsive: !0,
            onComplete: a.noop,
            onZoomedImageLoaded: function() {},
            onImageSwap: a.noop,
            onImageSwapComplete: a.noop
        }
    }(jQuery, window, document),
    function(a) {
        var b, c, d, e, f, g, h, i = "Close",
            j = "BeforeClose",
            k = "AfterClose",
            l = "BeforeAppend",
            m = "MarkupParse",
            n = "Open",
            o = "Change",
            p = "mfp",
            q = "." + p,
            r = "mfp-ready",
            s = "mfp-removing",
            t = "mfp-prevent-close",
            u = function() {},
            v = !!window.jQuery,
            w = a(window),
            x = function(a, c) {
                b.ev.on(p + a + q, c)
            },
            y = function(b, c, d, e) {
                var f = document.createElement("div");
                return f.className = "mfp-" + b, d && (f.innerHTML = d), e ? c && c.appendChild(f) : (f = a(f), c && f.appendTo(c)), f
            },
            z = function(c, d) {
                b.ev.triggerHandler(p + c, d), b.st.callbacks && (c = c.charAt(0).toLowerCase() + c.slice(1), b.st.callbacks[c] && b.st.callbacks[c].apply(b, a.isArray(d) ? d : [d]))
            },
            A = function(c) {
                return c === h && b.currTemplate.closeBtn || (b.currTemplate.closeBtn = a(b.st.closeMarkup.replace("%title%", b.st.tClose)), h = c), b.currTemplate.closeBtn
            },
            B = function() {
                a.magnificPopup.instance || (b = new u, b.init(), a.magnificPopup.instance = b)
            },
            C = function() {
                var a = document.createElement("p").style,
                    b = ["ms", "O", "Moz", "Webkit"];
                if (void 0 !== a.transition) return !0;
                for (; b.length;)
                    if (b.pop() + "Transition" in a) return !0;
                return !1
            };
        u.prototype = {
            constructor: u,
            init: function() {
                var c = navigator.appVersion;
                b.isIE7 = -1 !== c.indexOf("MSIE 7."), b.isIE8 = -1 !== c.indexOf("MSIE 8."), b.isLowIE = b.isIE7 || b.isIE8, b.isAndroid = /android/gi.test(c), b.isIOS = /iphone|ipad|ipod/gi.test(c), b.supportsTransition = C(), b.probablyMobile = b.isAndroid || b.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), e = a(document), b.popupsCache = {}
            },
            open: function(c) {
                d || (d = a(document.body));
                var f;
                if (c.isObj === !1) {
                    b.items = c.items.toArray(), b.index = 0;
                    var h, i = c.items;
                    for (f = 0; i.length > f; f++)
                        if (h = i[f], h.parsed && (h = h.el[0]), h === c.el[0]) {
                            b.index = f;
                            break
                        }
                } else b.items = a.isArray(c.items) ? c.items : [c.items], b.index = c.index || 0;
                if (b.isOpen) return void b.updateItemHTML();
                b.types = [], g = "", b.ev = c.mainEl && c.mainEl.length ? c.mainEl.eq(0) : e, c.key ? (b.popupsCache[c.key] || (b.popupsCache[c.key] = {}), b.currTemplate = b.popupsCache[c.key]) : b.currTemplate = {}, b.st = a.extend(!0, {}, a.magnificPopup.defaults, c), b.fixedContentPos = "auto" === b.st.fixedContentPos ? !b.probablyMobile : b.st.fixedContentPos, b.st.modal && (b.st.closeOnContentClick = !1, b.st.closeOnBgClick = !1, b.st.showCloseBtn = !1, b.st.enableEscapeKey = !1), b.bgOverlay || (b.bgOverlay = y("bg").on("click" + q, function() {
                    b.close()
                }), b.wrap = y("wrap").attr("tabindex", -1).on("click" + q, function(a) {
                    b._checkIfClose(a.target) && b.close()
                }), b.container = y("container", b.wrap)), b.contentContainer = y("content"), b.st.preloader && (b.preloader = y("preloader", b.container, b.st.tLoading));
                var j = a.magnificPopup.modules;
                for (f = 0; j.length > f; f++) {
                    var k = j[f];
                    k = k.charAt(0).toUpperCase() + k.slice(1), b["init" + k].call(b)
                }
                z("BeforeOpen"), b.st.showCloseBtn && (b.st.closeBtnInside ? (x(m, function(a, b, c, d) {
                    c.close_replaceWith = A(d.type)
                }), g += " mfp-close-btn-in") : b.wrap.append(A())), b.st.alignTop && (g += " mfp-align-top"), b.fixedContentPos ? b.wrap.css({
                    overflow: b.st.overflowY,
                    overflowX: "hidden",
                    overflowY: b.st.overflowY
                }) : b.wrap.css({
                    top: w.scrollTop(),
                    position: "absolute"
                }), (b.st.fixedBgPos === !1 || "auto" === b.st.fixedBgPos && !b.fixedContentPos) && b.bgOverlay.css({
                    height: e.height(),
                    position: "absolute"
                }), b.st.enableEscapeKey && e.on("keyup" + q, function(a) {
                    27 === a.keyCode && b.close()
                }), w.on("resize" + q, function() {
                    b.updateSize()
                }), b.st.closeOnContentClick || (g += " mfp-auto-cursor"), g && b.wrap.addClass(g);
                var l = b.wH = w.height(),
                    o = {};
                if (b.fixedContentPos && b._hasScrollBar(l)) {
                    var p = b._getScrollbarSize();
                    p && (o.marginRight = p)
                }
                b.fixedContentPos && (b.isIE7 ? a("body, html").css("overflow", "hidden") : o.overflow = "hidden");
                var s = b.st.mainClass;
                return b.isIE7 && (s += " mfp-ie7"), s && b._addClassToMFP(s), b.updateItemHTML(), z("BuildControls"), a("html").css(o), b.bgOverlay.add(b.wrap).prependTo(b.st.prependTo || d), b._lastFocusedEl = document.activeElement, setTimeout(function() {
                    b.content ? (b._addClassToMFP(r), b._setFocus()) : b.bgOverlay.addClass(r), e.on("focusin" + q, b._onFocusIn)
                }, 16), b.isOpen = !0, b.updateSize(l), z(n), c
            },
            close: function() {
                b.isOpen && (z(j), b.isOpen = !1, b.st.removalDelay && !b.isLowIE && b.supportsTransition ? (b._addClassToMFP(s), setTimeout(function() {
                    b._close()
                }, b.st.removalDelay)) : b._close())
            },
            _close: function() {
                z(i);
                var c = s + " " + r + " ";
                if (b.bgOverlay.detach(), b.wrap.detach(), b.container.empty(), b.st.mainClass && (c += b.st.mainClass + " "), b._removeClassFromMFP(c), b.fixedContentPos) {
                    var d = {
                        marginRight: ""
                    };
                    b.isIE7 ? a("body, html").css("overflow", "") : d.overflow = "", a("html").css(d)
                }
                e.off("keyup" + q + " focusin" + q), b.ev.off(q), b.wrap.attr("class", "mfp-wrap").removeAttr("style"), b.bgOverlay.attr("class", "mfp-bg"), b.container.attr("class", "mfp-container"), !b.st.showCloseBtn || b.st.closeBtnInside && b.currTemplate[b.currItem.type] !== !0 || b.currTemplate.closeBtn && b.currTemplate.closeBtn.detach(), b._lastFocusedEl && a(b._lastFocusedEl).focus(), b.currItem = null, b.content = null, b.currTemplate = null, b.prevHeight = 0, z(k)
            },
            updateSize: function(a) {
                if (b.isIOS) {
                    var c = document.documentElement.clientWidth / window.innerWidth,
                        d = window.innerHeight * c;
                    b.wrap.css("height", d), b.wH = d
                } else b.wH = a || w.height();
                b.fixedContentPos || b.wrap.css("height", b.wH), z("Resize")
            },
            updateItemHTML: function() {
                var c = b.items[b.index];
                b.contentContainer.detach(), b.content && b.content.detach(), c.parsed || (c = b.parseEl(b.index));
                var d = c.type;
                if (z("BeforeChange", [b.currItem ? b.currItem.type : "", d]), b.currItem = c, !b.currTemplate[d]) {
                    var e = b.st[d] ? b.st[d].markup : !1;
                    z("FirstMarkupParse", e), b.currTemplate[d] = e ? a(e) : !0
                }
                f && f !== c.type && b.container.removeClass("mfp-" + f + "-holder");
                var g = b["get" + d.charAt(0).toUpperCase() + d.slice(1)](c, b.currTemplate[d]);
                b.appendContent(g, d), c.preloaded = !0, z(o, c), f = c.type, b.container.prepend(b.contentContainer), z("AfterChange")
            },
            appendContent: function(a, c) {
                b.content = a, a ? b.st.showCloseBtn && b.st.closeBtnInside && b.currTemplate[c] === !0 ? b.content.find(".mfp-close").length || b.content.append(A()) : b.content = a : b.content = "", z(l), b.container.addClass("mfp-" + c + "-holder"), b.contentContainer.append(b.content)
            },
            parseEl: function(c) {
                var d = b.items[c],
                    e = d.type;
                if (d = d.tagName ? {
                        el: a(d)
                    } : {
                        data: d,
                        src: d.src
                    }, d.el) {
                    for (var f = b.types, g = 0; f.length > g; g++)
                        if (d.el.hasClass("mfp-" + f[g])) {
                            e = f[g];
                            break
                        }
                    d.src = d.el.attr("data-mfp-src"), d.src || (d.src = d.el.attr("href"))
                }
                return d.type = e || b.st.type || "inline", d.index = c, d.parsed = !0, b.items[c] = d, z("ElementParse", d), b.items[c]
            },
            addGroup: function(a, c) {
                var d = function(d) {
                    d.mfpEl = this, b._openClick(d, a, c)
                };
                c || (c = {});
                var e = "click.magnificPopup";
                c.mainEl = a, c.items ? (c.isObj = !0, a.off(e).on(e, d)) : (c.isObj = !1, c.delegate ? a.off(e).on(e, c.delegate, d) : (c.items = a, a.off(e).on(e, d)))
            },
            _openClick: function(c, d, e) {
                var f = void 0 !== e.midClick ? e.midClick : a.magnificPopup.defaults.midClick;
                if (f || 2 !== c.which && !c.ctrlKey && !c.metaKey) {
                    var g = void 0 !== e.disableOn ? e.disableOn : a.magnificPopup.defaults.disableOn;
                    if (g)
                        if (a.isFunction(g)) {
                            if (!g.call(b)) return !0
                        } else if (g > w.width()) return !0;
                    c.type && (c.preventDefault(), b.isOpen && c.stopPropagation()), e.el = a(c.mfpEl), e.delegate && (e.items = d.find(e.delegate)), b.open(e)
                }
            },
            updateStatus: function(a, d) {
                if (b.preloader) {
                    c !== a && b.container.removeClass("mfp-s-" + c), d || "loading" !== a || (d = b.st.tLoading);
                    var e = {
                        status: a,
                        text: d
                    };
                    z("UpdateStatus", e), a = e.status, d = e.text, b.preloader.html(d), b.preloader.find("a").on("click", function(a) {
                        a.stopImmediatePropagation()
                    }), b.container.addClass("mfp-s-" + a), c = a
                }
            },
            _checkIfClose: function(c) {
                if (!a(c).hasClass(t)) {
                    var d = b.st.closeOnContentClick,
                        e = b.st.closeOnBgClick;
                    if (d && e) return !0;
                    if (!b.content || a(c).hasClass("mfp-close") || b.preloader && c === b.preloader[0]) return !0;
                    if (c === b.content[0] || a.contains(b.content[0], c)) {
                        if (d) return !0
                    } else if (e && a.contains(document, c)) return !0;
                    return !1
                }
            },
            _addClassToMFP: function(a) {
                b.bgOverlay.addClass(a), b.wrap.addClass(a)
            },
            _removeClassFromMFP: function(a) {
                this.bgOverlay.removeClass(a), b.wrap.removeClass(a)
            },
            _hasScrollBar: function(a) {
                return (b.isIE7 ? e.height() : document.body.scrollHeight) > (a || w.height())
            },
            _setFocus: function() {
                (b.st.focus ? b.content.find(b.st.focus).eq(0) : b.wrap).focus()
            },
            _onFocusIn: function(c) {
                return c.target === b.wrap[0] || a.contains(b.wrap[0], c.target) ? void 0 : (b._setFocus(), !1)
            },
            _parseMarkup: function(b, c, d) {
                var e;
                d.data && (c = a.extend(d.data, c)), z(m, [b, c, d]), a.each(c, function(a, c) {
                    if (void 0 === c || c === !1) return !0;
                    if (e = a.split("_"), e.length > 1) {
                        var d = b.find(q + "-" + e[0]);
                        if (d.length > 0) {
                            var f = e[1];
                            "replaceWith" === f ? d[0] !== c[0] && d.replaceWith(c) : "img" === f ? d.is("img") ? d.attr("src", c) : d.replaceWith('<img src="' + c + '" class="' + d.attr("class") + '" />') : d.attr(e[1], c)
                        }
                    } else b.find(q + "-" + a).html(c)
                })
            },
            _getScrollbarSize: function() {
                if (void 0 === b.scrollbarSize) {
                    var a = document.createElement("div");
                    a.id = "mfp-sbm", a.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(a), b.scrollbarSize = a.offsetWidth - a.clientWidth, document.body.removeChild(a)
                }
                return b.scrollbarSize
            }
        }, a.magnificPopup = {
            instance: null,
            proto: u.prototype,
            modules: [],
            open: function(b, c) {
                return B(), b = b ? a.extend(!0, {}, b) : {}, b.isObj = !0, b.index = c || 0, this.instance.open(b)
            },
            close: function() {
                return a.magnificPopup.instance && a.magnificPopup.instance.close()
            },
            registerModule: function(b, c) {
                c.options && (a.magnificPopup.defaults[b] = c.options), a.extend(this.proto, c.proto), this.modules.push(b)
            },
            defaults: {
                disableOn: 0,
                key: null,
                midClick: !1,
                mainClass: "",
                preloader: !0,
                focus: "",
                closeOnContentClick: !1,
                closeOnBgClick: !0,
                closeBtnInside: !0,
                showCloseBtn: !0,
                enableEscapeKey: !0,
                modal: !1,
                alignTop: !1,
                removalDelay: 0,
                prependTo: null,
                fixedContentPos: "auto",
                fixedBgPos: "auto",
                overflowY: "auto",
                closeMarkup: '<button title="%title%" type="button" class="mfp-close">&times;</button>',
                tClose: "Close (Esc)",
                tLoading: "Loading..."
            }
        }, a.fn.magnificPopup = function(c) {
            B();
            var d = a(this);
            if ("string" == typeof c)
                if ("open" === c) {
                    var e, f = v ? d.data("magnificPopup") : d[0].magnificPopup,
                        g = parseInt(arguments[1], 10) || 0;
                    f.items ? e = f.items[g] : (e = d, f.delegate && (e = e.find(f.delegate)), e = e.eq(g)), b._openClick({
                        mfpEl: e
                    }, d, f)
                } else b.isOpen && b[c].apply(b, Array.prototype.slice.call(arguments, 1));
            else c = a.extend(!0, {}, c), v ? d.data("magnificPopup", c) : d[0].magnificPopup = c, b.addGroup(d, c);
            return d
        };
        var D, E, F, G = "inline",
            H = function() {
                F && (E.after(F.addClass(D)).detach(), F = null)
            };
        a.magnificPopup.registerModule(G, {
            options: {
                hiddenClass: "hide",
                markup: "",
                tNotFound: "Content not found"
            },
            proto: {
                initInline: function() {
                    b.types.push(G), x(i + "." + G, function() {
                        H()
                    })
                },
                getInline: function(c, d) {
                    if (H(), c.src) {
                        var e = b.st.inline,
                            f = a(c.src);
                        if (f.length) {
                            var g = f[0].parentNode;
                            g && g.tagName && (E || (D = e.hiddenClass, E = y(D), D = "mfp-" + D), F = f.after(E).detach().removeClass(D)), b.updateStatus("ready")
                        } else b.updateStatus("error", e.tNotFound), f = a("<div>");
                        return c.inlineElement = f, f
                    }
                    return b.updateStatus("ready"), b._parseMarkup(d, {}, c), d
                }
            }
        });
        var I, J = "ajax",
            K = function() {
                I && d.removeClass(I)
            },
            L = function() {
                K(), b.req && b.req.abort()
            };
        a.magnificPopup.registerModule(J, {
            options: {
                settings: null,
                cursor: "mfp-ajax-cur",
                tError: '<a href="%url%">The content</a> could not be loaded.'
            },
            proto: {
                initAjax: function() {
                    b.types.push(J), I = b.st.ajax.cursor, x(i + "." + J, L), x("BeforeChange." + J, L)
                },
                getAjax: function(c) {
                    I && d.addClass(I), b.updateStatus("loading");
                    var e = a.extend({
                        url: c.src,
                        success: function(d, e, f) {
                            var g = {
                                data: d,
                                xhr: f
                            };
                            z("ParseAjax", g), b.appendContent(a(g.data), J), c.finished = !0, K(), b._setFocus(), setTimeout(function() {
                                b.wrap.addClass(r)
                            }, 16), b.updateStatus("ready"), z("AjaxContentAdded")
                        },
                        error: function() {
                            K(), c.finished = c.loadError = !0, b.updateStatus("error", b.st.ajax.tError.replace("%url%", c.src))
                        }
                    }, b.st.ajax.settings);
                    return b.req = a.ajax(e), ""
                }
            }
        });
        var M, N = function(c) {
            if (c.data && void 0 !== c.data.title) return c.data.title;
            var d = b.st.image.titleSrc;
            if (d) {
                if (a.isFunction(d)) return d.call(b, c);
                if (c.el) return c.el.attr(d) || ""
            }
            return ""
        };
        a.magnificPopup.registerModule("image", {
            options: {
                markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
                cursor: "mfp-zoom-out-cur",
                titleSrc: "title",
                verticalFit: !0,
                tError: '<a href="%url%">The image</a> could not be loaded.'
            },
            proto: {
                initImage: function() {
                    var a = b.st.image,
                        c = ".image";
                    b.types.push("image"), x(n + c, function() {
                        "image" === b.currItem.type && a.cursor && d.addClass(a.cursor)
                    }), x(i + c, function() {
                        a.cursor && d.removeClass(a.cursor), w.off("resize" + q)
                    }), x("Resize" + c, b.resizeImage), b.isLowIE && x("AfterChange", b.resizeImage)
                },
                resizeImage: function() {
                    var a = b.currItem;
                    if (a && a.img && b.st.image.verticalFit) {
                        var c = 0;
                        b.isLowIE && (c = parseInt(a.img.css("padding-top"), 10) + parseInt(a.img.css("padding-bottom"), 10)), a.img.css("max-height", b.wH - c)
                    }
                },
                _onImageHasSize: function(a) {
                    a.img && (a.hasSize = !0, M && clearInterval(M), a.isCheckingImgSize = !1, z("ImageHasSize", a), a.imgHidden && (b.content && b.content.removeClass("mfp-loading"), a.imgHidden = !1))
                },
                findImageSize: function(a) {
                    var c = 0,
                        d = a.img[0],
                        e = function(f) {
                            M && clearInterval(M), M = setInterval(function() {
                                return d.naturalWidth > 0 ? void b._onImageHasSize(a) : (c > 200 && clearInterval(M), c++, void(3 === c ? e(10) : 40 === c ? e(50) : 100 === c && e(500)))
                            }, f)
                        };
                    e(1)
                },
                getImage: function(c, d) {
                    var e = 0,
                        f = function() {
                            c && (c.img[0].complete ? (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("ready")), c.hasSize = !0, c.loaded = !0, z("ImageLoadComplete")) : (e++, 200 > e ? setTimeout(f, 100) : g()))
                        },
                        g = function() {
                            c && (c.img.off(".mfploader"), c === b.currItem && (b._onImageHasSize(c), b.updateStatus("error", h.tError.replace("%url%", c.src))), c.hasSize = !0, c.loaded = !0, c.loadError = !0)
                        },
                        h = b.st.image,
                        i = d.find(".mfp-img");
                    if (i.length) {
                        var j = document.createElement("img");
                        j.className = "mfp-img", c.img = a(j).on("load.mfploader", f).on("error.mfploader", g), j.src = c.src, i.is("img") && (c.img = c.img.clone()), j = c.img[0], j.naturalWidth > 0 ? c.hasSize = !0 : j.width || (c.hasSize = !1)
                    }
                    return b._parseMarkup(d, {
                        title: N(c),
                        img_replaceWith: c.img
                    }, c), b.resizeImage(), c.hasSize ? (M && clearInterval(M), c.loadError ? (d.addClass("mfp-loading"), b.updateStatus("error", h.tError.replace("%url%", c.src))) : (d.removeClass("mfp-loading"), b.updateStatus("ready")), d) : (b.updateStatus("loading"), c.loading = !0, c.hasSize || (c.imgHidden = !0, d.addClass("mfp-loading"), b.findImageSize(c)), d)
                }
            }
        });
        var O, P = function() {
            return void 0 === O && (O = void 0 !== document.createElement("p").style.MozTransform), O
        };
        a.magnificPopup.registerModule("zoom", {
            options: {
                enabled: !1,
                easing: "ease-in-out",
                duration: 300,
                opener: function(a) {
                    return a.is("img") ? a : a.find("img")
                }
            },
            proto: {
                initZoom: function() {
                    var a, c = b.st.zoom,
                        d = ".zoom";
                    if (c.enabled && b.supportsTransition) {
                        var e, f, g = c.duration,
                            h = function(a) {
                                var b = a.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                                    d = "all " + c.duration / 1e3 + "s " + c.easing,
                                    e = {
                                        position: "fixed",
                                        zIndex: 9999,
                                        left: 0,
                                        top: 0,
                                        "-webkit-backface-visibility": "hidden"
                                    },
                                    f = "transition";
                                return e["-webkit-" + f] = e["-moz-" + f] = e["-o-" + f] = e[f] = d, b.css(e), b
                            },
                            k = function() {
                                b.content.css("visibility", "visible")
                            };
                        x("BuildControls" + d, function() {
                            if (b._allowZoom()) {
                                if (clearTimeout(e), b.content.css("visibility", "hidden"), a = b._getItemToZoom(), !a) return void k();
                                f = h(a), f.css(b._getOffset()), b.wrap.append(f), e = setTimeout(function() {
                                    f.css(b._getOffset(!0)), e = setTimeout(function() {
                                        k(), setTimeout(function() {
                                            f.remove(), a = f = null, z("ZoomAnimationEnded")
                                        }, 16)
                                    }, g)
                                }, 16)
                            }
                        }), x(j + d, function() {
                            if (b._allowZoom()) {
                                if (clearTimeout(e), b.st.removalDelay = g, !a) {
                                    if (a = b._getItemToZoom(), !a) return;
                                    f = h(a)
                                }
                                f.css(b._getOffset(!0)), b.wrap.append(f), b.content.css("visibility", "hidden"), setTimeout(function() {
                                    f.css(b._getOffset())
                                }, 16)
                            }
                        }), x(i + d, function() {
                            b._allowZoom() && (k(), f && f.remove(), a = null)
                        })
                    }
                },
                _allowZoom: function() {
                    return "image" === b.currItem.type
                },
                _getItemToZoom: function() {
                    return b.currItem.hasSize ? b.currItem.img : !1
                },
                _getOffset: function(c) {
                    var d;
                    d = c ? b.currItem.img : b.st.zoom.opener(b.currItem.el || b.currItem);
                    var e = d.offset(),
                        f = parseInt(d.css("padding-top"), 10),
                        g = parseInt(d.css("padding-bottom"), 10);
                    e.top -= a(window).scrollTop() - f;
                    var h = {
                        width: d.width(),
                        height: (v ? d.innerHeight() : d[0].offsetHeight) - g - f
                    };
                    return P() ? h["-moz-transform"] = h.transform = "translate(" + e.left + "px," + e.top + "px)" : (h.left = e.left, h.top = e.top), h
                }
            }
        });
        var Q = "iframe",
            R = "//about:blank",
            S = function(a) {
                if (b.currTemplate[Q]) {
                    var c = b.currTemplate[Q].find("iframe");
                    c.length && (a || (c[0].src = R), b.isIE8 && c.css("display", a ? "block" : "none"))
                }
            };
        a.magnificPopup.registerModule(Q, {
            options: {
                markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
                srcAction: "iframe_src",
                patterns: {
                    youtube: {
                        index: "youtube.com",
                        id: "v=",
                        src: "//www.youtube.com/embed/%id%?autoplay=1"
                    },
                    vimeo: {
                        index: "vimeo.com/",
                        id: "/",
                        src: "//player.vimeo.com/video/%id%?autoplay=1"
                    },
                    gmaps: {
                        index: "//maps.google.",
                        src: "%id%&output=embed"
                    }
                }
            },
            proto: {
                initIframe: function() {
                    b.types.push(Q), x("BeforeChange", function(a, b, c) {
                        b !== c && (b === Q ? S() : c === Q && S(!0))
                    }), x(i + "." + Q, function() {
                        S()
                    })
                },
                getIframe: function(c, d) {
                    var e = c.src,
                        f = b.st.iframe;
                    a.each(f.patterns, function() {
                        return e.indexOf(this.index) > -1 ? (this.id && (e = "string" == typeof this.id ? e.substr(e.lastIndexOf(this.id) + this.id.length, e.length) : this.id.call(this, e)), e = this.src.replace("%id%", e), !1) : void 0
                    });
                    var g = {};
                    return f.srcAction && (g[f.srcAction] = e), b._parseMarkup(d, g, c), b.updateStatus("ready"), d
                }
            }
        });
        var T = function(a) {
                var c = b.items.length;
                return a > c - 1 ? a - c : 0 > a ? c + a : a
            },
            U = function(a, b, c) {
                return a.replace(/%curr%/gi, b + 1).replace(/%total%/gi, c)
            };
        a.magnificPopup.registerModule("gallery", {
            options: {
                enabled: !1,
                arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
                preload: [0, 2],
                navigateByImgClick: !0,
                arrows: !0,
                tPrev: "Previous (Left arrow key)",
                tNext: "Next (Right arrow key)",
                tCounter: "%curr% of %total%"
            },
            proto: {
                initGallery: function() {
                    var c = b.st.gallery,
                        d = ".mfp-gallery",
                        f = Boolean(a.fn.mfpFastClick);
                    return b.direction = !0, c && c.enabled ? (g += " mfp-gallery", x(n + d, function() {
                        c.navigateByImgClick && b.wrap.on("click" + d, ".mfp-img", function() {
                            return b.items.length > 1 ? (b.next(), !1) : void 0
                        }), e.on("keydown" + d, function(a) {
                            37 === a.keyCode ? b.prev() : 39 === a.keyCode && b.next()
                        })
                    }), x("UpdateStatus" + d, function(a, c) {
                        c.text && (c.text = U(c.text, b.currItem.index, b.items.length))
                    }), x(m + d, function(a, d, e, f) {
                        var g = b.items.length;
                        e.counter = g > 1 ? U(c.tCounter, f.index, g) : ""
                    }), x("BuildControls" + d, function() {
                        if (b.items.length > 1 && c.arrows && !b.arrowLeft) {
                            var d = c.arrowMarkup,
                                e = b.arrowLeft = a(d.replace(/%title%/gi, c.tPrev).replace(/%dir%/gi, "left")).addClass(t),
                                g = b.arrowRight = a(d.replace(/%title%/gi, c.tNext).replace(/%dir%/gi, "right")).addClass(t),
                                h = f ? "mfpFastClick" : "click";
                            e[h](function() {
                                b.prev()
                            }), g[h](function() {
                                b.next()
                            }), b.isIE7 && (y("b", e[0], !1, !0), y("a", e[0], !1, !0), y("b", g[0], !1, !0), y("a", g[0], !1, !0)), b.container.append(e.add(g))
                        }
                    }), x(o + d, function() {
                        b._preloadTimeout && clearTimeout(b._preloadTimeout), b._preloadTimeout = setTimeout(function() {
                            b.preloadNearbyImages(), b._preloadTimeout = null
                        }, 16)
                    }), void x(i + d, function() {
                        e.off(d), b.wrap.off("click" + d), b.arrowLeft && f && b.arrowLeft.add(b.arrowRight).destroyMfpFastClick(), b.arrowRight = b.arrowLeft = null
                    })) : !1
                },
                next: function() {
                    b.direction = !0, b.index = T(b.index + 1), b.updateItemHTML()
                },
                prev: function() {
                    b.direction = !1, b.index = T(b.index - 1), b.updateItemHTML()
                },
                goTo: function(a) {
                    b.direction = a >= b.index, b.index = a, b.updateItemHTML()
                },
                preloadNearbyImages: function() {
                    var a, c = b.st.gallery.preload,
                        d = Math.min(c[0], b.items.length),
                        e = Math.min(c[1], b.items.length);
                    for (a = 1;
                        (b.direction ? e : d) >= a; a++) b._preloadItem(b.index + a);
                    for (a = 1;
                        (b.direction ? d : e) >= a; a++) b._preloadItem(b.index - a)
                },
                _preloadItem: function(c) {
                    if (c = T(c), !b.items[c].preloaded) {
                        var d = b.items[c];
                        d.parsed || (d = b.parseEl(c)), z("LazyLoad", d), "image" === d.type && (d.img = a('<img class="mfp-img" />').on("load.mfploader", function() {
                            d.hasSize = !0
                        }).on("error.mfploader", function() {
                            d.hasSize = !0, d.loadError = !0, z("LazyLoadError", d)
                        }).attr("src", d.src)), d.preloaded = !0
                    }
                }
            }
        });
        var V = "retina";
        a.magnificPopup.registerModule(V, {
                options: {
                    replaceSrc: function(a) {
                        return a.src.replace(/\.\w+$/, function(a) {
                            return "@2x" + a
                        })
                    },
                    ratio: 1
                },
                proto: {
                    initRetina: function() {
                        if (window.devicePixelRatio > 1) {
                            var a = b.st.retina,
                                c = a.ratio;
                            c = isNaN(c) ? c() : c, c > 1 && (x("ImageHasSize." + V, function(a, b) {
                                b.img.css({
                                    "max-width": b.img[0].naturalWidth / c,
                                    width: "100%"
                                })
                            }), x("ElementParse." + V, function(b, d) {
                                d.src = a.replaceSrc(d, c)
                            }))
                        }
                    }
                }
            }),
            function() {
                var b = 1e3,
                    c = "ontouchstart" in window,
                    d = function() {
                        w.off("touchmove" + f + " touchend" + f)
                    },
                    e = "mfpFastClick",
                    f = "." + e;
                a.fn.mfpFastClick = function(e) {
                    return a(this).each(function() {
                        var g, h = a(this);
                        if (c) {
                            var i, j, k, l, m, n;
                            h.on("touchstart" + f, function(a) {
                                l = !1, n = 1, m = a.originalEvent ? a.originalEvent.touches[0] : a.touches[0], j = m.clientX, k = m.clientY, w.on("touchmove" + f, function(a) {
                                    m = a.originalEvent ? a.originalEvent.touches : a.touches, n = m.length, m = m[0], (Math.abs(m.clientX - j) > 10 || Math.abs(m.clientY - k) > 10) && (l = !0, d())
                                }).on("touchend" + f, function(a) {
                                    d(), l || n > 1 || (g = !0, a.preventDefault(), clearTimeout(i), i = setTimeout(function() {
                                        g = !1
                                    }, b), e())
                                })
                            })
                        }
                        h.on("click" + f, function() {
                            g || e()
                        })
                    })
                }, a.fn.destroyMfpFastClick = function() {
                    a(this).off("touchstart" + f + " click" + f), c && w.off("touchmove" + f + " touchend" + f)
                }
            }(), B()
    }(window.jQuery || window.Zepto),
    function() {
        function a(a) {
            function b(b, c, d, e, f, g) {
                for (; f >= 0 && g > f; f += a) {
                    var h = e ? e[f] : f;
                    d = c(d, b[h], h, b)
                }
                return d
            }
            return function(c, d, e, f) {
                d = t(d, f, 4);
                var g = !A(c) && s.keys(c),
                    h = (g || c).length,
                    i = a > 0 ? 0 : h - 1;
                return arguments.length < 3 && (e = c[g ? g[i] : i], i += a), b(c, d, e, g, i, h)
            }
        }

        function b(a) {
            return function(b, c, d) {
                c = u(c, d);
                for (var e = z(b), f = a > 0 ? 0 : e - 1; f >= 0 && e > f; f += a)
                    if (c(b[f], f, b)) return f;
                return -1
            }
        }

        function c(a, b, c) {
            return function(d, e, f) {
                var g = 0,
                    h = z(d);
                if ("number" == typeof f) a > 0 ? g = f >= 0 ? f : Math.max(f + h, g) : h = f >= 0 ? Math.min(f + 1, h) : f + h + 1;
                else if (c && f && h) return f = c(d, e), d[f] === e ? f : -1;
                if (e !== e) return f = b(k.call(d, g, h), s.isNaN), f >= 0 ? f + g : -1;
                for (f = a > 0 ? g : h - 1; f >= 0 && h > f; f += a)
                    if (d[f] === e) return f;
                return -1
            }
        }

        function d(a, b) {
            var c = F.length,
                d = a.constructor,
                e = s.isFunction(d) && d.prototype || h,
                f = "constructor";
            for (s.has(a, f) && !s.contains(b, f) && b.push(f); c--;) f = F[c], f in a && a[f] !== e[f] && !s.contains(b, f) && b.push(f)
        }
        var e = this,
            f = e._,
            g = Array.prototype,
            h = Object.prototype,
            i = Function.prototype,
            j = g.push,
            k = g.slice,
            l = h.toString,
            m = h.hasOwnProperty,
            n = Array.isArray,
            o = Object.keys,
            p = i.bind,
            q = Object.create,
            r = function() {},
            s = function(a) {
                return a instanceof s ? a : this instanceof s ? void(this._wrapped = a) : new s(a)
            };
        "undefined" != typeof exports ? ("undefined" != typeof module && module.exports && (exports = module.exports = s), exports._ = s) : e._ = s, s.VERSION = "1.8.3";
        var t = function(a, b, c) {
                if (void 0 === b) return a;
                switch (null == c ? 3 : c) {
                    case 1:
                        return function(c) {
                            return a.call(b, c)
                        };
                    case 2:
                        return function(c, d) {
                            return a.call(b, c, d)
                        };
                    case 3:
                        return function(c, d, e) {
                            return a.call(b, c, d, e)
                        };
                    case 4:
                        return function(c, d, e, f) {
                            return a.call(b, c, d, e, f)
                        }
                }
                return function() {
                    return a.apply(b, arguments)
                }
            },
            u = function(a, b, c) {
                return null == a ? s.identity : s.isFunction(a) ? t(a, b, c) : s.isObject(a) ? s.matcher(a) : s.property(a)
            };
        s.iteratee = function(a, b) {
            return u(a, b, 1 / 0)
        };
        var v = function(a, b) {
                return function(c) {
                    var d = arguments.length;
                    if (2 > d || null == c) return c;
                    for (var e = 1; d > e; e++)
                        for (var f = arguments[e], g = a(f), h = g.length, i = 0; h > i; i++) {
                            var j = g[i];
                            b && void 0 !== c[j] || (c[j] = f[j])
                        }
                    return c
                }
            },
            w = function(a) {
                if (!s.isObject(a)) return {};
                if (q) return q(a);
                r.prototype = a;
                var b = new r;
                return r.prototype = null, b
            },
            x = function(a) {
                return function(b) {
                    return null == b ? void 0 : b[a]
                }
            },
            y = Math.pow(2, 53) - 1,
            z = x("length"),
            A = function(a) {
                var b = z(a);
                return "number" == typeof b && b >= 0 && y >= b
            };
        s.each = s.forEach = function(a, b, c) {
            b = t(b, c);
            var d, e;
            if (A(a))
                for (d = 0, e = a.length; e > d; d++) b(a[d], d, a);
            else {
                var f = s.keys(a);
                for (d = 0, e = f.length; e > d; d++) b(a[f[d]], f[d], a)
            }
            return a
        }, s.map = s.collect = function(a, b, c) {
            b = u(b, c);
            for (var d = !A(a) && s.keys(a), e = (d || a).length, f = Array(e), g = 0; e > g; g++) {
                var h = d ? d[g] : g;
                f[g] = b(a[h], h, a)
            }
            return f
        }, s.reduce = s.foldl = s.inject = a(1), s.reduceRight = s.foldr = a(-1), s.find = s.detect = function(a, b, c) {
            var d;
            return d = A(a) ? s.findIndex(a, b, c) : s.findKey(a, b, c), void 0 !== d && -1 !== d ? a[d] : void 0
        }, s.filter = s.select = function(a, b, c) {
            var d = [];
            return b = u(b, c), s.each(a, function(a, c, e) {
                b(a, c, e) && d.push(a)
            }), d
        }, s.reject = function(a, b, c) {
            return s.filter(a, s.negate(u(b)), c)
        }, s.every = s.all = function(a, b, c) {
            b = u(b, c);
            for (var d = !A(a) && s.keys(a), e = (d || a).length, f = 0; e > f; f++) {
                var g = d ? d[f] : f;
                if (!b(a[g], g, a)) return !1
            }
            return !0
        }, s.some = s.any = function(a, b, c) {
            b = u(b, c);
            for (var d = !A(a) && s.keys(a), e = (d || a).length, f = 0; e > f; f++) {
                var g = d ? d[f] : f;
                if (b(a[g], g, a)) return !0
            }
            return !1
        }, s.contains = s.includes = s.include = function(a, b, c, d) {
            return A(a) || (a = s.values(a)), ("number" != typeof c || d) && (c = 0), s.indexOf(a, b, c) >= 0
        }, s.invoke = function(a, b) {
            var c = k.call(arguments, 2),
                d = s.isFunction(b);
            return s.map(a, function(a) {
                var e = d ? b : a[b];
                return null == e ? e : e.apply(a, c)
            })
        }, s.pluck = function(a, b) {
            return s.map(a, s.property(b))
        }, s.where = function(a, b) {
            return s.filter(a, s.matcher(b))
        }, s.findWhere = function(a, b) {
            return s.find(a, s.matcher(b))
        }, s.max = function(a, b, c) {
            var d, e, f = -1 / 0,
                g = -1 / 0;
            if (null == b && null != a) {
                a = A(a) ? a : s.values(a);
                for (var h = 0, i = a.length; i > h; h++) d = a[h], d > f && (f = d)
            } else b = u(b, c), s.each(a, function(a, c, d) {
                e = b(a, c, d), (e > g || e === -1 / 0 && f === -1 / 0) && (f = a, g = e)
            });
            return f
        }, s.min = function(a, b, c) {
            var d, e, f = 1 / 0,
                g = 1 / 0;
            if (null == b && null != a) {
                a = A(a) ? a : s.values(a);
                for (var h = 0, i = a.length; i > h; h++) d = a[h], f > d && (f = d)
            } else b = u(b, c), s.each(a, function(a, c, d) {
                e = b(a, c, d), (g > e || 1 / 0 === e && 1 / 0 === f) && (f = a, g = e)
            });
            return f
        }, s.shuffle = function(a) {
            for (var b, c = A(a) ? a : s.values(a), d = c.length, e = Array(d), f = 0; d > f; f++) b = s.random(0, f), b !== f && (e[f] = e[b]), e[b] = c[f];
            return e
        }, s.sample = function(a, b, c) {
            return null == b || c ? (A(a) || (a = s.values(a)), a[s.random(a.length - 1)]) : s.shuffle(a).slice(0, Math.max(0, b))
        }, s.sortBy = function(a, b, c) {
            return b = u(b, c), s.pluck(s.map(a, function(a, c, d) {
                return {
                    value: a,
                    index: c,
                    criteria: b(a, c, d)
                }
            }).sort(function(a, b) {
                var c = a.criteria,
                    d = b.criteria;
                if (c !== d) {
                    if (c > d || void 0 === c) return 1;
                    if (d > c || void 0 === d) return -1
                }
                return a.index - b.index
            }), "value")
        };
        var B = function(a) {
            return function(b, c, d) {
                var e = {};
                return c = u(c, d), s.each(b, function(d, f) {
                    var g = c(d, f, b);
                    a(e, d, g)
                }), e
            }
        };
        s.groupBy = B(function(a, b, c) {
            s.has(a, c) ? a[c].push(b) : a[c] = [b]
        }), s.indexBy = B(function(a, b, c) {
            a[c] = b
        }), s.countBy = B(function(a, b, c) {
            s.has(a, c) ? a[c]++ : a[c] = 1
        }), s.toArray = function(a) {
            return a ? s.isArray(a) ? k.call(a) : A(a) ? s.map(a, s.identity) : s.values(a) : []
        }, s.size = function(a) {
            return null == a ? 0 : A(a) ? a.length : s.keys(a).length
        }, s.partition = function(a, b, c) {
            b = u(b, c);
            var d = [],
                e = [];
            return s.each(a, function(a, c, f) {
                (b(a, c, f) ? d : e).push(a)
            }), [d, e]
        }, s.first = s.head = s.take = function(a, b, c) {
            return null == a ? void 0 : null == b || c ? a[0] : s.initial(a, a.length - b)
        }, s.initial = function(a, b, c) {
            return k.call(a, 0, Math.max(0, a.length - (null == b || c ? 1 : b)))
        }, s.last = function(a, b, c) {
            return null == a ? void 0 : null == b || c ? a[a.length - 1] : s.rest(a, Math.max(0, a.length - b))
        }, s.rest = s.tail = s.drop = function(a, b, c) {
            return k.call(a, null == b || c ? 1 : b)
        }, s.compact = function(a) {
            return s.filter(a, s.identity)
        };
        var C = function(a, b, c, d) {
            for (var e = [], f = 0, g = d || 0, h = z(a); h > g; g++) {
                var i = a[g];
                if (A(i) && (s.isArray(i) || s.isArguments(i))) {
                    b || (i = C(i, b, c));
                    var j = 0,
                        k = i.length;
                    for (e.length += k; k > j;) e[f++] = i[j++]
                } else c || (e[f++] = i)
            }
            return e
        };
        s.flatten = function(a, b) {
            return C(a, b, !1)
        }, s.without = function(a) {
            return s.difference(a, k.call(arguments, 1))
        }, s.uniq = s.unique = function(a, b, c, d) {
            s.isBoolean(b) || (d = c, c = b, b = !1), null != c && (c = u(c, d));
            for (var e = [], f = [], g = 0, h = z(a); h > g; g++) {
                var i = a[g],
                    j = c ? c(i, g, a) : i;
                b ? (g && f === j || e.push(i), f = j) : c ? s.contains(f, j) || (f.push(j), e.push(i)) : s.contains(e, i) || e.push(i)
            }
            return e
        }, s.union = function() {
            return s.uniq(C(arguments, !0, !0))
        }, s.intersection = function(a) {
            for (var b = [], c = arguments.length, d = 0, e = z(a); e > d; d++) {
                var f = a[d];
                if (!s.contains(b, f)) {
                    for (var g = 1; c > g && s.contains(arguments[g], f); g++);
                    g === c && b.push(f)
                }
            }
            return b
        }, s.difference = function(a) {
            var b = C(arguments, !0, !0, 1);
            return s.filter(a, function(a) {
                return !s.contains(b, a)
            })
        }, s.zip = function() {
            return s.unzip(arguments)
        }, s.unzip = function(a) {
            for (var b = a && s.max(a, z).length || 0, c = Array(b), d = 0; b > d; d++) c[d] = s.pluck(a, d);
            return c
        }, s.object = function(a, b) {
            for (var c = {}, d = 0, e = z(a); e > d; d++) b ? c[a[d]] = b[d] : c[a[d][0]] = a[d][1];
            return c
        }, s.findIndex = b(1), s.findLastIndex = b(-1), s.sortedIndex = function(a, b, c, d) {
            c = u(c, d, 1);
            for (var e = c(b), f = 0, g = z(a); g > f;) {
                var h = Math.floor((f + g) / 2);
                c(a[h]) < e ? f = h + 1 : g = h
            }
            return f
        }, s.indexOf = c(1, s.findIndex, s.sortedIndex), s.lastIndexOf = c(-1, s.findLastIndex), s.range = function(a, b, c) {
            null == b && (b = a || 0, a = 0), c = c || 1;
            for (var d = Math.max(Math.ceil((b - a) / c), 0), e = Array(d), f = 0; d > f; f++, a += c) e[f] = a;
            return e
        };
        var D = function(a, b, c, d, e) {
            if (!(d instanceof b)) return a.apply(c, e);
            var f = w(a.prototype),
                g = a.apply(f, e);
            return s.isObject(g) ? g : f
        };
        s.bind = function(a, b) {
            if (p && a.bind === p) return p.apply(a, k.call(arguments, 1));
            if (!s.isFunction(a)) throw new TypeError("Bind must be called on a function");
            var c = k.call(arguments, 2),
                d = function() {
                    return D(a, d, b, this, c.concat(k.call(arguments)))
                };
            return d
        }, s.partial = function(a) {
            var b = k.call(arguments, 1),
                c = function() {
                    for (var d = 0, e = b.length, f = Array(e), g = 0; e > g; g++) f[g] = b[g] === s ? arguments[d++] : b[g];
                    for (; d < arguments.length;) f.push(arguments[d++]);
                    return D(a, c, this, this, f)
                };
            return c
        }, s.bindAll = function(a) {
            var b, c, d = arguments.length;
            if (1 >= d) throw new Error("bindAll must be passed function names");
            for (b = 1; d > b; b++) c = arguments[b], a[c] = s.bind(a[c], a);
            return a
        }, s.memoize = function(a, b) {
            var c = function(d) {
                var e = c.cache,
                    f = "" + (b ? b.apply(this, arguments) : d);
                return s.has(e, f) || (e[f] = a.apply(this, arguments)), e[f]
            };
            return c.cache = {}, c
        }, s.delay = function(a, b) {
            var c = k.call(arguments, 2);
            return setTimeout(function() {
                return a.apply(null, c)
            }, b)
        }, s.defer = s.partial(s.delay, s, 1), s.throttle = function(a, b, c) {
            var d, e, f, g = null,
                h = 0;
            c || (c = {});
            var i = function() {
                h = c.leading === !1 ? 0 : s.now(), g = null, f = a.apply(d, e), g || (d = e = null)
            };
            return function() {
                var j = s.now();
                h || c.leading !== !1 || (h = j);
                var k = b - (j - h);
                return d = this, e = arguments, 0 >= k || k > b ? (g && (clearTimeout(g), g = null), h = j, f = a.apply(d, e), g || (d = e = null)) : g || c.trailing === !1 || (g = setTimeout(i, k)), f
            }
        }, s.debounce = function(a, b, c) {
            var d, e, f, g, h, i = function() {
                var j = s.now() - g;
                b > j && j >= 0 ? d = setTimeout(i, b - j) : (d = null, c || (h = a.apply(f, e), d || (f = e = null)))
            };
            return function() {
                f = this, e = arguments, g = s.now();
                var j = c && !d;
                return d || (d = setTimeout(i, b)), j && (h = a.apply(f, e), f = e = null), h
            }
        }, s.wrap = function(a, b) {
            return s.partial(b, a)
        }, s.negate = function(a) {
            return function() {
                return !a.apply(this, arguments)
            }
        }, s.compose = function() {
            var a = arguments,
                b = a.length - 1;
            return function() {
                for (var c = b, d = a[b].apply(this, arguments); c--;) d = a[c].call(this, d);
                return d
            }
        }, s.after = function(a, b) {
            return function() {
                return --a < 1 ? b.apply(this, arguments) : void 0
            }
        }, s.before = function(a, b) {
            var c;
            return function() {
                return --a > 0 && (c = b.apply(this, arguments)), 1 >= a && (b = null), c
            }
        }, s.once = s.partial(s.before, 2);
        var E = !{
                toString: null
            }.propertyIsEnumerable("toString"),
            F = ["valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
        s.keys = function(a) {
            if (!s.isObject(a)) return [];
            if (o) return o(a);
            var b = [];
            for (var c in a) s.has(a, c) && b.push(c);
            return E && d(a, b), b
        }, s.allKeys = function(a) {
            if (!s.isObject(a)) return [];
            var b = [];
            for (var c in a) b.push(c);
            return E && d(a, b), b
        }, s.values = function(a) {
            for (var b = s.keys(a), c = b.length, d = Array(c), e = 0; c > e; e++) d[e] = a[b[e]];
            return d
        }, s.mapObject = function(a, b, c) {
            b = u(b, c);
            for (var d, e = s.keys(a), f = e.length, g = {}, h = 0; f > h; h++) d = e[h], g[d] = b(a[d], d, a);
            return g
        }, s.pairs = function(a) {
            for (var b = s.keys(a), c = b.length, d = Array(c), e = 0; c > e; e++) d[e] = [b[e], a[b[e]]];
            return d
        }, s.invert = function(a) {
            for (var b = {}, c = s.keys(a), d = 0, e = c.length; e > d; d++) b[a[c[d]]] = c[d];
            return b
        }, s.functions = s.methods = function(a) {
            var b = [];
            for (var c in a) s.isFunction(a[c]) && b.push(c);
            return b.sort()
        }, s.extend = v(s.allKeys), s.extendOwn = s.assign = v(s.keys), s.findKey = function(a, b, c) {
            b = u(b, c);
            for (var d, e = s.keys(a), f = 0, g = e.length; g > f; f++)
                if (d = e[f], b(a[d], d, a)) return d
        }, s.pick = function(a, b, c) {
            var d, e, f = {},
                g = a;
            if (null == g) return f;
            s.isFunction(b) ? (e = s.allKeys(g), d = t(b, c)) : (e = C(arguments, !1, !1, 1), d = function(a, b, c) {
                return b in c
            }, g = Object(g));
            for (var h = 0, i = e.length; i > h; h++) {
                var j = e[h],
                    k = g[j];
                d(k, j, g) && (f[j] = k)
            }
            return f
        }, s.omit = function(a, b, c) {
            if (s.isFunction(b)) b = s.negate(b);
            else {
                var d = s.map(C(arguments, !1, !1, 1), String);
                b = function(a, b) {
                    return !s.contains(d, b)
                }
            }
            return s.pick(a, b, c)
        }, s.defaults = v(s.allKeys, !0), s.create = function(a, b) {
            var c = w(a);
            return b && s.extendOwn(c, b), c
        }, s.clone = function(a) {
            return s.isObject(a) ? s.isArray(a) ? a.slice() : s.extend({}, a) : a
        }, s.tap = function(a, b) {
            return b(a), a
        }, s.isMatch = function(a, b) {
            var c = s.keys(b),
                d = c.length;
            if (null == a) return !d;
            for (var e = Object(a), f = 0; d > f; f++) {
                var g = c[f];
                if (b[g] !== e[g] || !(g in e)) return !1
            }
            return !0
        };
        var G = function(a, b, c, d) {
            if (a === b) return 0 !== a || 1 / a === 1 / b;
            if (null == a || null == b) return a === b;
            a instanceof s && (a = a._wrapped), b instanceof s && (b = b._wrapped);
            var e = l.call(a);
            if (e !== l.call(b)) return !1;
            switch (e) {
                case "[object RegExp]":
                case "[object String]":
                    return "" + a == "" + b;
                case "[object Number]":
                    return +a !== +a ? +b !== +b : 0 === +a ? 1 / +a === 1 / b : +a === +b;
                case "[object Date]":
                case "[object Boolean]":
                    return +a === +b
            }
            var f = "[object Array]" === e;
            if (!f) {
                if ("object" != typeof a || "object" != typeof b) return !1;
                var g = a.constructor,
                    h = b.constructor;
                if (g !== h && !(s.isFunction(g) && g instanceof g && s.isFunction(h) && h instanceof h) && "constructor" in a && "constructor" in b) return !1
            }
            c = c || [], d = d || [];
            for (var i = c.length; i--;)
                if (c[i] === a) return d[i] === b;
            if (c.push(a), d.push(b), f) {
                if (i = a.length, i !== b.length) return !1;
                for (; i--;)
                    if (!G(a[i], b[i], c, d)) return !1
            } else {
                var j, k = s.keys(a);
                if (i = k.length, s.keys(b).length !== i) return !1;
                for (; i--;)
                    if (j = k[i], !s.has(b, j) || !G(a[j], b[j], c, d)) return !1
            }
            return c.pop(), d.pop(), !0
        };
        s.isEqual = function(a, b) {
            return G(a, b)
        }, s.isEmpty = function(a) {
            return null == a ? !0 : A(a) && (s.isArray(a) || s.isString(a) || s.isArguments(a)) ? 0 === a.length : 0 === s.keys(a).length
        }, s.isElement = function(a) {
            return !(!a || 1 !== a.nodeType)
        }, s.isArray = n || function(a) {
            return "[object Array]" === l.call(a)
        }, s.isObject = function(a) {
            var b = typeof a;
            return "function" === b || "object" === b && !!a
        }, s.each(["Arguments", "Function", "String", "Number", "Date", "RegExp", "Error"], function(a) {
            s["is" + a] = function(b) {
                return l.call(b) === "[object " + a + "]"
            }
        }), s.isArguments(arguments) || (s.isArguments = function(a) {
            return s.has(a, "callee")
        }), "function" != typeof /./ && "object" != typeof Int8Array && (s.isFunction = function(a) {
            return "function" == typeof a || !1
        }), s.isFinite = function(a) {
            return isFinite(a) && !isNaN(parseFloat(a))
        }, s.isNaN = function(a) {
            return s.isNumber(a) && a !== +a
        }, s.isBoolean = function(a) {
            return a === !0 || a === !1 || "[object Boolean]" === l.call(a)
        }, s.isNull = function(a) {
            return null === a
        }, s.isUndefined = function(a) {
            return void 0 === a
        }, s.has = function(a, b) {
            return null != a && m.call(a, b)
        }, s.noConflict = function() {
            return e._ = f, this
        }, s.identity = function(a) {
            return a
        }, s.constant = function(a) {
            return function() {
                return a
            }
        }, s.noop = function() {}, s.property = x, s.propertyOf = function(a) {
            return null == a ? function() {} : function(b) {
                return a[b]
            }
        }, s.matcher = s.matches = function(a) {
            return a = s.extendOwn({}, a),
                function(b) {
                    return s.isMatch(b, a)
                }
        }, s.times = function(a, b, c) {
            var d = Array(Math.max(0, a));
            b = t(b, c, 1);
            for (var e = 0; a > e; e++) d[e] = b(e);
            return d
        }, s.random = function(a, b) {
            return null == b && (b = a, a = 0), a + Math.floor(Math.random() * (b - a + 1))
        }, s.now = Date.now || function() {
            return (new Date).getTime()
        };
        var H = {
                "&": "&amp;",
                "<": "&lt;",
                ">": "&gt;",
                '"': "&quot;",
                "'": "&#x27;",
                "`": "&#x60;"
            },
            I = s.invert(H),
            J = function(a) {
                var b = function(b) {
                        return a[b]
                    },
                    c = "(?:" + s.keys(a).join("|") + ")",
                    d = RegExp(c),
                    e = RegExp(c, "g");
                return function(a) {
                    return a = null == a ? "" : "" + a, d.test(a) ? a.replace(e, b) : a
                }
            };
        s.escape = J(H), s.unescape = J(I), s.result = function(a, b, c) {
            var d = null == a ? void 0 : a[b];
            return void 0 === d && (d = c), s.isFunction(d) ? d.call(a) : d
        };
        var K = 0;
        s.uniqueId = function(a) {
            var b = ++K + "";
            return a ? a + b : b
        }, s.templateSettings = {
            evaluate: /<%([\s\S]+?)%>/g,
            interpolate: /<%=([\s\S]+?)%>/g,
            escape: /<%-([\s\S]+?)%>/g
        };
        var L = /(.)^/,
            M = {
                "'": "'",
                "\\": "\\",
                "\r": "r",
                "\n": "n",
                "\u2028": "u2028",
                "\u2029": "u2029"
            },
            N = /\\|'|\r|\n|\u2028|\u2029/g,
            O = function(a) {
                return "\\" + M[a]
            };
        s.template = function(a, b, c) {
            !b && c && (b = c), b = s.defaults({}, b, s.templateSettings);
            var d = RegExp([(b.escape || L).source, (b.interpolate || L).source, (b.evaluate || L).source].join("|") + "|$", "g"),
                e = 0,
                f = "__p+='";
            a.replace(d, function(b, c, d, g, h) {
                return f += a.slice(e, h).replace(N, O), e = h + b.length, c ? f += "'+\n((__t=(" + c + "))==null?'':_.escape(__t))+\n'" : d ? f += "'+\n((__t=(" + d + "))==null?'':__t)+\n'" : g && (f += "';\n" + g + "\n__p+='"), b
            }), f += "';\n", b.variable || (f = "with(obj||{}){\n" + f + "}\n"), f = "var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};\n" + f + "return __p;\n";
            try {
                var g = new Function(b.variable || "obj", "_", f)
            } catch (h) {
                throw h.source = f, h
            }
            var i = function(a) {
                    return g.call(this, a, s)
                },
                j = b.variable || "obj";
            return i.source = "function(" + j + "){\n" + f + "}", i
        }, s.chain = function(a) {
            var b = s(a);
            return b._chain = !0, b
        };
        var P = function(a, b) {
            return a._chain ? s(b).chain() : b
        };
        s.mixin = function(a) {
            s.each(s.functions(a), function(b) {
                var c = s[b] = a[b];
                s.prototype[b] = function() {
                    var a = [this._wrapped];
                    return j.apply(a, arguments), P(this, c.apply(s, a))
                }
            })
        }, s.mixin(s), s.each(["pop", "push", "reverse", "shift", "sort", "splice", "unshift"], function(a) {
            var b = g[a];
            s.prototype[a] = function() {
                var c = this._wrapped;
                return b.apply(c, arguments), "shift" !== a && "splice" !== a || 0 !== c.length || delete c[0], P(this, c)
            }
        }), s.each(["concat", "join", "slice"], function(a) {
            var b = g[a];
            s.prototype[a] = function() {
                return P(this, b.apply(this._wrapped, arguments))
            }
        }), s.prototype.value = function() {
            return this._wrapped
        }, s.prototype.valueOf = s.prototype.toJSON = s.prototype.value, s.prototype.toString = function() {
            return "" + this._wrapped
        }, "function" == typeof define && define.amd && define("underscore", [], function() {
            return s
        })
    }.call(this), "object" == typeof Countries && (Countries.updateProvinceLabel = function(a, b) {
        if ("string" == typeof a && Countries[a] && Countries[a].provinces) {
            if ("object" != typeof b && (b = document.getElementById("address_province_label"), null === b)) return;
            b.innerHTML = Countries[a].label;
            var c = jQuery(b).parent();
            c.find("select");
            c.find(".custom-style-select-box-inner").html(Countries[a].provinces[0])
        }
    }), "undefined" == typeof Shopify.Cart && (Shopify.Cart = {}), Shopify.Cart.ShippingCalculator = function() {
        var _config = {
                submitButton: "Calculate shipping",
                submitButtonDisabled: "Calculating...",
                templateId: "shipping-calculator-response-template",
                wrapperId: "wrapper-response",
                customerIsLoggedIn: !1,
                moneyFormat: "$"
            },
            _render = function(a) {
                var b = jQuery("#" + _config.templateId),
                    c = jQuery("#" + _config.wrapperId);
                if (b.length && c.length) {
                    var d = _.template(jQuery.trim(b.text())),
                        e = d(a);
                    if (jQuery(e).appendTo(c), "undefined" != typeof Currency && "function" == typeof Currency.convertAll) {
                        var f = "";
                        jQuery("[name=currencies]").size() ? f = jQuery("[name=currencies]").val() : jQuery("#currencies span.selected").size() && (f = jQuery("#currencies span.selected").attr("data-currency")), "" !== f && Currency.convertAll(shopCurrency, f, "#wrapper-response span.money, #estimated-shipping span.money")
                    }
                }
            },
            _enableButtons = function() {
                jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton)
            },
            _disableButtons = function() {
                jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled")
            },
            _getCartShippingRatesForDestination = function(a) {
                var b = {
                    type: "POST",
                    url: "/cart/prepare_shipping_rates",
                    data: jQuery.param({
                        shipping_address: a
                    }),
                    success: _pollForCartShippingRatesForDestination(a),
                    error: _onError
                };
                jQuery.ajax(b)
            },
            _pollForCartShippingRatesForDestination = function(a) {
                var b = function() {
                    jQuery.ajax("/cart/async_shipping_rates", {
                        dataType: "json",
                        success: function(c, d, e) {
                            200 === e.status ? _onCartShippingRatesUpdate(c.shipping_rates, a) : setTimeout(b, 500)
                        },
                        error: _onError
                    })
                };
                return b
            },
            _fullMessagesFromErrors = function(a) {
                var b = [];
                return jQuery.each(a, function(a, c) {
                    jQuery.each(c, function(c, d) {
                        b.push(a + " " + d)
                    })
                }), b
            },
            _onError = function(XMLHttpRequest, textStatus) {
                jQuery("#estimated-shipping").hide(), jQuery("#estimated-shipping em").empty(), _enableButtons();
                var feedback = "",
                    data = eval("(" + XMLHttpRequest.responseText + ")");
                feedback = data.message ? data.message + "(" + data.status + "): " + data.description : "Error : " + _fullMessagesFromErrors(data).join("; ") + ".", "Error : country is not supported." === feedback && (feedback = "We do not ship to this destination."), _render({
                    rates: [],
                    errorFeedback: feedback,
                    success: !1
                }), jQuery("#" + _config.wrapperId).show()
            },
            _onCartShippingRatesUpdate = function(a, b) {
                _enableButtons();
                var c = "";
                if (b.zip && (c += b.zip + ", "), b.province && (c += b.province + ", "), c += b.country, a.length) {
                    "0.00" == a[0].price ? jQuery("#estimated-shipping em").html("FREE") : jQuery("#estimated-shipping em").html(_formatRate(a[0].price));
                    for (var d = 0; d < a.length; d++) a[d].price = _formatRate(a[d].price)
                }
                _render({
                    rates: a,
                    address: c,
                    success: !0
                }), jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn()
            },
            _formatRate = function(a) {
                function b(a, b) {
                    return "undefined" == typeof a ? b : a
                }

                function c(a, c, d, e) {
                    if (c = b(c, 2), d = b(d, ","), e = b(e, "."), isNaN(a) || null == a) return 0;
                    a = (a / 100).toFixed(c);
                    var f = a.split("."),
                        g = f[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + d),
                        h = f[1] ? e + f[1] : "";
                    return g + h
                }
                if ("function" == typeof Shopify.formatMoney) return Shopify.formatMoney(a, _config.moneyFormat);
                "string" == typeof a && (a = a.replace(".", ""));
                var d = "",
                    e = /\{\{\s*(\w+)\s*\}\}/,
                    f = _config.moneyFormat;
                switch (f.match(e)[1]) {
                    case "amount":
                        d = c(a, 2);
                        break;
                    case "amount_no_decimals":
                        d = c(a, 0);
                        break;
                    case "amount_with_comma_separator":
                        d = c(a, 2, ".", ",");
                        break;
                    case "amount_no_decimals_with_comma_separator":
                        d = c(a, 0, ".", ",")
                }
                return f.replace(e, d)
            };
        return _init = function() {
            new Shopify.CountryProvinceSelector("address_country", "address_province", {
                hideElement: "address_province_container"
            });
            var a = jQuery("#address_country"),
                b = jQuery("#address_province_label").get(0);
            "undefined" != typeof Countries && (Countries.updateProvinceLabel(a.val(), b), a.change(function() {
                Countries.updateProvinceLabel(a.val(), b)
            })), jQuery(".get-rates").click(function() {
                _disableButtons(), jQuery("#" + _config.wrapperId).empty().hide();
                var a = {};
                a.zip = jQuery("#address_zip").val() || "", a.country = jQuery("#address_country").val() || "", a.province = jQuery("#address_province").val() || "", _getCartShippingRatesForDestination(a)
            }), _config.customerIsLoggedIn && jQuery(".get-rates:eq(0)").trigger("click")
        }, {
            show: function(a) {
                a = a || {}, jQuery.extend(_config, a), jQuery(function() {
                    _init()
                })
            },
            getConfig: function() {
                return _config
            },
            formatRate: function(a) {
                return _formatRate(a)
            }
        }
    }();
var Shopify = Shopify || {};
Shopify.optionsMap = {}, Shopify.updateOptionsInSelector = function(a) {
        switch (a) {
            case 0:
                var b = "root",
                    c = jQuery(".single-option-selector:eq(0)");
                break;
            case 1:
                var b = jQuery(".single-option-selector:eq(0)").val(),
                    c = jQuery(".single-option-selector:eq(1)");
                break;
            case 2:
                var b = jQuery(".single-option-selector:eq(0)").val();
                b += " / " + jQuery(".single-option-selector:eq(1)").val();
                var c = jQuery(".single-option-selector:eq(2)")
        }
        var d = c.val();
        c.empty();
        for (var e = Shopify.optionsMap[b], f = 0; f < e.length; f++) {
            var g = e[f],
                h = jQuery("<option></option>").val(g).html(g);
            c.append(h)
        }
        jQuery('.swatch[data-option-index="' + a + '"] .swatch-element').each(function() {
            -1 !== jQuery.inArray($(this).attr("data-value"), e) ? $(this).removeClass("soldout").show().find(":radio").removeAttr("disabled", "disabled").removeAttr("checked") : $(this).addClass("soldout").hide().find(":radio").removeAttr("checked").attr("disabled", "disabled")
        }), -1 !== jQuery.inArray(d, e) && c.val(d), c.trigger("change")
    }, Shopify.linkOptionSelectors = function(a) {
        for (var b = 0; b < a.variants.length; b++) {
            var c = a.variants[b];
            if (c.available) {
                if (Shopify.optionsMap.root = Shopify.optionsMap.root || [], Shopify.optionsMap.root.push(c.option1), Shopify.optionsMap.root = Shopify.uniq(Shopify.optionsMap.root), a.options.length > 1) {
                    var d = c.option1;
                    Shopify.optionsMap[d] = Shopify.optionsMap[d] || [], Shopify.optionsMap[d].push(c.option2), Shopify.optionsMap[d] = Shopify.uniq(Shopify.optionsMap[d])
                }
                if (3 === a.options.length) {
                    var d = c.option1 + " / " + c.option2;
                    Shopify.optionsMap[d] = Shopify.optionsMap[d] || [], Shopify.optionsMap[d].push(c.option3), Shopify.optionsMap[d] = Shopify.uniq(Shopify.optionsMap[d])
                }
            }
        }
        Shopify.updateOptionsInSelector(0), a.options.length > 1 && Shopify.updateOptionsInSelector(1), 3 === a.options.length && Shopify.updateOptionsInSelector(2), jQuery(".single-option-selector:eq(0)").change(function() {
            return Shopify.updateOptionsInSelector(1), 3 === a.options.length && Shopify.updateOptionsInSelector(2), !0
        }), jQuery(".single-option-selector:eq(1)").change(function() {
            return 3 === a.options.length && Shopify.updateOptionsInSelector(2), !0
        })
    }, Shopify.handleize = function(a) {
        return a.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "")
    }, jQuery.cookie = function(a, b, c) {
        if ("undefined" == typeof b) {
            var d = null;
            if (document.cookie && "" != document.cookie)
                for (var e = document.cookie.split(";"), f = 0; f < e.length; f++) {
                    var g = jQuery.trim(e[f]);
                    if (g.substring(0, a.length + 1) == a + "=") {
                        d = decodeURIComponent(g.substring(a.length + 1));
                        break
                    }
                }
            return d
        }
        c = c || {}, null === b && (b = "", c.expires = -1);
        var h = "";
        if (c.expires && ("number" == typeof c.expires || c.expires.toUTCString)) {
            var i;
            "number" == typeof c.expires ? (i = new Date, i.setTime(i.getTime() + 24 * c.expires * 60 * 60 * 1e3)) : i = c.expires, h = "; expires=" + i.toUTCString()
        }
        var j = c.path ? "; path=" + c.path : "",
            k = c.domain ? "; domain=" + c.domain : "",
            l = c.secure ? "; secure" : "";
        document.cookie = [a, "=", encodeURIComponent(b), h, j, k, l].join("")
    },
    function(a, b) {
        "use strict";
        var c = a.History = a.History || {};
        if ("undefined" != typeof c.Adapter) throw new Error("History.js Adapter has already been loaded...");
        c.Adapter = {
            handlers: {},
            _uid: 1,
            uid: function(a) {
                return a._uid || (a._uid = c.Adapter._uid++)
            },
            bind: function(a, b, d) {
                var e = c.Adapter.uid(a);
                c.Adapter.handlers[e] = c.Adapter.handlers[e] || {}, c.Adapter.handlers[e][b] = c.Adapter.handlers[e][b] || [], c.Adapter.handlers[e][b].push(d), a["on" + b] = function(a, b) {
                    return function(d) {
                        c.Adapter.trigger(a, b, d)
                    }
                }(a, b)
            },
            trigger: function(a, b, d) {
                d = d || {};
                var e, f, g = c.Adapter.uid(a);
                for (c.Adapter.handlers[g] = c.Adapter.handlers[g] || {}, c.Adapter.handlers[g][b] = c.Adapter.handlers[g][b] || [], e = 0, f = c.Adapter.handlers[g][b].length; f > e; ++e) c.Adapter.handlers[g][b][e].apply(this, [d])
            },
            extractEventData: function(a, c) {
                var d = c && c[a] || b;
                return d
            },
            onDomLoad: function(b) {
                var c = a.setTimeout(function() {
                    b()
                }, 2e3);
                a.onload = function() {
                    clearTimeout(c), b()
                }
            }
        }, "undefined" != typeof c.init && c.init()
    }(window),
    function(a, b) {
        "use strict";
        var c = a.console || b,
            d = a.document,
            e = a.navigator,
            f = !1,
            g = a.setTimeout,
            h = a.clearTimeout,
            i = a.setInterval,
            j = a.clearInterval,
            k = a.JSON,
            l = a.alert,
            m = a.History = a.History || {},
            n = a.history;
        try {
            f = a.sessionStorage, f.setItem("TEST", "1"), f.removeItem("TEST")
        } catch (o) {
            f = !1
        }
        if (k.stringify = k.stringify || k.encode, k.parse = k.parse || k.decode, "undefined" != typeof m.init) throw new Error("History.js Core has already been loaded...");
        m.init = function(a) {
            return "undefined" == typeof m.Adapter ? !1 : ("undefined" != typeof m.initCore && m.initCore(), "undefined" != typeof m.initHtml4 && m.initHtml4(), !0)
        }, m.initCore = function(o) {
            if ("undefined" != typeof m.initCore.initialized) return !1;
            if (m.initCore.initialized = !0, m.options = m.options || {}, m.options.hashChangeInterval = m.options.hashChangeInterval || 100, m.options.safariPollInterval = m.options.safariPollInterval || 500, m.options.doubleCheckInterval = m.options.doubleCheckInterval || 500, m.options.disableSuid = m.options.disableSuid || !1, m.options.storeInterval = m.options.storeInterval || 1e3, m.options.busyDelay = m.options.busyDelay || 250, m.options.debug = m.options.debug || !1, m.options.initialTitle = m.options.initialTitle || d.title, m.options.html4Mode = m.options.html4Mode || !1, m.options.delayInit = m.options.delayInit || !1, m.intervalList = [], m.clearAllIntervals = function() {
                    var a, b = m.intervalList;
                    if ("undefined" != typeof b && null !== b) {
                        for (a = 0; a < b.length; a++) j(b[a]);
                        m.intervalList = null
                    }
                }, m.debug = function() {
                    (m.options.debug || !1) && m.log.apply(m, arguments)
                }, m.log = function() {
                    var a, b, e, f, g, h = "undefined" != typeof c && "undefined" != typeof c.log && "undefined" != typeof c.log.apply,
                        i = d.getElementById("log");
                    for (h ? (f = Array.prototype.slice.call(arguments), a = f.shift(), "undefined" != typeof c.debug ? c.debug.apply(c, [a, f]) : c.log.apply(c, [a, f])) : a = "\n" + arguments[0] + "\n", b = 1, e = arguments.length; e > b; ++b) {
                        if (g = arguments[b], "object" == typeof g && "undefined" != typeof k) try {
                            g = k.stringify(g)
                        } catch (j) {}
                        a += "\n" + g + "\n"
                    }
                    return i ? (i.value += a + "\n-----\n", i.scrollTop = i.scrollHeight - i.clientHeight) : h || l(a), !0
                }, m.getInternetExplorerMajorVersion = function() {
                    var a = m.getInternetExplorerMajorVersion.cached = "undefined" != typeof m.getInternetExplorerMajorVersion.cached ? m.getInternetExplorerMajorVersion.cached : function() {
                        for (var a = 3, b = d.createElement("div"), c = b.getElementsByTagName("i");
                            (b.innerHTML = "<!--[if gt IE " + ++a + "]><i></i><![endif]-->") && c[0];);
                        return a > 4 ? a : !1
                    }();
                    return a
                }, m.isInternetExplorer = function() {
                    var a = m.isInternetExplorer.cached = "undefined" != typeof m.isInternetExplorer.cached ? m.isInternetExplorer.cached : Boolean(m.getInternetExplorerMajorVersion());
                    return a
                }, m.options.html4Mode ? m.emulated = {
                    pushState: !0,
                    hashChange: !0
                } : m.emulated = {
                    pushState: !Boolean(a.history && a.history.pushState && a.history.replaceState && !/ Mobile\/([1-7][a-z]|(8([abcde]|f(1[0-8]))))/i.test(e.userAgent) && !/AppleWebKit\/5([0-2]|3[0-2])/i.test(e.userAgent)),
                    hashChange: Boolean(!("onhashchange" in a || "onhashchange" in d) || m.isInternetExplorer() && m.getInternetExplorerMajorVersion() < 8)
                }, m.enabled = !m.emulated.pushState, m.bugs = {
                    setHash: Boolean(!m.emulated.pushState && "Apple Computer, Inc." === e.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(e.userAgent)),
                    safariPoll: Boolean(!m.emulated.pushState && "Apple Computer, Inc." === e.vendor && /AppleWebKit\/5([0-2]|3[0-3])/.test(e.userAgent)),
                    ieDoubleCheck: Boolean(m.isInternetExplorer() && m.getInternetExplorerMajorVersion() < 8),
                    hashEscape: Boolean(m.isInternetExplorer() && m.getInternetExplorerMajorVersion() < 7)
                }, m.isEmptyObject = function(a) {
                    for (var b in a)
                        if (a.hasOwnProperty(b)) return !1;
                    return !0
                }, m.cloneObject = function(a) {
                    var b, c;
                    return a ? (b = k.stringify(a), c = k.parse(b)) : c = {}, c
                }, m.getRootUrl = function() {
                    var a = d.location.protocol + "//" + (d.location.hostname || d.location.host);
                    return d.location.port && (a += ":" + d.location.port), a += "/"
                }, m.getBaseHref = function() {
                    var a = d.getElementsByTagName("base"),
                        b = null,
                        c = "";
                    return 1 === a.length && (b = a[0], c = b.href.replace(/[^\/]+$/, "")), c = c.replace(/\/+$/, ""), c && (c += "/"), c
                }, m.getBaseUrl = function() {
                    var a = m.getBaseHref() || m.getBasePageUrl() || m.getRootUrl();
                    return a
                }, m.getPageUrl = function() {
                    var a, b = m.getState(!1, !1),
                        c = (b || {}).url || m.getLocationHref();
                    return a = c.replace(/\/+$/, "").replace(/[^\/]+$/, function(a, b, c) {
                        return /\./.test(a) ? a : a + "/"
                    })
                }, m.getBasePageUrl = function() {
                    var a = m.getLocationHref().replace(/[#\?].*/, "").replace(/[^\/]+$/, function(a, b, c) {
                        return /[^\/]$/.test(a) ? "" : a
                    }).replace(/\/+$/, "") + "/";
                    return a
                }, m.getFullUrl = function(a, b) {
                    var c = a,
                        d = a.substring(0, 1);
                    return b = "undefined" == typeof b ? !0 : b, /[a-z]+\:\/\//.test(a) || (c = "/" === d ? m.getRootUrl() + a.replace(/^\/+/, "") : "#" === d ? m.getPageUrl().replace(/#.*/, "") + a : "?" === d ? m.getPageUrl().replace(/[\?#].*/, "") + a : b ? m.getBaseUrl() + a.replace(/^(\.\/)+/, "") : m.getBasePageUrl() + a.replace(/^(\.\/)+/, "")), c.replace(/\#$/, "")
                }, m.getShortUrl = function(a) {
                    var b = a,
                        c = m.getBaseUrl(),
                        d = m.getRootUrl();
                    return m.emulated.pushState && (b = b.replace(c, "")), b = b.replace(d, "/"), m.isTraditionalAnchor(b) && (b = "./" + b), b = b.replace(/^(\.\/)+/g, "./").replace(/\#$/, "")
                }, m.getLocationHref = function(a) {
                    return a = a || d, a.URL === a.location.href ? a.location.href : a.location.href === decodeURIComponent(a.URL) ? a.URL : a.location.hash && decodeURIComponent(a.location.href.replace(/^[^#]+/, "")) === a.location.hash ? a.location.href : -1 == a.URL.indexOf("#") && -1 != a.location.href.indexOf("#") ? a.location.href : a.URL || a.location.href
                }, m.store = {}, m.idToState = m.idToState || {}, m.stateToId = m.stateToId || {}, m.urlToId = m.urlToId || {}, m.storedStates = m.storedStates || [], m.savedStates = m.savedStates || [], m.normalizeStore = function() {
                    m.store.idToState = m.store.idToState || {}, m.store.urlToId = m.store.urlToId || {}, m.store.stateToId = m.store.stateToId || {}
                }, m.getState = function(a, b) {
                    "undefined" == typeof a && (a = !0), "undefined" == typeof b && (b = !0);
                    var c = m.getLastSavedState();
                    return !c && b && (c = m.createStateObject()), a && (c = m.cloneObject(c), c.url = c.cleanUrl || c.url), c
                }, m.getIdByState = function(a) {
                    var b, c = m.extractId(a.url);
                    if (!c)
                        if (b = m.getStateString(a), "undefined" != typeof m.stateToId[b]) c = m.stateToId[b];
                        else if ("undefined" != typeof m.store.stateToId[b]) c = m.store.stateToId[b];
                    else {
                        for (; c = (new Date).getTime() + String(Math.random()).replace(/\D/g, ""), "undefined" != typeof m.idToState[c] || "undefined" != typeof m.store.idToState[c];);
                        m.stateToId[b] = c, m.idToState[c] = a
                    }
                    return c
                }, m.normalizeState = function(a) {
                    var b, c;
                    return a && "object" == typeof a || (a = {}), "undefined" != typeof a.normalized ? a : (a.data && "object" == typeof a.data || (a.data = {}), b = {}, b.normalized = !0, b.title = a.title || "", b.url = m.getFullUrl(a.url ? a.url : m.getLocationHref()), b.hash = m.getShortUrl(b.url), b.data = m.cloneObject(a.data), b.id = m.getIdByState(b), b.cleanUrl = b.url.replace(/\??\&_suid.*/, ""), b.url = b.cleanUrl, c = !m.isEmptyObject(b.data), (b.title || c) && m.options.disableSuid !== !0 && (b.hash = m.getShortUrl(b.url).replace(/\??\&_suid.*/, ""), /\?/.test(b.hash) || (b.hash += "?"), b.hash += "&_suid=" + b.id), b.hashedUrl = m.getFullUrl(b.hash), (m.emulated.pushState || m.bugs.safariPoll) && m.hasUrlDuplicate(b) && (b.url = b.hashedUrl), b)
                }, m.createStateObject = function(a, b, c) {
                    var d = {
                        data: a,
                        title: b,
                        url: c
                    };
                    return d = m.normalizeState(d)
                }, m.getStateById = function(a) {
                    a = String(a);
                    var c = m.idToState[a] || m.store.idToState[a] || b;
                    return c
                }, m.getStateString = function(a) {
                    var b, c, d;
                    return b = m.normalizeState(a), c = {
                        data: b.data,
                        title: a.title,
                        url: a.url
                    }, d = k.stringify(c)
                }, m.getStateId = function(a) {
                    var b, c;
                    return b = m.normalizeState(a), c = b.id
                }, m.getHashByState = function(a) {
                    var b, c;
                    return b = m.normalizeState(a), c = b.hash
                }, m.extractId = function(a) {
                    var b, c, d, e;
                    return e = -1 != a.indexOf("#") ? a.split("#")[0] : a, c = /(.*)\&_suid=([0-9]+)$/.exec(e), d = c ? c[1] || a : a, b = c ? String(c[2] || "") : "", b || !1
                }, m.isTraditionalAnchor = function(a) {
                    var b = !/[\/\?\.]/.test(a);
                    return b
                }, m.extractState = function(a, b) {
                    var c, d, e = null;
                    return b = b || !1, c = m.extractId(a), c && (e = m.getStateById(c)), e || (d = m.getFullUrl(a), c = m.getIdByUrl(d) || !1, c && (e = m.getStateById(c)), !e && b && !m.isTraditionalAnchor(a) && (e = m.createStateObject(null, null, d))), e
                }, m.getIdByUrl = function(a) {
                    var c = m.urlToId[a] || m.store.urlToId[a] || b;
                    return c
                }, m.getLastSavedState = function() {
                    return m.savedStates[m.savedStates.length - 1] || b
                }, m.getLastStoredState = function() {
                    return m.storedStates[m.storedStates.length - 1] || b
                }, m.hasUrlDuplicate = function(a) {
                    var b, c = !1;
                    return b = m.extractState(a.url), c = b && b.id !== a.id
                }, m.storeState = function(a) {
                    return m.urlToId[a.url] = a.id, m.storedStates.push(m.cloneObject(a)), a
                }, m.isLastSavedState = function(a) {
                    var b, c, d, e = !1;
                    return m.savedStates.length && (b = a.id, c = m.getLastSavedState(), d = c.id, e = b === d), e
                }, m.saveState = function(a) {
                    return m.isLastSavedState(a) ? !1 : (m.savedStates.push(m.cloneObject(a)), !0)
                }, m.getStateByIndex = function(a) {
                    var b = null;
                    return b = "undefined" == typeof a ? m.savedStates[m.savedStates.length - 1] : 0 > a ? m.savedStates[m.savedStates.length + a] : m.savedStates[a]
                }, m.getCurrentIndex = function() {
                    var a = null;
                    return a = m.savedStates.length < 1 ? 0 : m.savedStates.length - 1
                }, m.getHash = function(a) {
                    var b, c = m.getLocationHref(a);
                    return b = m.getHashByUrl(c)
                }, m.unescapeHash = function(a) {
                    var b = m.normalizeHash(a);
                    return b = decodeURIComponent(b)
                }, m.normalizeHash = function(a) {
                    var b = a.replace(/[^#]*#/, "").replace(/#.*/, "");
                    return b
                }, m.setHash = function(a, b) {
                    var c, e;
                    return b !== !1 && m.busy() ? (m.pushQueue({
                        scope: m,
                        callback: m.setHash,
                        args: arguments,
                        queue: b
                    }), !1) : (m.busy(!0), c = m.extractState(a, !0), c && !m.emulated.pushState ? m.pushState(c.data, c.title, c.url, !1) : m.getHash() !== a && (m.bugs.setHash ? (e = m.getPageUrl(), m.pushState(null, null, e + "#" + a, !1)) : d.location.hash = a), m)
                }, m.escapeHash = function(b) {
                    var c = m.normalizeHash(b);
                    return c = a.encodeURIComponent(c), m.bugs.hashEscape || (c = c.replace(/\%21/g, "!").replace(/\%26/g, "&").replace(/\%3D/g, "=").replace(/\%3F/g, "?")), c
                }, m.getHashByUrl = function(a) {
                    var b = String(a).replace(/([^#]*)#?([^#]*)#?(.*)/, "$2");
                    return b = m.unescapeHash(b)
                }, m.setTitle = function(a) {
                    var b, c = a.title;
                    c || (b = m.getStateByIndex(0), b && b.url === a.url && (c = b.title || m.options.initialTitle));
                    try {
                        d.getElementsByTagName("title")[0].innerHTML = c.replace("<", "&lt;").replace(">", "&gt;").replace(" & ", " &amp; ")
                    } catch (e) {}
                    return d.title = c, m
                }, m.queues = [], m.busy = function(a) {
                    if ("undefined" != typeof a ? m.busy.flag = a : "undefined" == typeof m.busy.flag && (m.busy.flag = !1), !m.busy.flag) {
                        h(m.busy.timeout);
                        var b = function() {
                            var a, c, d;
                            if (!m.busy.flag)
                                for (a = m.queues.length - 1; a >= 0; --a) c = m.queues[a], 0 !== c.length && (d = c.shift(), m.fireQueueItem(d), m.busy.timeout = g(b, m.options.busyDelay))
                        };
                        m.busy.timeout = g(b, m.options.busyDelay)
                    }
                    return m.busy.flag
                }, m.busy.flag = !1, m.fireQueueItem = function(a) {
                    return a.callback.apply(a.scope || m, a.args || [])
                }, m.pushQueue = function(a) {
                    return m.queues[a.queue || 0] = m.queues[a.queue || 0] || [], m.queues[a.queue || 0].push(a), m
                }, m.queue = function(a, b) {
                    return "function" == typeof a && (a = {
                        callback: a
                    }), "undefined" != typeof b && (a.queue = b), m.busy() ? m.pushQueue(a) : m.fireQueueItem(a), m
                }, m.clearQueue = function() {
                    return m.busy.flag = !1, m.queues = [], m
                }, m.stateChanged = !1, m.doubleChecker = !1, m.doubleCheckComplete = function() {
                    return m.stateChanged = !0, m.doubleCheckClear(), m
                }, m.doubleCheckClear = function() {
                    return m.doubleChecker && (h(m.doubleChecker), m.doubleChecker = !1), m
                }, m.doubleCheck = function(a) {
                    return m.stateChanged = !1, m.doubleCheckClear(), m.bugs.ieDoubleCheck && (m.doubleChecker = g(function() {
                        return m.doubleCheckClear(), m.stateChanged || a(), !0
                    }, m.options.doubleCheckInterval)), m
                }, m.safariStatePoll = function() {
                    var b, c = m.extractState(m.getLocationHref());
                    return m.isLastSavedState(c) ? void 0 : (b = c, b || (b = m.createStateObject()), m.Adapter.trigger(a, "popstate"), m)
                }, m.back = function(a) {
                    return a !== !1 && m.busy() ? (m.pushQueue({
                        scope: m,
                        callback: m.back,
                        args: arguments,
                        queue: a
                    }), !1) : (m.busy(!0), m.doubleCheck(function() {
                        m.back(!1)
                    }), n.go(-1), !0)
                }, m.forward = function(a) {
                    return a !== !1 && m.busy() ? (m.pushQueue({
                        scope: m,
                        callback: m.forward,
                        args: arguments,
                        queue: a
                    }), !1) : (m.busy(!0), m.doubleCheck(function() {
                        m.forward(!1)
                    }), n.go(1), !0)
                }, m.go = function(a, b) {
                    var c;
                    if (a > 0)
                        for (c = 1; a >= c; ++c) m.forward(b);
                    else {
                        if (!(0 > a)) throw new Error("History.go: History.go requires a positive or negative integer passed.");
                        for (c = -1; c >= a; --c) m.back(b)
                    }
                    return m
                }, m.emulated.pushState) {
                var p = function() {};
                m.pushState = m.pushState || p, m.replaceState = m.replaceState || p
            } else m.onPopState = function(b, c) {
                var d, e, f = !1,
                    g = !1;
                return m.doubleCheckComplete(), d = m.getHash(), d ? (e = m.extractState(d || m.getLocationHref(), !0), e ? m.replaceState(e.data, e.title, e.url, !1) : (m.Adapter.trigger(a, "anchorchange"), m.busy(!1)), m.expectedStateId = !1, !1) : (f = m.Adapter.extractEventData("state", b, c) || !1, g = f ? m.getStateById(f) : m.expectedStateId ? m.getStateById(m.expectedStateId) : m.extractState(m.getLocationHref()), g || (g = m.createStateObject(null, null, m.getLocationHref())), m.expectedStateId = !1, m.isLastSavedState(g) ? (m.busy(!1), !1) : (m.storeState(g), m.saveState(g), m.setTitle(g), m.Adapter.trigger(a, "statechange"), m.busy(!1), !0))
            }, m.Adapter.bind(a, "popstate", m.onPopState), m.pushState = function(b, c, d, e) {
                if (m.getHashByUrl(d) && m.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                if (e !== !1 && m.busy()) return m.pushQueue({
                    scope: m,
                    callback: m.pushState,
                    args: arguments,
                    queue: e
                }), !1;
                m.busy(!0);
                var f = m.createStateObject(b, c, d);
                return m.isLastSavedState(f) ? m.busy(!1) : (m.storeState(f), m.expectedStateId = f.id, n.pushState(f.id, f.title, f.url), m.Adapter.trigger(a, "popstate")), !0
            }, m.replaceState = function(b, c, d, e) {
                if (m.getHashByUrl(d) && m.emulated.pushState) throw new Error("History.js does not support states with fragement-identifiers (hashes/anchors).");
                if (e !== !1 && m.busy()) return m.pushQueue({
                    scope: m,
                    callback: m.replaceState,
                    args: arguments,
                    queue: e
                }), !1;
                m.busy(!0);
                var f = m.createStateObject(b, c, d);
                return m.isLastSavedState(f) ? m.busy(!1) : (m.storeState(f), m.expectedStateId = f.id, n.replaceState(f.id, f.title, f.url), m.Adapter.trigger(a, "popstate")), !0
            };
            if (f) {
                try {
                    m.store = k.parse(f.getItem("History.store")) || {}
                } catch (q) {
                    m.store = {}
                }
                m.normalizeStore()
            } else m.store = {}, m.normalizeStore();
            m.Adapter.bind(a, "unload", m.clearAllIntervals), m.saveState(m.storeState(m.extractState(m.getLocationHref(), !0))), f && (m.onUnload = function() {
                var a, b, c;
                try {
                    a = k.parse(f.getItem("History.store")) || {}
                } catch (d) {
                    a = {}
                }
                a.idToState = a.idToState || {}, a.urlToId = a.urlToId || {}, a.stateToId = a.stateToId || {};
                for (b in m.idToState) m.idToState.hasOwnProperty(b) && (a.idToState[b] = m.idToState[b]);
                for (b in m.urlToId) m.urlToId.hasOwnProperty(b) && (a.urlToId[b] = m.urlToId[b]);
                for (b in m.stateToId) m.stateToId.hasOwnProperty(b) && (a.stateToId[b] = m.stateToId[b]);
                m.store = a, m.normalizeStore(), c = k.stringify(a);
                try {
                    f.setItem("History.store", c)
                } catch (e) {
                    if (e.code !== DOMException.QUOTA_EXCEEDED_ERR) throw e;
                    f.length && (f.removeItem("History.store"), f.setItem("History.store", c))
                }
            }, m.intervalList.push(i(m.onUnload, m.options.storeInterval)), m.Adapter.bind(a, "beforeunload", m.onUnload), m.Adapter.bind(a, "unload", m.onUnload)), m.emulated.pushState || (m.bugs.safariPoll && m.intervalList.push(i(m.safariStatePoll, m.options.safariPollInterval)), ("Apple Computer, Inc." === e.vendor || "Mozilla" === (e.appCodeName || "")) && (m.Adapter.bind(a, "hashchange", function() {
                m.Adapter.trigger(a, "popstate")
            }), m.getHash() && m.Adapter.onDomLoad(function() {
                m.Adapter.trigger(a, "hashchange")
            })))
        }, (!m.options || !m.options.delayInit) && m.init()
    }(window),
    function(a) {
        var b = function(b, c) {
            this.$menu = a(b), this.$menu.length && (this.options = a.extend({}, a.fn.pglmenu.defaults, c), this.child_open = [], this.loaded = !1, this.start())
        };
        b.prototype = {
            constructor: b,
            start: function() {
                if (!this.loaded) {
                    this.loaded = !0;
                    var b = this,
                        c = this.options,
                        d = this.$menu;
                    this.$items = d.find("li"), this.$items.each(function(d, e) {
                        var f = a(this),
                            g = f.children(".dropdown-menu"),
                            h = f.children("a"),
                            i = {
                                $item: f,
                                child: g.length,
                                link: h.length,
                                clickable: !(h.length && g.length),
                                mega: f.hasClass("mega"),
                                status: "close",
                                timer: null,
                                atimer: null
                            };
                        f.data("pglmenu.item", i), g.length && !c.hover ? f.on("click", function(a) {
                            a.stopPropagation(), f.hasClass("group") || "close" == i.status && (a.preventDefault(), b.show(i))
                        }) : f.on("click", function(a) {
                            a.stopPropagation()
                        }), c.hover && (f.on("mouseover", function(a) {
                            f.hasClass("group") || (a.stopPropagation(), b.show(i))
                        }).on("mouseleave", function(a) {
                            f.hasClass("group") || (a.stopPropagation(), b.hide(i))
                        }), h.length && g.length && h.on("click", function(a) {
                            return i.clickable
                        }))
                    }), a(document.body).on("tap hideall.pglmenu", function(c) {
                        clearTimeout(b.timer), b.timer = setTimeout(a.proxy(b.hide_alls, b), "tap" == c.type ? 500 : b.options.hidedelay)
                    })
                }
            },
            show: function(b) {
                a.inArray(b, this.child_open) < this.child_open.length - 1 && this.hide_others(b), a(document.body).trigger("hideall.pglmenu", [this]), clearTimeout(this.timer), clearTimeout(b.timer), clearTimeout(b.ftimer), clearTimeout(b.ctimer), "open" == b.status && b.$item.hasClass("open") && this.child_open.length || (b.mega ? (clearTimeout(b.astimer), clearTimeout(b.atimer), this.position(b.$item), b.astimer = setTimeout(function() {
                    b.$item.addClass("animating")
                }, 10), b.atimer = setTimeout(function() {
                    b.$item.removeClass("animating")
                }, this.options.duration + 50), b.timer = setTimeout(function() {
                    b.$item.addClass("open")
                }, 100)) : b.$item.addClass("open"), b.status = "open", b.child && -1 == a.inArray(b, this.child_open) && this.child_open.push(b)), b.ctimer = setTimeout(a.proxy(this.clickable, this, b), 300)
            },
            hide: function(b) {
                clearTimeout(this.timer), clearTimeout(b.timer), clearTimeout(b.astimer), clearTimeout(b.atimer), clearTimeout(b.ftimer), b.mega ? (b.$item.addClass("animating"), b.atimer = setTimeout(function() {
                    b.$item.removeClass("animating")
                }, this.options.duration), b.timer = setTimeout(function() {
                    b.$item.removeClass("open")
                }, 100)) : b.$item.removeClass("open"), b.status = "close";
                for (var c = this.child_open.length; c--;) this.child_open[c] === b && this.child_open.splice(c, 1);
                b.ftimer = setTimeout(a.proxy(this.hidden, this, b), this.options.duration), this.timer = setTimeout(a.proxy(this.hide_alls, this), this.options.hidedelay)
            },
            hidden: function(a) {
                "close" == a.status && (a.clickable = !1)
            },
            hide_others: function(b) {
                var c = this;
                a.each(this.child_open.slice(), function(a, d) {
                    (!b || d != b && !d.$item.has(b.$item).length) && c.hide(d)
                })
            },
            hide_alls: function(b, c) {
                if (!b || "tap" == b.type || "hideall" == b.type && this != c) {
                    var d = this;
                    a.each(this.child_open.slice(), function(a, b) {
                        b && d.hide(b)
                    })
                }
            },
            clickable: function(a) {
                a.clickable = !0
            },
            position: function(b) {
                var c = b.find(">.dropdown-menu"),
                    d = c.is(":visible");
                d || c.show();
                var e = b.offset(),
                    f = b.outerWidth(),
                    g = a(window).width() - this.options.sb_width,
                    h = c.outerWidth(),
                    i = b.data("level");
                if (d || c.css("display", ""), c.css({
                        left: "",
                        right: ""
                    }), 1 == i) {
                    var j = b.data("alignsub"),
                        k = 0,
                        l = 0,
                        m = 0;
                    if ("fullwidth" == j) return;
                    j || (j = "left"), "center" == j ? (k = e.left + f / 2, a.support.pgltransform || (m = -h / 2, c.css(this.options.rtl ? "right" : "left", m + f / 2))) : k = e.left + ("left" == j && this.options.rtl || "right" == j && !this.options.rtl ? f : 0), this.options.rtl ? "right" == j ? k + h > g && (l = g - k - h, c.css("left", l), h > g && c.css("left", l + h - g)) : (("center" == j ? h / 2 : h) > k && (l = k - ("center" == j ? h / 2 : h), c.css("right", l + m)), k + ("center" == j ? h / 2 : 0) - l > g && c.css("right", k + ("center" == j ? (h + f) / 2 : 0) + m - g)) : "right" == j ? h > k && (l = k - h, c.css("right", l), h > g && c.css("right", h - g + l)) : (k + ("center" == j ? h / 2 : h) > g && (l = g - k - ("center" == j ? h / 2 : h), c.css("left", l + m)), 0 > k - ("center" == j ? h / 2 : 0) + l && c.css("left", ("center" == j ? (h + f) / 2 : 0) + m - k))
                } else this.options.rtl ? b.closest(".mega-dropdown-menu").parent().hasClass("mega-align-right") ? (b.removeClass("mega-align-left").addClass("mega-align-right"), e.left + f + h > g && (b.removeClass("mega-align-right"), e.left - h < 0 && c.css("right", e.left + f - h))) : e.left - h < 0 && (b.removeClass("mega-align-left").addClass("mega-align-right"), e.left + f + h > g && c.css("left", g - e.left - h)) : b.closest(".mega-dropdown-menu").parent().hasClass("mega-align-right") ? (b.removeClass("mega-align-left").addClass("mega-align-right"), e.left - h < 0 && (b.removeClass("mega-align-right"), e.left + f + h > g && c.css("left", g - e.left - h))) : e.left + f + h > g && (b.removeClass("mega-align-left").addClass("mega-align-right"), e.left - h < 0 && c.css("right", e.left + f - h))
            }
        }, a.fn.pglmenu = function(c) {
            return this.each(function() {
                var d = a(this),
                    e = d.data("megamenu"),
                    f = "object" == typeof c && c;
                e ? "string" == typeof c && e[c] && e[c]() : d.data("megamenu", e = new b(this, f))
            })
        }, a.fn.pglmenu.defaults = {
            duration: 400,
            timeout: 100,
            hidedelay: 200,
            hover: !0,
            sb_width: 20
        }, a(document).ready(function() {
            var b = a("#is-mainnav").data("duration") || 0,
                c = b ? 100 + b : 500,
                d = "rtl" == a(document.documentElement).attr("dir"),
                e = !0,
                f = function() {
                    var b = a('<div style="width:50px;height:50px;overflow:auto"><div/></div>').appendTo("body"),
                        c = b.children(),
                        d = c.innerWidth() - c.height(100).innerWidth();
                    return b.remove(), d
                }();
            a(".is-megamenu,.is-menu-canvas").has(".dropdown-menu").pglmenu({
                duration: b,
                timeout: c,
                rtl: d,
                sb_width: f,
                hover: e
            }), a(window).load(function() {
                a(".is-megamenu,.is-menu-canvas").has(".dropdown-menu").pglmenu({
                    duration: b,
                    timeout: c,
                    rtl: d,
                    sb_width: f,
                    hover: e
                })
            })
        })
    }(jQuery);
var PGL_Plugin = window.PGL_Plugin || {};
! function(a) {
    "use strict";
    a.extend(PGL_Plugin, {
        mm_Duration: a("#is-mainnav").data("duration") || 0,
        mm_Animation: a("#is-mainnav").data("animation") || "",
        oc_Variables: {
            wrapper: a("body"),
            inner: a(".is-wrapper"),
            btn: null,
            nav: null
        },
        init: function() {
            PGL_Plugin.MegamenuDuration()
        },
        stopBubble: function(b) {
            a(b.target).hasClass("dropdown-toggle") || b.stopPropagation()
        },
        MegamenuDuration: function() {
            var b = a("#is-mainnav").data("duration") || 0;
            b && a('<style type="text/css">.is-megamenu.animate .animating > .dropdown-menu,.is-megamenu.animate.slide .animating > .dropdown-menu > div {transition-duration: ' + b + "ms;-webkit-transition-duration: " + b + "ms;-moz-transition-duration: " + b + "ms;}</style>").appendTo("head")
        }
    }), a(document).ready(function() {
        PGL_Plugin.init()
    })
}(jQuery),
function(a, b, c, d) {
    function e(b, c) {
        b.owlCarousel = {
            name: "Owl Carousel",
            author: "Bartosz Wojciechowski",
            version: "2.0.0-beta.2.1"
        }, this.settings = null, this.options = a.extend({}, e.Defaults, c), this.itemData = a.extend({}, l), this.dom = a.extend({}, m), this.width = a.extend({}, n), this.num = a.extend({}, o), this.drag = a.extend({}, q), this.state = a.extend({}, r), this.e = a.extend({}, s), this.plugins = {}, this._supress = {}, this._current = null, this._speed = null, this._coordinates = null, this.dom.el = b, this.dom.$el = a(b);
        for (var d in e.Plugins) this.plugins[d[0].toLowerCase() + d.slice(1)] = new e.Plugins[d](this);
        this.init()
    }

    function f(a) {
        var b, d, e = c.createElement("div"),
            f = a;
        for (b in f)
            if (d = f[b], "undefined" != typeof e.style[d]) return e = null, [d, b];
        return [!1]
    }

    function g() {
        return f(["transition", "WebkitTransition", "MozTransition", "OTransition"])[1]
    }

    function h() {
        return f(["transform", "WebkitTransform", "MozTransform", "OTransform", "msTransform"])[0]
    }

    function i() {
        return f(["perspective", "webkitPerspective", "MozPerspective", "OPerspective", "MsPerspective"])[0]
    }

    function j() {
        return "ontouchstart" in b || !!navigator.msMaxTouchPoints
    }

    function k() {
        return b.navigator.msPointerEnabled
    }
    var l, m, n, o, p, q, r, s;
    l = {
        index: !1,
        indexAbs: !1,
        posLeft: !1,
        clone: !1,
        active: !1,
        loaded: !1,
        lazyLoad: !1,
        current: !1,
        width: !1,
        center: !1,
        page: !1,
        hasVideo: !1,
        playVideo: !1
    }, m = {
        el: null,
        $el: null,
        stage: null,
        $stage: null,
        oStage: null,
        $oStage: null,
        $items: null,
        $oItems: null,
        $cItems: null,
        $content: null
    }, n = {
        el: 0,
        stage: 0,
        item: 0,
        prevWindow: 0,
        cloneLast: 0
    }, o = {
        items: 0,
        oItems: 0,
        cItems: 0,
        active: 0,
        merged: []
    }, q = {
        start: 0,
        startX: 0,
        startY: 0,
        current: 0,
        currentX: 0,
        currentY: 0,
        offsetX: 0,
        offsetY: 0,
        distance: null,
        startTime: 0,
        endTime: 0,
        updatedX: 0,
        targetEl: null
    }, r = {
        isTouch: !1,
        isScrolling: !1,
        isSwiping: !1,
        direction: !1,
        inMotion: !1
    }, s = {
        _onDragStart: null,
        _onDragMove: null,
        _onDragEnd: null,
        _transitionEnd: null,
        _resizer: null,
        _responsiveCall: null,
        _goToLoop: null,
        _checkVisibile: null
    }, e.Defaults = {
        items: 3,
        loop: !1,
        center: !1,
        mouseDrag: !0,
        touchDrag: !0,
        pullDrag: !0,
        freeDrag: !1,
        margin: 0,
        stagePadding: 0,
        merge: !1,
        mergeFit: !0,
        autoWidth: !1,
        startPosition: 0,
        smartSpeed: 250,
        fluidSpeed: !1,
        dragEndSpeed: !1,
        responsive: {},
        responsiveRefreshRate: 200,
        responsiveBaseElement: b,
        responsiveClass: !1,
        fallbackEasing: "swing",
        info: !1,
        nestedItemSelector: !1,
        itemElement: "div",
        stageElement: "div",
        themeClass: "owl-theme",
        baseClass: "owl-carousel",
        itemClass: "owl-item",
        centerClass: "center",
        activeClass: "active"
    }, e.Plugins = {}, e.prototype.init = function() {
        if (this.setResponsiveOptions(), this.trigger("initialize"), this.dom.$el.hasClass(this.settings.baseClass) || this.dom.$el.addClass(this.settings.baseClass), this.dom.$el.hasClass(this.settings.themeClass) || this.dom.$el.addClass(this.settings.themeClass), this.settings.rtl && this.dom.$el.addClass("owl-rtl"), this.browserSupport(), this.settings.autoWidth && this.state.imagesLoaded !== !0) {
            var a, b, c;
            if (a = this.dom.$el.find("img"), b = this.settings.nestedItemSelector ? "." + this.settings.nestedItemSelector : d, c = this.dom.$el.children(b).width(), a.length && 0 >= c) return this.preloadAutoWidthImages(a), !1
        }
        this.width.prevWindow = this.viewport(), this.createStage(), this.fetchContent(), this.eventsCall(), this.internalEvents(), this.dom.$el.addClass("owl-loading"), this.refresh(!0), this.dom.$el.removeClass("owl-loading").addClass("owl-loaded"), this.trigger("initialized"), this.addTriggerableEvents()
    }, e.prototype.setResponsiveOptions = function() {
        if (this.options.responsive) {
            var b = this.viewport(),
                c = this.options.responsive,
                d = -1;
            a.each(c, function(a) {
                b >= a && a > d && (d = Number(a))
            }), this.settings = a.extend({}, this.options, c[d]), delete this.settings.responsive, this.settings.responsiveClass && this.dom.$el.attr("class", function(a, b) {
                return b.replace(/\b owl-responsive-\S+/g, "")
            }).addClass("owl-responsive-" + d)
        } else this.settings = a.extend({}, this.options)
    }, e.prototype.optionsLogic = function() {
        this.dom.$el.toggleClass("owl-center", this.settings.center), this.settings.loop && this.num.oItems < this.settings.items && (this.settings.loop = !1), this.settings.autoWidth && (this.settings.stagePadding = !1, this.settings.merge = !1)
    }, e.prototype.createStage = function() {
        var b = c.createElement("div"),
            d = c.createElement(this.settings.stageElement);
        b.className = "owl-stage-outer", d.className = "owl-stage", b.appendChild(d), this.dom.el.appendChild(b), this.dom.oStage = b, this.dom.$oStage = a(b), this.dom.stage = d, this.dom.$stage = a(d), b = null, d = null
    }, e.prototype.createItemContainer = function() {
        var b = c.createElement(this.settings.itemElement);
        return b.className = this.settings.itemClass, a(b)
    }, e.prototype.fetchContent = function(b) {
        b ? this.dom.$content = b instanceof jQuery ? b : a(b) : this.settings.nestedItemSelector ? this.dom.$content = this.dom.$el.find("." + this.settings.nestedItemSelector).not(".owl-stage-outer") : this.dom.$content = this.dom.$el.children().not(".owl-stage-outer"), this.num.oItems = this.dom.$content.length, 0 !== this.num.oItems && this.initStructure()
    }, e.prototype.initStructure = function() {
        this.createNormalStructure()
    }, e.prototype.createNormalStructure = function() {
        var a, b;
        for (a = 0; a < this.num.oItems; a++) b = this.createItemContainer(), this.initializeItemContainer(b, this.dom.$content[a]), this.dom.$stage.append(b);
        this.dom.$content = null
    }, e.prototype.createCustomStructure = function(a) {
        var b, c;
        for (b = 0; a > b; b++) c = this.createItemContainer(), this.createItemContainerData(c), this.dom.$stage.append(c)
    }, e.prototype.initializeItemContainer = function(a, b) {
        this.trigger("change", {
            property: {
                name: "item",
                value: a
            }
        }), this.createItemContainerData(a), a.append(b), this.trigger("changed", {
            property: {
                name: "item",
                value: a
            }
        })
    }, e.prototype.createItemContainerData = function(b, c) {
        var d = a.extend({}, this.itemData);
        c && a.extend(d, c.data("owl-item")), b.data("owl-item", d)
    }, e.prototype.cloneItemContainer = function(a) {
        var b = a.clone(!0, !0).addClass("cloned");
        return this.createItemContainerData(b, b), b.data("owl-item").clone = !0, b
    }, e.prototype.updateLocalContent = function() {
        var b, c;
        for (this.dom.$oItems = this.dom.$stage.find("." + this.settings.itemClass).filter(function() {
                return a(this).data("owl-item").clone === !1
            }), this.num.oItems = this.dom.$oItems.length, b = 0; b < this.num.oItems; b++) c = this.dom.$oItems.eq(b), c.data("owl-item").index = b
    }, e.prototype.loopClone = function() {
        if (!this.settings.loop || this.num.oItems < this.settings.items) return !1;
        var b, c, d, e = this.settings.items,
            f = this.num.oItems - 1;
        for (this.settings.stagePadding && 1 === this.settings.items && (e += 1), this.num.cItems = 2 * e, d = 0; e > d; d++) b = this.cloneItemContainer(this.dom.$oItems.eq(d)), c = this.cloneItemContainer(this.dom.$oItems.eq(f - d)), this.dom.$stage.append(b), this.dom.$stage.prepend(c);
        this.dom.$cItems = this.dom.$stage.find("." + this.settings.itemClass).filter(function() {
            return a(this).data("owl-item").clone === !0
        })
    }, e.prototype.reClone = function() {
        null !== this.dom.$cItems && (this.dom.$cItems.remove(), this.dom.$cItems = null, this.num.cItems = 0), this.settings.loop && this.loopClone()
    }, e.prototype.calculate = function() {
        var a, b, c, d, e, f, g, h = 0,
            i = 0;
        for (this.width.el = this.dom.$el.width() - 2 * this.settings.stagePadding, this.width.view = this.dom.$el.width(), c = this.width.el - this.settings.margin * (1 === this.settings.items ? 0 : this.settings.items - 1), this.width.el = this.width.el + this.settings.margin, this.width.item = (c / this.settings.items + this.settings.margin).toFixed(3), this.dom.$items = this.dom.$stage.find(".owl-item"), this.num.items = this.dom.$items.length, this.settings.autoWidth && this.dom.$items.css("width", ""), this._coordinates = [], this.num.merged = [], d = this.settings.rtl ? this.settings.center ? -(this.width.el / 2) : 0 : this.settings.center ? this.width.el / 2 : 0, this.width.mergeStage = 0, a = 0; a < this.num.items; a++) this.settings.merge ? (g = this.dom.$items.eq(a).find("[data-merge]").attr("data-merge") || 1, this.settings.mergeFit && g > this.settings.items && (g = this.settings.items), this.num.merged.push(parseInt(g)), this.width.mergeStage += this.width.item * this.num.merged[a]) : this.num.merged.push(1), f = this.width.item * this.num.merged[a], this.settings.autoWidth && (f = this.dom.$items.eq(a).width() + this.settings.margin, this.settings.rtl ? this.dom.$items[a].style.marginLeft = this.settings.margin + "px" : this.dom.$items[a].style.marginRight = this.settings.margin + "px"), this._coordinates.push(d), this.dom.$items.eq(a).data("owl-item").posLeft = h, this.dom.$items.eq(a).data("owl-item").width = f, this.settings.rtl ? (d += f, h += f) : (d -= f, h -= f), i -= Math.abs(f), this.settings.center && (this._coordinates[a] = this.settings.rtl ? this._coordinates[a] + f / 2 : this._coordinates[a] - f / 2);
        for (this.settings.autoWidth ? this.width.stage = this.settings.center ? Math.abs(i) : Math.abs(d) : this.width.stage = Math.abs(i), e = this.num.oItems + this.num.cItems, b = 0; e > b; b++) this.dom.$items.eq(b).data("owl-item").indexAbs = b;
        this.setSizes()
    }, e.prototype.setSizes = function() {
        this.settings.stagePadding !== !1 && (this.dom.oStage.style.paddingLeft = this.settings.stagePadding + "px", this.dom.oStage.style.paddingRight = this.settings.stagePadding + "px"), this.settings.rtl ? b.setTimeout(a.proxy(function() {
            this.dom.stage.style.width = this.width.stage + "px"
        }, this), 0) : this.dom.stage.style.width = this.width.stage + "px";
        for (var c = 0; c < this.num.items; c++) this.settings.autoWidth || (this.dom.$items[c].style.width = this.width.item - this.settings.margin + "px"), this.settings.rtl ? this.dom.$items[c].style.marginLeft = this.settings.margin + "px" : this.dom.$items[c].style.marginRight = this.settings.margin + "px", 1 === this.num.merged[c] || this.settings.autoWidth || (this.dom.$items[c].style.width = this.width.item * this.num.merged[c] - this.settings.margin + "px");
        this.width.stagePrev = this.width.stage
    }, e.prototype.responsive = function() {
        if (!this.num.oItems) return !1;
        var a = this.isElWidthChanged();
        return a ? this.trigger("resize").isDefaultPrevented() ? !1 : (this.state.responsive = !0, this.refresh(), this.state.responsive = !1, void this.trigger("resized")) : !1
    }, e.prototype.refresh = function() {
        var a = this.dom.$oItems && this.dom.$oItems.eq(this.normalize(this.current(), !0));
        return this.trigger("refresh"), this.setResponsiveOptions(), this.updateLocalContent(), this.optionsLogic(), 0 === this.num.oItems ? !1 : (this.dom.$stage.addClass("owl-refresh"), this.reClone(), this.calculate(), this.dom.$stage.removeClass("owl-refresh"), a ? this.reset(a.data("owl-item").indexAbs) : (this.dom.oStage.scrollLeft = 0, this.reset(this.dom.$oItems.eq(0).data("owl-item").indexAbs)), this.state.orientation = b.orientation, this.watchVisibility(), void this.trigger("refreshed"))
    }, e.prototype.updateActiveItems = function() {
        this.trigger("change", {
            property: {
                name: "items",
                value: this.dom.$items
            }
        });
        var a, b, c, d, e, f;
        for (a = 0; a < this.num.items; a++) this.dom.$items.eq(a).data("owl-item").active = !1, this.dom.$items.eq(a).data("owl-item").current = !1, this.dom.$items.eq(a).removeClass(this.settings.activeClass).removeClass(this.settings.centerClass);
        for (this.num.active = 0, padding = 2 * this.settings.stagePadding, stageX = this.coordinates(this.current()) + padding, view = this.settings.rtl ? this.width.view : -this.width.view, b = 0; b < this.num.items; b++) c = this.dom.$items.eq(b), d = c.data("owl-item").posLeft, e = c.data("owl-item").width, f = this.settings.rtl ? d - e - padding : d - e + padding, (this.op(d, "<=", stageX) && this.op(d, ">", stageX + view) || this.op(f, "<", stageX) && this.op(f, ">", stageX + view)) && (this.num.active++, c.data("owl-item").active = !0, c.data("owl-item").current = !0, c.addClass(this.settings.activeClass), this.settings.lazyLoad || (c.data("owl-item").loaded = !0), this.settings.loop && this.updateClonedItemsState(c.data("owl-item").index));
        this.settings.center && (this.dom.$items.eq(this.current()).addClass(this.settings.centerClass).data("owl-item").center = !0), this.trigger("changed", {
            property: {
                name: "items",
                value: this.dom.$items
            }
        })
    }, e.prototype.updateClonedItemsState = function(a) {
        var b, c, d;
        for (this.settings.center && (b = this.dom.$items.eq(this.current()).data("owl-item").index), d = 0; d < this.num.items; d++) c = this.dom.$items.eq(d), c.data("owl-item").index === a && (c.data("owl-item").current = !0, c.data("owl-item").index === b && c.addClass(this.settings.centerClass))
    }, e.prototype.eventsCall = function() {
        this.e._onDragStart = a.proxy(function(a) {
            this.onDragStart(a)
        }, this), this.e._onDragMove = a.proxy(function(a) {
            this.onDragMove(a)
        }, this), this.e._onDragEnd = a.proxy(function(a) {
            this.onDragEnd(a)
        }, this), this.e._transitionEnd = a.proxy(function(a) {
            this.transitionEnd(a)
        }, this), this.e._resizer = a.proxy(function() {
            this.responsiveTimer()
        }, this), this.e._responsiveCall = a.proxy(function() {
            this.responsive()
        }, this), this.e._preventClick = a.proxy(function(a) {
            this.preventClick(a)
        }, this)
    }, e.prototype.responsiveTimer = function() {
        return this.viewport() === this.width.prevWindow ? !1 : (b.clearTimeout(this.resizeTimer), this.resizeTimer = b.setTimeout(this.e._responsiveCall, this.settings.responsiveRefreshRate), void(this.width.prevWindow = this.viewport()))
    }, e.prototype.internalEvents = function() {
        var a = j(),
            d = k();
        a && !d ? this.dragType = ["touchstart", "touchmove", "touchend", "touchcancel"] : a && d ? this.dragType = ["MSPointerDown", "MSPointerMove", "MSPointerUp", "MSPointerCancel"] : this.dragType = ["mousedown", "mousemove", "mouseup"], (a || d) && this.settings.touchDrag ? this.on(c, this.dragType[3], this.e._onDragEnd) : (this.dom.$stage.on("dragstart", function() {
            return !1
        }), this.settings.mouseDrag ? this.dom.stage.onselectstart = function() {
            return !1
        } : this.dom.$el.addClass("owl-text-select-on")), this.transitionEndVendor && this.on(this.dom.stage, this.transitionEndVendor, this.e._transitionEnd, !1), this.settings.responsive !== !1 && this.on(b, "resize", this.e._resizer, !1), this.dragEvents()
    }, e.prototype.dragEvents = function() {
        !this.settings.touchDrag || "touchstart" !== this.dragType[0] && "MSPointerDown" !== this.dragType[0] ? this.settings.mouseDrag && "mousedown" === this.dragType[0] ? this.on(this.dom.stage, this.dragType[0], this.e._onDragStart, !1) : this.off(this.dom.stage, this.dragType[0], this.e._onDragStart) : this.on(this.dom.stage, this.dragType[0], this.e._onDragStart, !1)
    }, e.prototype.onDragStart = function(a) {
        var d, e, f, g, h;
        if (d = a.originalEvent || a || b.event, 3 === d.which) return !1;
        if ("mousedown" === this.dragType[0] && this.dom.$stage.addClass("owl-grab"), this.trigger("drag"), this.drag.startTime = (new Date).getTime(), this.speed(0), this.state.isTouch = !0, this.state.isScrolling = !1, this.state.isSwiping = !1, this.drag.distance = 0, e = "touchstart" === d.type, f = e ? a.targetTouches[0].pageX : d.pageX || d.clientX, g = e ? a.targetTouches[0].pageY : d.pageY || d.clientY, this.drag.offsetX = this.dom.$stage.position().left - this.settings.stagePadding, this.drag.offsetY = this.dom.$stage.position().top, this.settings.rtl && (this.drag.offsetX = this.dom.$stage.position().left + this.width.stage - this.width.el + this.settings.margin), this.state.inMotion && this.support3d) h = this.getTransformProperty(), this.drag.offsetX = h, this.animate(h), this.state.inMotion = !0;
        else if (this.state.inMotion && !this.support3d) return this.state.inMotion = !1, !1;
        this.drag.startX = f - this.drag.offsetX, this.drag.startY = g - this.drag.offsetY, this.drag.start = f - this.drag.startX, this.drag.targetEl = d.target || d.srcElement, this.drag.updatedX = this.drag.start, ("IMG" === this.drag.targetEl.tagName || "A" === this.drag.targetEl.tagName) && (this.drag.targetEl.draggable = !1), this.on(c, this.dragType[1], this.e._onDragMove, !1), this.on(c, this.dragType[2], this.e._onDragEnd, !1)
    }, e.prototype.onDragMove = function(a) {
        var c, e, f, g, h, i, j;
        this.state.isTouch && (this.state.isScrolling || (c = a.originalEvent || a || b.event, e = "touchmove" == c.type, f = e ? c.targetTouches[0].pageX : c.pageX || c.clientX, g = e ? c.targetTouches[0].pageY : c.pageY || c.clientY, this.drag.currentX = f - this.drag.startX, this.drag.currentY = g - this.drag.startY, this.drag.distance = this.drag.currentX - this.drag.offsetX, this.drag.distance < 0 ? this.state.direction = this.settings.rtl ? "right" : "left" : this.drag.distance > 0 && (this.state.direction = this.settings.rtl ? "left" : "right"), this.settings.loop ? this.op(this.drag.currentX, ">", this.coordinates(this.minimum())) && "right" === this.state.direction ? this.drag.currentX -= (this.settings.center && this.coordinates(0)) - this.coordinates(this.num.oItems) : this.op(this.drag.currentX, "<", this.coordinates(this.maximum())) && "left" === this.state.direction && (this.drag.currentX += (this.settings.center && this.coordinates(0)) - this.coordinates(this.num.oItems)) : (h = this.settings.rtl ? this.coordinates(this.maximum()) : this.coordinates(this.minimum()), i = this.settings.rtl ? this.coordinates(this.minimum()) : this.coordinates(this.maximum()), j = this.settings.pullDrag ? this.drag.distance / 5 : 0, this.drag.currentX = Math.max(Math.min(this.drag.currentX, h + j), i + j)), (this.drag.distance > 8 || this.drag.distance < -8) && (c.preventDefault !== d ? c.preventDefault() : c.returnValue = !1, this.state.isSwiping = !0), this.drag.updatedX = this.drag.currentX, (this.drag.currentY > 16 || this.drag.currentY < -16) && this.state.isSwiping === !1 && (this.state.isScrolling = !0, this.drag.updatedX = this.drag.start), this.animate(this.drag.updatedX)))
    }, e.prototype.onDragEnd = function() {
        var a, b, d;
        if (this.state.isTouch) {
            if ("mousedown" === this.dragType[0] && this.dom.$stage.removeClass("owl-grab"), this.trigger("dragged"), this.drag.targetEl.removeAttribute("draggable"), this.state.isTouch = !1, this.state.isScrolling = !1, this.state.isSwiping = !1, 0 === this.drag.distance && this.state.inMotion !== !0) return this.state.inMotion = !1, !1;
            this.drag.endTime = (new Date).getTime(), a = this.drag.endTime - this.drag.startTime, b = Math.abs(this.drag.distance), (b > 3 || a > 300) && this.removeClick(this.drag.targetEl), d = this.closest(this.drag.updatedX), this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed), this.current(d), this.settings.pullDrag || this.drag.updatedX !== this.coordinates(d) || this.transitionEnd(), this.drag.distance = 0, this.off(c, this.dragType[1], this.e._onDragMove), this.off(c, this.dragType[2], this.e._onDragEnd)
        }
    }, e.prototype.removeClick = function(c) {
        this.drag.targetEl = c, a(c).on("click.preventClick", this.e._preventClick), b.setTimeout(function() {
            a(c).off("click.preventClick")
        }, 300)
    }, e.prototype.preventClick = function(b) {
        b.preventDefault ? b.preventDefault() : b.returnValue = !1, b.stopPropagation && b.stopPropagation(), a(b.target).off("click.preventClick")
    }, e.prototype.getTransformProperty = function() {
        var a, c;
        return a = b.getComputedStyle(this.dom.stage, null).getPropertyValue(this.vendorName + "transform"), a = a.replace(/matrix(3d)?\(|\)/g, "").split(","), c = 16 === a.length, c !== !0 ? a[4] : a[12]
    }, e.prototype.closest = function(b) {
        var c = 0,
            d = 30;
        return this.settings.freeDrag || a.each(this.coordinates(), a.proxy(function(a, e) {
            b > e - d && e + d > b ? c = a : this.op(b, "<", e) && this.op(b, ">", this.coordinates(a + 1) || e - this.width.el) && (c = "left" === this.state.direction ? a + 1 : a)
        }, this)), this.settings.loop || (this.op(b, ">", this.coordinates(this.minimum())) ? c = b = this.minimum() : this.op(b, "<", this.coordinates(this.maximum())) && (c = b = this.maximum())), c
    }, e.prototype.animate = function(b) {
        this.trigger("translate"), this.state.inMotion = this.speed() > 0, this.support3d ? this.dom.$stage.css({
            transform: "translate3d(" + b + "px,0px, 0px)",
            transition: this.speed() / 1e3 + "s"
        }) : this.state.isTouch ? this.dom.$stage.css({
            left: b + "px"
        }) : this.dom.$stage.animate({
            left: b
        }, this.speed() / 1e3, this.settings.fallbackEasing, a.proxy(function() {
            this.state.inMotion && this.transitionEnd()
        }, this))
    }, e.prototype.current = function(a) {
        if (a === d) return this._current;
        if (0 === this.num.oItems) return d;
        if (a = this.normalize(a), this._current === a) this.animate(this.coordinates(this._current));
        else {
            var b = this.trigger("change", {
                property: {
                    name: "position",
                    value: a
                }
            });
            b.data !== d && (a = this.normalize(b.data)), this._current = a, this.animate(this.coordinates(this._current)), this.updateActiveItems(), this.trigger("changed", {
                property: {
                    name: "position",
                    value: this._current
                }
            })
        }
        return this._current
    }, e.prototype.reset = function(a) {
        this.suppress(["change", "changed"]), this.speed(0), this.current(a), this.release(["change", "changed"])
    }, e.prototype.normalize = function(a, b) {
        if (a === d || !this.dom.$items) return d;
        if (this.settings.loop) {
            var c = this.dom.$items.length;
            a = (a % c + c) % c
        } else a = Math.max(this.minimum(), Math.min(this.maximum(), a));
        return b ? this.dom.$items.eq(a).data("owl-item").index : a
    }, e.prototype.maximum = function() {
        var b, c, d = this.settings;
        if (!d.loop && d.center) b = this.num.oItems - 1;
        else if (d.loop || d.center)
            if (d.loop || d.center) b = this.num.oItems + d.items;
            else {
                if (!d.autoWidth && !d.merge) throw "Can not detect maximum absolute position.";
                revert = d.rtl ? 1 : -1, c = this.dom.$stage.width() - this.$el.width(), a.each(this.coordinates(), function(a, d) {
                    return d * revert >= c ? !1 : void(b = a + 1)
                })
            }
        else b = this.num.oItems - d.items;
        return b
    }, e.prototype.minimum = function() {
        return this.dom.$oItems.eq(0).data("owl-item").indexAbs
    }, e.prototype.speed = function(a) {
        return a !== d && (this._speed = a), this._speed
    }, e.prototype.coordinates = function(a) {
        return a !== d ? this._coordinates[a] : this._coordinates
    }, e.prototype.duration = function(a, b, c) {
        return Math.min(Math.max(Math.abs(b - a), 1), 6) * Math.abs(c || this.settings.smartSpeed)
    }, e.prototype.to = function(c, d) {
        if (this.settings.loop) {
            var e = c - this.normalize(this.current(), !0),
                f = this.current(),
                g = this.current(),
                h = this.current() + e,
                i = 0 > g - h ? !0 : !1;
            h < this.settings.items && i === !1 ? (f = this.num.items - (this.settings.items - g) - this.settings.items, this.reset(f)) : h >= this.num.items - this.settings.items && i === !0 && (f = g - this.num.oItems, this.reset(f)), b.clearTimeout(this.e._goToLoop), this.e._goToLoop = b.setTimeout(a.proxy(function() {
                this.speed(this.duration(this.current(), f + e, d)), this.current(f + e)
            }, this), 30)
        } else this.speed(this.duration(this.current(), c, d)), this.current(c)
    }, e.prototype.next = function(a) {
        a = a || !1, this.to(this.normalize(this.current(), !0) + 1, a)
    }, e.prototype.prev = function(a) {
        a = a || !1, this.to(this.normalize(this.current(), !0) - 1, a)
    }, e.prototype.transitionEnd = function(a) {
        if (a !== d) {
            a.stopPropagation();
            var b = a.target || a.srcElement || a.originalTarget;
            if (b !== this.dom.stage) return !1
        }
        this.state.inMotion = !1, this.trigger("translated")
    }, e.prototype.isElWidthChanged = function() {
        var a = this.dom.$el.width() - this.settings.stagePadding,
            b = this.width.el + this.settings.margin;
        return a !== b
    }, e.prototype.viewport = function() {
        var d;
        if (this.options.responsiveBaseElement !== b) d = a(this.options.responsiveBaseElement).width();
        else if (b.innerWidth) d = b.innerWidth;
        else {
            if (!c.documentElement || !c.documentElement.clientWidth) throw "Can not detect viewport width.";
            d = c.documentElement.clientWidth
        }
        return d
    }, e.prototype.insertContent = function(a) {
        this.dom.$stage.empty(), this.fetchContent(a), this.refresh()
    }, e.prototype.addItem = function(a, b) {
        var c = this.createItemContainer();
        b = b || 0, this.initializeItemContainer(c, a), 0 === this.dom.$oItems.length ? this.dom.$stage.append(c) : -1 !== p ? this.dom.$oItems.eq(b).before(c) : this.dom.$oItems.eq(b).after(c), this.refresh()
    }, e.prototype.removeItem = function(a) {
        this.dom.$oItems.eq(a).remove(), this.refresh()
    }, e.prototype.addTriggerableEvents = function() {
        var b = a.proxy(function(b, c) {
            return a.proxy(function(a) {
                a.relatedTarget !== this && (this.suppress([c]), b.apply(this, [].slice.call(arguments, 1)), this.release([c]))
            }, this)
        }, this);
        a.each({
            next: this.next,
            prev: this.prev,
            to: this.to,
            destroy: this.destroy,
            refresh: this.refresh,
            replace: this.insertContent,
            add: this.addItem,
            remove: this.removeItem
        }, a.proxy(function(a, c) {
            this.dom.$el.on(a + ".owl.carousel", b(c, a + ".owl.carousel"))
        }, this))
    }, e.prototype.watchVisibility = function() {
        function c(a) {
            return a.offsetWidth > 0 && a.offsetHeight > 0
        }

        function d() {
            c(this.dom.el) && (this.dom.$el.removeClass("owl-hidden"), this.refresh(), b.clearInterval(this.e._checkVisibile))
        }
        c(this.dom.el) || (this.dom.$el.addClass("owl-hidden"), b.clearInterval(this.e._checkVisibile), this.e._checkVisibile = b.setInterval(a.proxy(d, this), 500))
    }, e.prototype.preloadAutoWidthImages = function(b) {
        var c, d, e, f;
        c = 0, d = this, b.each(function(g, h) {
            e = a(h), f = new Image, f.onload = function() {
                c++, e.attr("src", f.src), e.css("opacity", 1), c >= b.length && (d.state.imagesLoaded = !0, d.init())
            }, f.src = e.attr("src") || e.attr("data-src") || e.attr("data-src-retina")
        })
    }, e.prototype.destroy = function() {
        this.dom.$el.hasClass(this.settings.themeClass) && this.dom.$el.removeClass(this.settings.themeClass), this.settings.responsive !== !1 && this.off(b, "resize", this.e._resizer), this.transitionEndVendor && this.off(this.dom.stage, this.transitionEndVendor, this.e._transitionEnd);
        for (var a in this.plugins) this.plugins[a].destroy();
        (this.settings.mouseDrag || this.settings.touchDrag) && (this.off(this.dom.stage, this.dragType[0], this.e._onDragStart), this.settings.mouseDrag && this.off(c, this.dragType[3], this.e._onDragStart), this.settings.mouseDrag && (this.dom.$stage.off("dragstart", function() {
            return !1
        }), this.dom.stage.onselectstart = function() {})), this.dom.$el.off(".owl"), null !== this.dom.$cItems && this.dom.$cItems.remove(), this.e = null, this.dom.$el.data("owlCarousel", null), delete this.dom.el.owlCarousel, this.dom.$stage.unwrap(), this.dom.$items.unwrap(), this.dom.$items.contents().unwrap(), this.dom = null;
    }, e.prototype.op = function(a, b, c) {
        var d = this.settings.rtl;
        switch (b) {
            case "<":
                return d ? a > c : c > a;
            case ">":
                return d ? c > a : a > c;
            case ">=":
                return d ? c >= a : a >= c;
            case "<=":
                return d ? a >= c : c >= a
        }
    }, e.prototype.on = function(a, b, c, d) {
        a.addEventListener ? a.addEventListener(b, c, d) : a.attachEvent && a.attachEvent("on" + b, c)
    }, e.prototype.off = function(a, b, c, d) {
        a.removeEventListener ? a.removeEventListener(b, c, d) : a.detachEvent && a.detachEvent("on" + b, c)
    }, e.prototype.trigger = function(b, c, d) {
        var e = {
                item: {
                    count: this.num.oItems,
                    index: this.current()
                }
            },
            f = a.camelCase(a.grep(["on", b, d], function(a) {
                return a
            }).join("-").toLowerCase()),
            g = a.Event([b, "owl", d || "carousel"].join(".").toLowerCase(), a.extend({
                relatedTarget: this
            }, e, c));
        return this._supress[g.type] || (a.each(this.plugins, function(a, b) {
            b.onTrigger && b.onTrigger(g)
        }), this.dom.$el.trigger(g), "function" == typeof this.settings[f] && this.settings[f].apply(this, g)), g
    }, e.prototype.suppress = function(b) {
        a.each(b, a.proxy(function(a, b) {
            this._supress[b] = !0
        }, this))
    }, e.prototype.release = function(b) {
        a.each(b, a.proxy(function(a, b) {
            delete this._supress[b]
        }, this))
    }, e.prototype.browserSupport = function() {
        if (this.support3d = i(), this.support3d) {
            this.transformVendor = h();
            var a = ["transitionend", "webkitTransitionEnd", "transitionend", "oTransitionEnd"];
            this.transitionEndVendor = a[g()], this.vendorName = this.transformVendor.replace(/Transform/i, ""), this.vendorName = "" !== this.vendorName ? "-" + this.vendorName.toLowerCase() + "-" : ""
        }
        this.state.orientation = b.orientation
    }, a.fn.owlCarousel = function(b) {
        return this.each(function() {
            a(this).data("owlCarousel") || a(this).data("owlCarousel", new e(this, b))
        })
    }, a.fn.owlCarousel.Constructor = e
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
    LazyLoad = function(b) {
        this.owl = b, this.owl.options = a.extend({}, LazyLoad.Defaults, this.owl.options), this.handlers = {
            "changed.owl.carousel": a.proxy(function(a) {
                "items" == a.property.name && a.property.value && !a.property.value.is(":empty") && this.check()
            }, this)
        }, this.owl.dom.$el.on(this.handlers)
    }, LazyLoad.Defaults = {
        lazyLoad: !1
    }, LazyLoad.prototype.check = function() {
        var a, c, d, e, f = b.devicePixelRatio > 1 ? "data-src-retina" : "data-src";
        for (d = 0; d < this.owl.num.items; d++) e = this.owl.dom.$items.eq(d), e.data("owl-item").current === !0 && e.data("owl-item").loaded === !1 && (c = e.find(".owl-lazy"), a = c.attr(f), a = a || c.attr("data-src"), a && (c.css("opacity", "0"), this.preload(c, e)))
    }, LazyLoad.prototype.preload = function(c, d) {
        var e, f, g;
        c.each(a.proxy(function(c, h) {
            this.owl.trigger("load", null, "lazy"), e = a(h), f = new Image, g = b.devicePixelRatio > 1 ? e.attr("data-src-retina") : e.attr("data-src"), g = g || e.attr("data-src"), f.onload = a.proxy(function() {
                d.data("owl-item").loaded = !0, e.is("img") ? e.attr("src", f.src) : e.css("background-image", "url(" + f.src + ")"), e.css("opacity", 1), this.owl.trigger("loaded", null, "lazy")
            }, this), f.src = g
        }, this))
    }, LazyLoad.prototype.destroy = function() {
        var a, b;
        for (a in this.handlers) this.owl.dom.$el.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.lazyLoad = LazyLoad
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
    AutoHeight = function(b) {
        this.owl = b, this.owl.options = a.extend({}, AutoHeight.Defaults, this.owl.options), this.handlers = {
            "changed.owl.carousel": a.proxy(function(a) {
                "position" == a.property.name && this.owl.settings.autoHeight && this.setHeight()
            }, this)
        }, this.owl.dom.$el.on(this.handlers)
    }, AutoHeight.Defaults = {
        autoHeight: !1,
        autoHeightClass: "owl-height"
    }, AutoHeight.prototype.setHeight = function() {
        var a, c = this.owl.dom.$items.eq(this.owl.current()),
            d = this.owl.dom.$oStage,
            e = 0;
        this.owl.dom.$oStage.hasClass(this.owl.settings.autoHeightClass) || this.owl.dom.$oStage.addClass(this.owl.settings.autoHeightClass), a = b.setInterval(function() {
            e += 1, c.data("owl-item").loaded ? (d.height(c.height() + "px"), clearInterval(a)) : 500 === e && clearInterval(a)
        }, 100)
    }, AutoHeight.prototype.destroy = function() {
        var a, b;
        for (a in this.handlers) this.owl.dom.$el.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.autoHeight = AutoHeight
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
    Video = function(b) {
        this.owl = b, this.owl.options = a.extend({}, Video.Defaults, this.owl.options), this.handlers = {
            "resize.owl.carousel": a.proxy(function(a) {
                this.owl.settings.video && !this.isInFullScreen() && a.preventDefault()
            }, this),
            "refresh.owl.carousel changed.owl.carousel": a.proxy(function(a) {
                this.owl.state.videoPlay && this.stopVideo()
            }, this),
            "refresh.owl.carousel refreshed.owl.carousel": a.proxy(function(a) {
                return this.owl.settings.video ? void(this.refreshing = "refresh" == a.type) : !1
            }, this),
            "changed.owl.carousel": a.proxy(function(a) {
                this.refreshing && "items" == a.property.name && a.property.value && !a.property.value.is(":empty") && this.checkVideoLinks()
            }, this)
        }, this.owl.dom.$el.on(this.handlers), this.owl.dom.$el.on("click.owl.video", ".owl-video-play-icon", a.proxy(function(a) {
            this.playVideo(a)
        }, this))
    }, Video.Defaults = {
        video: !1,
        videoHeight: !1,
        videoWidth: !1
    }, Video.prototype.checkVideoLinks = function() {
        var a, b, c;
        for (c = 0; c < this.owl.num.items; c++) b = this.owl.dom.$items.eq(c), b.data("owl-item").hasVideo || (a = b.find(".owl-video"), a.length && (this.owl.state.hasVideos = !0, this.owl.dom.$items.eq(c).data("owl-item").hasVideo = !0, a.css("display", "none"), this.getVideoInfo(a, b)))
    }, Video.prototype.getVideoInfo = function(a, b) {
        var c, d, e, f, g = a.data("vimeo-id"),
            h = a.data("youtube-id"),
            i = a.data("width") || this.owl.settings.videoWidth,
            j = a.data("height") || this.owl.settings.videoHeight,
            k = a.attr("href");
        if (g) d = "vimeo", e = g;
        else if (h) d = "youtube", e = h;
        else {
            if (!k) throw new Error("Missing video link.");
            e = k.match(/(http:|https:|)\/\/(player.|www.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com))\/(video\/|embed\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/), e[3].indexOf("youtu") > -1 ? d = "youtube" : e[3].indexOf("vimeo") > -1 && (d = "vimeo"), e = e[6]
        }
        b.data("owl-item").videoType = d, b.data("owl-item").videoId = e, b.data("owl-item").videoWidth = i, b.data("owl-item").videoHeight = j, c = {
            type: d,
            id: e
        }, f = i && j ? 'style="width:' + i + "px;height:" + j + 'px;"' : "", a.wrap('<div class="owl-video-wrapper"' + f + "></div>"), this.createVideoTn(a, c)
    }, Video.prototype.createVideoTn = function(b, c) {
        function d(a) {
            f = '<div class="owl-video-play-icon"></div>', e = k.settings.lazyLoad ? '<div class="owl-video-tn ' + j + '" ' + i + '="' + a + '"></div>' : '<div class="owl-video-tn" style="opacity:1;background-image:url(' + a + ')"></div>', b.after(e), b.after(f)
        }
        var e, f, g, h = b.find("img"),
            i = "src",
            j = "",
            k = this.owl;
        return this.owl.settings.lazyLoad && (i = "data-src", j = "owl-lazy"), h.length ? (d(h.attr(i)), h.remove(), !1) : void("youtube" === c.type ? (g = "http://img.youtube.com/vi/" + c.id + "/hqdefault.jpg", d(g)) : "vimeo" === c.type && a.ajax({
            type: "GET",
            url: "http://vimeo.com/api/v2/video/" + c.id + ".json",
            jsonp: "callback",
            dataType: "jsonp",
            success: function(a) {
                g = a[0].thumbnail_large, d(g), k.settings.loop && k.updateActiveItems()
            }
        }))
    }, Video.prototype.stopVideo = function() {
        this.owl.trigger("stop", null, "video");
        var a = this.owl.dom.$items.eq(this.owl.state.videoPlayIndex);
        a.find(".owl-video-frame").remove(), a.removeClass("owl-video-playing"), this.owl.state.videoPlay = !1
    }, Video.prototype.playVideo = function(b) {
        this.owl.trigger("play", null, "video"), this.owl.state.videoPlay && this.stopVideo();
        var c, d, e, f = a(b.target || b.srcElement),
            g = f.closest("." + this.owl.settings.itemClass);
        e = g.data("owl-item").videoType, id = g.data("owl-item").videoId, width = g.data("owl-item").videoWidth || Math.floor(g.data("owl-item").width - this.owl.settings.margin), height = g.data("owl-item").videoHeight || this.owl.dom.$stage.height(), "youtube" === e ? c = '<iframe width="' + width + '" height="' + height + '" src="http://www.youtube.com/embed/' + id + "?autoplay=1&v=" + id + '" frameborder="0" allowfullscreen></iframe>' : "vimeo" === e && (c = '<iframe src="http://player.vimeo.com/video/' + id + '?autoplay=1" width="' + width + '" height="' + height + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>'), g.addClass("owl-video-playing"), this.owl.state.videoPlay = !0, this.owl.state.videoPlayIndex = g.data("owl-item").indexAbs, d = a('<div style="height:' + height + "px; width:" + width + 'px" class="owl-video-frame">' + c + "</div>"), f.after(d)
    }, Video.prototype.isInFullScreen = function() {
        var d = c.fullscreenElement || c.mozFullScreenElement || c.webkitFullscreenElement;
        return d && a(d.parentNode).hasClass("owl-video-frame") && (this.owl.speed(0), this.owl.state.isFullScreen = !0), d && this.owl.state.isFullScreen && this.owl.state.videoPlay ? !1 : this.owl.state.isFullScreen ? (this.owl.state.isFullScreen = !1, !1) : this.owl.state.videoPlay && this.owl.state.orientation !== b.orientation ? (this.owl.state.orientation = b.orientation, !1) : !0
    }, Video.prototype.destroy = function() {
        var a, b;
        this.owl.dom.$el.off("click.owl.video");
        for (a in this.handlers) this.owl.dom.$el.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.video = Video
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
    Animate = function(b) {
        this.core = b, this.core.options = a.extend({}, Animate.Defaults, this.core.options), this.swapping = !0, this.previous = d, this.next = d, this.handlers = {
            "change.owl.carousel": a.proxy(function(a) {
                "position" == a.property.name && (this.previous = this.core.current(), this.next = a.property.value)
            }, this),
            "drag.owl.carousel dragged.owl.carousel translated.owl.carousel": a.proxy(function(a) {
                this.swapping = "translated" == a.type
            }, this),
            "translate.owl.carousel": a.proxy(function(a) {
                this.swapping && (this.core.options.animateOut || this.core.options.animateIn) && this.swap()
            }, this)
        }, this.core.dom.$el.on(this.handlers)
    }, Animate.Defaults = {
        animateOut: !1,
        animateIn: !1
    }, Animate.prototype.swap = function() {
        if (1 === this.core.settings.items && this.core.support3d) {
            this.core.speed(0);
            var b, c = a.proxy(this.clear, this),
                d = this.core.dom.$items.eq(this.previous),
                e = this.core.dom.$items.eq(this.next),
                f = this.core.settings.animateIn,
                g = this.core.settings.animateOut;
            this.core.current() !== this.previous && (g && (b = this.core.coordinates(this.previous) - this.core.coordinates(this.next), d.css({
                left: b + "px"
            }).addClass("animated owl-animated-out").addClass(g).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", c)), f && e.addClass("animated owl-animated-in").addClass(f).one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", c))
        }
    }, Animate.prototype.clear = function(b) {
        a(b.target).css({
            left: ""
        }).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut), this.core.transitionEnd()
    }, Animate.prototype.destroy = function() {
        var a, b;
        for (a in this.handlers) this.core.dom.$el.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this)) "function" != typeof this[b] && (this[b] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.Animate = Animate
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
    Autoplay = function(b) {
        this.core = b, this.core.options = a.extend({}, Autoplay.Defaults, this.core.options), this.handlers = {
            "translated.owl.carousel refreshed.owl.carousel": a.proxy(function() {
                this.autoplay()
            }, this),
            "play.owl.autoplay": a.proxy(function(a, b, c) {
                this.play(b, c)
            }, this),
            "stop.owl.autoplay": a.proxy(function() {
                this.stop()
            }, this),
            "mouseover.owl.autoplay": a.proxy(function() {
                this.core.settings.autoplayHoverPause && this.pause()
            }, this),
            "mouseleave.owl.autoplay": a.proxy(function() {
                this.core.settings.autoplayHoverPause && this.autoplay()
            }, this)
        }, this.core.dom.$el.on(this.handlers)
    }, Autoplay.Defaults = {
        autoplay: !1,
        autoplayTimeout: 5e3,
        autoplayHoverPause: !1,
        autoplaySpeed: !1
    }, Autoplay.prototype.autoplay = function() {
        this.core.settings.autoplay && !this.core.state.videoPlay ? (b.clearInterval(this.interval), this.interval = b.setInterval(a.proxy(function() {
            this.play()
        }, this), this.core.settings.autoplayTimeout)) : b.clearInterval(this.interval)
    }, Autoplay.prototype.play = function(a, d) {
        return c.hidden === !0 || this.core.state.isTouch || this.core.state.isScrolling || this.core.state.isSwiping || this.core.state.inMotion ? void 0 : this.core.settings.autoplay === !1 ? void b.clearInterval(this.interval) : void this.core.next(this.core.settings.autoplaySpeed)
    }, Autoplay.prototype.stop = function() {
        b.clearInterval(this.interval)
    }, Autoplay.prototype.pause = function() {
        b.clearInterval(this.interval)
    }, Autoplay.prototype.destroy = function() {
        var a, c;
        b.clearInterval(this.interval);
        for (a in this.handlers) this.core.dom.$el.off(a, this.handlers[a]);
        for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.autoplay = Autoplay
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
    "use strict";
    var e = function(b) {
        this.core = b, this.initialized = !1, this.pages = [], this.controls = {}, this.template = null, this.$element = this.core.dom.$el, this.overrides = {
            next: this.core.next,
            prev: this.core.prev,
            to: this.core.to
        }, this.handlers = {
            "changed.owl.carousel": a.proxy(function(b) {
                "items" == b.property.name && (this.initialized || (this.initialize(), this.initialized = !0), this.update(), this.draw()), this.filling && (b.property.value.data("owl-item").dot = a(":first-child", b.property.value).find("[data-dot]").andSelf().data("dot"))
            }, this),
            "change.owl.carousel": a.proxy(function(a) {
                if ("position" == a.property.name && !this.core.state.revert && !this.core.settings.loop && this.core.settings.navRewind) {
                    var b = this.core.current(),
                        c = this.core.maximum(),
                        d = this.core.minimum();
                    a.data = a.property.value > c ? b >= c ? d : c : a.property.value < d ? c : a.property.value
                }
                this.filling = this.core.settings.dotsData && "item" == a.property.name && a.property.value && a.property.value.is(":empty")
            }, this),
            "refreshed.owl.carousel": a.proxy(function() {
                this.initialized && (this.update(), this.draw())
            }, this)
        }, this.core.options = a.extend({}, e.Defaults, this.core.options), this.$element.on(this.handlers)
    };
    e.Defaults = {
        nav: !1,
        navRewind: !0,
        navText: ["prev", "next"],
        navSpeed: !1,
        navElement: "div",
        navContainer: !1,
        navContainerClass: "owl-nav",
        navClass: ["owl-prev", "owl-next"],
        slideBy: 1,
        dotClass: "owl-dot",
        dotsClass: "owl-dots",
        dots: !0,
        dotsEach: !1,
        dotData: !1,
        dotsSpeed: !1,
        dotsContainer: !1,
        controlsClass: "owl-controls"
    }, e.prototype.initialize = function() {
        var b, c, d = this.core.settings;
        d.dotsData || (this.template = a("<div>").addClass(d.dotClass).append(a("<span>")).prop("outerHTML")), d.navContainer && d.dotsContainer || (this.controls.$container = a("<div>").addClass(d.controlsClass).appendTo(this.$element)), this.controls.$indicators = d.dotsContainer ? a(d.dotsContainer) : a("<div>").hide().addClass(d.dotsClass).appendTo(this.controls.$container), this.controls.$indicators.on(this.core.dragType[2], "div", a.proxy(function(b) {
            var c = a(b.target).parent().is(this.controls.$indicators) ? a(b.target).index() : a(b.target).parent().index();
            b.preventDefault(), this.to(c, d.dotsSpeed)
        }, this)), b = d.navContainer ? a(d.navContainer) : a("<div>").addClass(d.navContainerClass).prependTo(this.controls.$container), this.controls.$next = a("<" + d.navElement + ">"), this.controls.$previous = this.controls.$next.clone(), this.controls.$previous.addClass(d.navClass[0]).html(d.navText[0]).hide().prependTo(b).on(this.core.dragType[2], a.proxy(function(a) {
            this.prev()
        }, this)), this.controls.$next.addClass(d.navClass[1]).html(d.navText[1]).hide().appendTo(b).on(this.core.dragType[2], a.proxy(function(a) {
            this.next()
        }, this));
        for (c in this.overrides) this.core[c] = a.proxy(this[c], this)
    }, e.prototype.destroy = function() {
        var a, b, c, d;
        for (a in this.handlers) this.$element.off(a, this.handlers[a]);
        for (b in this.controls) this.controls[b].remove();
        for (d in this.overides) this.core[d] = this.overrides[d];
        for (c in Object.getOwnPropertyNames(this)) "function" != typeof this[c] && (this[c] = null)
    }, e.prototype.update = function() {
        var a, b, c, d = this.core.settings,
            e = this.core.num.cItems / 2,
            f = this.core.num.items - e,
            g = d.center || d.autoWidth || d.dotData ? 1 : d.dotsEach || d.items;
        if ("page" !== d.slideBy && (d.slideBy = Math.min(d.slideBy, d.items)), d.dots)
            for (this.pages = [], a = e, b = 0, c = 0; f > a; a++)(b >= g || 0 === b) && (this.pages.push({
                start: a - e,
                end: a - e + g - 1
            }), b = 0, ++c), b += this.core.num.merged[a]
    }, e.prototype.draw = function() {
        var b, c, d = "",
            e = this.core.settings,
            f = this.core.dom.$oItems,
            g = this.core.normalize(this.core.current(), !0);
        if (!e.nav || e.loop || e.navRewind || (this.controls.$previous.toggleClass("disabled", 0 >= g), this.controls.$next.toggleClass("disabled", g >= this.core.maximum())), this.controls.$previous.toggle(e.nav), this.controls.$next.toggle(e.nav), e.dots) {
            if (b = this.pages.length - this.controls.$indicators.children().length, b > 0) {
                for (c = 0; c < Math.abs(b); c++) d += e.dotData ? f.eq(c).data("owl-item").dot : this.template;
                this.controls.$indicators.append(d)
            } else 0 > b && this.controls.$indicators.children().slice(b).remove();
            this.controls.$indicators.find(".active").removeClass("active"), this.controls.$indicators.children().eq(a.inArray(this.current(), this.pages)).addClass("active")
        }
        this.controls.$indicators.toggle(e.dots)
    }, e.prototype.onTrigger = function(b) {
        var c = this.core.settings;
        b.page = {
            index: a.inArray(this.current(), this.pages),
            count: this.pages.length,
            size: c.center || c.autoWidth || c.dotData ? 1 : c.dotsEach || c.items
        }
    }, e.prototype.current = function() {
        var b = this.core.normalize(this.core.current(), !0);
        return a.grep(this.pages, function(a) {
            return a.start <= b && a.end >= b
        }).pop()
    }, e.prototype.getPosition = function(b) {
        var c, d, e = this.core.settings;
        return "page" == e.slideBy ? (c = a.inArray(this.current(), this.pages), d = this.pages.length, b ? ++c : --c, c = this.pages[(c % d + d) % d].start) : (c = this.core.normalize(this.core.current(), !0), d = this.core.num.oItems, b ? c += e.slideBy : c -= e.slideBy), c
    }, e.prototype.next = function(b) {
        a.proxy(this.overrides.to, this.core)(this.getPosition(!0), b)
    }, e.prototype.prev = function(b) {
        a.proxy(this.overrides.to, this.core)(this.getPosition(!1), b)
    }, e.prototype.to = function(b, c, d) {
        var e;
        d ? a.proxy(this.overrides.to, this.core)(b, c) : (e = this.pages.length, a.proxy(this.overrides.to, this.core)(this.pages[(b % e + e) % e].start, c))
    }, a.fn.owlCarousel.Constructor.Plugins.Navigation = e
}(window.Zepto || window.jQuery, window, document),
function(a, b, c, d) {
    "use strict";
    var e = function(c) {
        this.core = c, this.hashes = {}, this.$element = this.core.dom.$el, this.handlers = {
            "initialized.owl.carousel": a.proxy(function() {
                b.location.hash.substring(1) && a(b).trigger("hashchange.owl.navigation")
            }, this),
            "changed.owl.carousel": a.proxy(function(b) {
                this.filling && (b.property.value.data("owl-item").hash = a(":first-child", b.property.value).find("[data-hash]").andSelf().data("hash"), this.hashes[b.property.value.data("owl-item").hash] = b.property.value)
            }, this),
            "change.owl.carousel": a.proxy(function(a) {
                "position" == a.property.name && this.core.current() === d && "URLHash" == this.core.settings.startPosition && (a.data = this.hashes[b.location.hash.substring(1)]), this.filling = "item" == a.property.name && a.property.value && a.property.value.is(":empty")
            }, this)
        }, this.core.options = a.extend({}, e.Defaults, this.core.options), this.$element.on(this.handlers), a(b).on("hashchange.owl.navigation", a.proxy(function() {
            var a = b.location.hash.substring(1),
                c = this.core.dom.$oItems,
                d = this.hashes[a] && c.index(this.hashes[a]) || 0;
            return a ? (this.core.dom.oStage.scrollLeft = 0, void this.core.to(d, !1, !0)) : !1
        }, this))
    };
    e.Defaults = {
        URLhashListener: !1
    }, e.prototype.destroy = function() {
        var c, d;
        a(b).off("hashchange.owl.navigation");
        for (c in this.handlers) this.owl.dom.$el.off(c, this.handlers[c]);
        for (d in Object.getOwnPropertyNames(this)) "function" != typeof this[d] && (this[d] = null)
    }, a.fn.owlCarousel.Constructor.Plugins.Hash = e
}(window.Zepto || window.jQuery, window, document),
function(a) {
    "use strict";
    var b = {
            init: function() {
                this.quickview(), this.addToCart(), this.addToCartFromQuickview(), this.addToCartFromWishlist(), this.addToCartFromProductPage(), this.removeFromCart(), this.addToWishlist(), this.removeFromWishlist(), this.zoomImage(), this.switchImage(), this.buttonQuantity(".is-product .quantity"), this.buttonQuantityEvent(), this.variantOptions()
            },
            getRating: function() {
                var b = a("script[src^='//productreviews.shopifycdn.com']");
                b.remove(), a("head").append(b)
            },
            buttonQuantity: function(b) {
                a(b).prepend('<span class="btn btn-default qty-ctrl qty-minus">-</span>').append('<span class="btn btn-default qty-ctrl qty-plus">+</span>')
            },
            buttonQuantityEvent: function() {
                a("body").delegate(".quantity .qty-plus", "click", function() {
                    var b = a(this).prev(),
                        c = b.val();
                    c = parseInt(c), b.val(c + 1)
                }).delegate(".quantity .qty-minus", "click", function() {
                    var b = a(this).next(),
                        c = b.val();
                    c = parseInt(c), c > 1 && b.val(c - 1)
                })
            },
            quickview: function() {
                var c = this;
                a("#is-content").on("click", ".quickview", function() {
                    var d = a(this),
                        f = d.data("product-handle");
                    return a.ajax({
                        url: "/products/" + f + ".js",
                        type: "GET",
                        dataType: "json",
                        beforeSend: function() {
                            d.addClass("loading"), b.quickviewRefresh()
                        },
                        success: function(f) {
                            var g = _.template(a("#product-quickview").html())({
                                data: f,
                                description: e(f.description, 30) + " ...",
                                price: Shopify.formatMoney(f.price, moneyFormat)
                            });
                            a.magnificPopup.open({
                                items: {
                                    src: g,
                                    type: "inline"
                                }
                            });
                            f.available, f.options.length, f.options[0].name, f.variants.length, f.variants[0].title;
                            c.variantOptions({
                                from: "quickview",
                                productJson: f,
                                productAvailable: f.available,
                                productOptionsSize: f.options.length,
                                productOptionsTitle: f.options[0].name,
                                variantSize: f.variants.length,
                                variantTitle: f.variants[0].title
                            }), d.removeClass("loading"), b.quickviewSlide(), b.quickviewImage()
                        }
                    }), !1
                })
            },
            quickviewSlide: function() {
                a(".quickview-slides").owlCarousel({
                    nav: !1,
                    dots: !1,
                    items: 4,
//                    loop: true,
//                    autoplay:true,
//                    autoplayTimeout:3000,
//                    autoplayHoverPause:true,
                })
            },
            quickviewImage: function() {
                a(".quickview-slides .item").on("click", function() {
                    var b = a(this),
                        c = b.find("img").attr("src");
                    return a(".quickview-slides .item").removeClass("active"), b.addClass("active"), a(".product-quickview .image-thumb img").attr("src", c), !1
                })
            },
            quickviewRefresh: function() {
                a(".product-quickview .quickview-slides").remove(), a(".product-quickview .images").append('<div class="quickview-slides row owl-theme owl-carousel"></div>')
            },
            addToCart: function() {
                var b = this;
                a("#is-content").on("click", ".add_to_cart_button", function() {
                    var c = a(this),
                        d = c.data("product-id");
                    return a.ajax({
                        url: "/cart/add.js",
                        type: "POST",
                        data: {
                            quantity: 1,
                            id: d
                        },
                        dataType: "json",
                        beforeSend: function() {
                            c.addClass("loading")
                        },
                        success: function(a) {
                            c.removeClass("loading"), b.updateCartCanvas(), b.cartFlyImage(c.closest(".product-block").find(".image img").first())
                        }
                    }), !1
                })
            },
            cartFlyImage: function(b) {
                var c = b,
                    d = a(".shoppingcart"),
                    e = c.clone().offset({
                        top: c.offset().top,
                        left: c.offset().left
                    }).css({
                        opacity: "0.7",
                        position: "absolute",
                        height: "150px",
                        width: "150px",
                        "z-index": "9999"
                    }).appendTo(a("body")).animate({
                        top: d.offset().top - 10,
                        left: d.offset().left + 15,
                        width: 30,
                        height: 30
                    }, 1e3);
                e.animate({
                    opacity: 0
                }, function() {
                    a(this).detach()
                })
            },
            addToCartFromQuickview: function() {
                var b = this;
                a("body").on("click", ".product-quickview .quickview_add_to_cart_button", function(c) {
                    c.preventDefault();
                    var d = a(this);
                    return a.ajax({
                        url: "/cart/add.js",
                        type: "POST",
                        data: d.parents("form.quickview-add-to-cart").serialize(),
                        dataType: "json",
                        beforeSend: function() {
                            d.addClass("loading")
                        },
                        success: function(c) {
                            var e = '<a class="button viewcart" href="/cart">View cart</a>';
                            d.removeClass("loading"), a(".product-quickview .button").hasClass("viewcart") || d.parents("form.quickview-add-to-cart").append(e), b.updateCartCanvas()
                        }
                    }), !1
                })
            },
            addToCartFromProductPage: function() {
                var b = this;
                a("#is-content").on("click", ".cart_add_to_cart_button", function(c) {
                    c.preventDefault();
                    var d = a(this);
                    return a.ajax({
                        url: "/cart/add.js",
                        type: "POST",
                        data: d.parents("form#AddToCartForm").serialize(),
                        dataType: "json",
                        beforeSend: function() {
                            d.addClass("loading")
                        },
                        success: function(c) {
                            var e = '<a href="/cart">View cart</a>';
                            d.removeClass("loading"), d.parents("form#AddToCartForm").append(e), b.updateCartCanvas(), b.cartFlyImage(a("#ProductPhotoImg"))
                        }
                    }), !1
                })
            },
            addToCartFromWishlist: function() {
                var b = this;
                a(".wishlist_add_to_cart_button").on("click", function() {
                    var c = a(this),
                        d = c.data("product-id"),
                        e = c.data("customer-email"),
                        f = c.data("customer-tags"),
                        g = c.closest("td").siblings("td.product-name").find("img");
                    return a.ajax({
                        url: "/cart/add.js",
                        type: "POST",
                        data: {
                            quantity: 1,
                            id: d
                        },
                        dataType: "json",
                        beforeSend: function() {},
                        success: function(d) {
                            b.updateCartCanvas(), b.cartFlyImage(g), a.ajax({
                                url: "/contact",
                                type: "POST",
                                data: {
                                    contact: {
                                        email: e,
                                        tags: f
                                    },
                                    form_type: "customer",
                                    utf8: "✓"
                                },
                                dataType: "json",
                                beforeSend: function() {},
                                complete: function(b) {
                                    c.closest(".wishlist-item").remove(), 0 == a(".wishlist_table .wishlist-item").length && a(".wishlist_table .empty-product").removeClass("hidden")
                                }
                            })
                        }
                    }), !1
                })
            },
            removeFromCart: function() {
                var b = this;
                a("#is_cart_canvas").on("click", ".is_product_remove", function(c) {
                    c.preventDefault();
                    var d = a(this).data("product-id");
                    a.ajax({
                        url: "/cart/change.js",
                        type: "POST",
                        data: {
                            id: d,
                            quantity: 0
                        },
                        dataType: "json",
                        beforeSend: function() {},
                        success: function(a) {
                            b.updateCartCanvas()
                        }
                    })
                })
            },
            updateCartCanvas: function(b) {
                var c = this;
                void 0 == b ? a.ajax({
                    url: "/cart.js",
                    type: "GET",
                    dataType: "json",
                    beforeSend: function() {},
                    success: function(b) {
                        c.createCartCanvasItem(b), a(".shoppingcart .count").text(b.item_count)
                    }
                }) : c.createCartCanvasItem(b)
            },
            createCartCanvasItem: function(b) {
                var c = '<li class="empty">No product in the cart</li>',
                    d = '<li class="media"><a href="{url}" class="cart-image pull-left"><img src="{image}" /></a><div class="cart-main-content media-body"><div class="name"><a href="{url}">{title}</a></div><p class="cart-item"><span class="quantity">{quantity} × <span class="amount">{price}</span></span></p></div><a href="#" class="is_product_remove" data-product-id="{variant_id}"><i class="fa fa-close"></i></a></li>';
                if (0 == b.item_count) a("#is_cart_canvas .cart_list").html(c), a("#is_cart_canvas .cart-actions").addClass("hidden");
                else {
                    for (var e = "", f = 0; f < b.items.length; f++) {
                        var g = d;
                        g = g.replace(/\{url\}/g, b.items[f].url), g = g.replace(/\{title\}/g, b.items[f].title), g = g.replace(/\{quantity\}/g, b.items[f].quantity), g = g.replace(/\{image\}/g, Shopify.resizeImage(b.items[f].image, "small")), g = g.replace(/\{price\}/g, Shopify.formatMoney(b.items[f].price, moneyFormat)), g = g.replace(/\{variant_id\}/g, b.items[f].variant_id), e += g
                    }
                    a("#is_cart_canvas .cart_list").html(e), a("#is_cart_canvas p.total .amount").text(Shopify.formatMoney(b.total_price, moneyFormat)), a("#is_cart_canvas .cart-actions").removeClass("hidden")
                }
            },
            addToWishlist: function() {
                a("#is-content").on("click", ".add_to_wishlist_button", function(b) {
                    b.preventDefault();
                    var c = a(this),
                        d = c.data("customer-email"),
                        e = c.data("customer-tags"),
                        f = c.data("wishlist-link"),
                        g = c.data("button");
                    return "#" != c.attr("href") && (window.location.href = f), a.ajax({
                        url: "/contact",
                        type: "POST",
                        data: {
                            contact: {
                                email: d,
                                tags: e
                            },
                            form_type: "customer",
                            utf8: "✓"
                        },
                        dataType: "json",
                        beforeSend: function() {
                            c.addClass("loading")
                        },
                        complete: function(a) {
                            c.removeClass("loading"), "button" == g && (c.removeClass("add_to_wishlist_button").addClass("added"), c.attr("href", f)), "text" == g && c.parents(".wishlist-text").html('The product is added to the wishlist! <a href="/pages/">Browse Wishlist</a>')
                        }
                    }), !1
                })
            },
            removeFromWishlist: function() {
                a(".remove-from-wishlist-btn").on("click", function(b) {
                    b.preventDefault();
                    var c = a(this),
                        d = c.data("customer-email"),
                        e = c.data("customer-tags");
                    return a.ajax({
                        url: "/contact",
                        type: "POST",
                        data: {
                            contact: {
                                email: d,
                                tags: e
                            },
                            form_type: "customer",
                            utf8: "✓"
                        },
                        dataType: "json",
                        beforeSend: function() {},
                        complete: function(b) {
                            c.closest(".wishlist-item").remove(), 0 == a(".wishlist_table .wishlist-item").length && a(".wishlist_table .empty-product").removeClass("hidden")
                        }
                    }), !1
                })
            },
            switchImage: function() {
                a(".single-product .product_thumbnail_image").on("click", function(b) {
                    b.preventDefault();
                    var c = a(this),
                        d = c.attr("href"),
                        e = c.data("image-id");
                    a(".single-product .product_featured_image").attr("src", d).attr("data-zoom-image", d).attr("data-image-id", e)
                })
            },
            zoomImage: function() {
                if (a(".single-product .product_featured_image").length > 0 && void 0 != zoomOptions) {
                    var b = a(window).width(),
                        c = b > 750 ? "desktop" : "mobile";
                    "mobile" == c && (zoomOptions.zoomType = mobileZoomType), a(".product_featured_image").elevateZoom(zoomOptions);
                    var d;
                    a(window).on("resize", function(b) {
                        a(window).width() > 750 && "mobile" == c && (c = "desktop", zoomOptions.zoomType = defaultZoomType), a(window).width() <= 750 && (c = "mobile", zoomOptions.zoomType = mobileZoomType), clearTimeout(d), d = setTimeout(function() {
                            a(".zoomContainer").remove(), a(".product_featured_image").removeData("elevateZoom").removeData("zoomImage").elevateZoom(zoomOptions)
                        }, 500)
                    })
                }
            },
            variantOptions: function(b) {
                var c = this;
                "undefined" != typeof b && "undefined" != typeof b.from && "quickview" == b.from && c.variantOptionsChange(b.productJson, b.productAvailable, b.productOptionsSize, b.productOptionsTitle, b.variantSize, b.variantTitle), a("#productSelect").length > 0 && "undefined" != typeof productJson && c.variantOptionsChange(productJson, productAvailable, productOptionsSize, productOptionsTitle, variantSize, variantTitle)
            },
            variantOptionsChange: function(b, c, d, e, f, g) {
                new Shopify.OptionSelectors("productSelect", {
                    product: b,
                    onVariantSelected: function(b, c) {
                        var d = d,
                            b = b,
                            c = c,
                            e = (a("#ProductPhotoImg"), a("#AddToCart")),
                            f = a("#ProductPrice"),
                            g = a("#ComparePrice"),
                            h = a(".quantity-selector, label + .js-qty");
                        a("#AddToCartText");
                        if (b) {
                            b.featured_image && a(".product_thumbnail_image[data-image-id='" + b.featured_image.id + "']").click(), b.available ? e.removeClass("disabled").prop("disabled", !1) : e.addClass("disabled").prop("disabled", !0), f.html(Shopify.formatMoney(b.price, d)), b.compare_at_price > b.price ? g.html(Shopify.formatMoney(b.compare_at_price, d)).show() : g.hide();
                            for (var i = a("#" + c.domIdPrefix).closest("form"), j = 0, k = b.options.length; k > j; j++) {
                                var l = i.find('.swatch[data-option-index="' + j + '"] :radio[value="' + b.options[j] + '"]');
                                l.size() && (l.get(0).checked = !0)
                            }
                        } else e.addClass("disabled").prop("disabled", !0), h.hide()
                    },
                    enableHistoryState: !0
                });
                c && d > 1 && Shopify.linkOptionSelectors(b), 1 == d && "Title" != e && a(".selector-wrapper:eq(0)").prepend('<label for="productSelect-option-0">' + e + "</label>"), 1 == f && g.indexOf("Default") > -1 && a(".selector-wrapper").hide(), a(".swatch :radio").change(function() {
                    var b = a(this).closest(".swatch").attr("data-option-index"),
                        c = a(this).val();
                    a(this).closest("form").find(".single-option-selector").eq(b).val(c).trigger("change")
                })
            }
        },
        c = {
            init: function() {
                this.initQueryParams(), this.changeCategory(), this.changeFilter(), this.changeColorFilter(), this.changePriceSliderFilter(), this.clearFilter(), this.clearAllFilter(), this.changeViewType(), this.changeSortingOrder(), this.changePagination(), this.hideFilter(), this.handleBack(), this.activeMenuCategories()
            },
            activeMenuCategories: function() {
                a(".categories-list .children li.active").parent().addClass("open").prev().addClass("show").closest("li").addClass("active")
            },
            initQueryParams: function() {
                if (Shopify.queryParams = {}, location.search.length)
                    for (var a, b = 0, c = location.search.substr(1).split("&"); b < c.length; b++) a = c[b].split("="), a.length > 1 && (Shopify.queryParams[decodeURIComponent(a[0])] = decodeURIComponent(a[1]))
            },
            handleBack: function() {
                a(".is-collection").length > 0 && History.Adapter.bind(window, "statechange", function() {
                    History.getState();
                    c.initQueryParams(), c.getContent()
                })
            },
            changeCategory: function() {
                var b = this;
                a(".categories-list").on("click", "a", function(c) {
                    c.preventDefault();
                    var d = a(this);
                    delete Shopify.queryParams.page, a(".categories-list li").removeClass("active"), d.parent().addClass("active"), d.closest(".children").parent().addClass("active");
                    var e = d.attr("href");
                    b.getContent(e)
                })
            },
            changeFilter: function() {
                var b = this;
                a(".product-sidebar").on("change", ".widget-product-filter input", function() {
                    delete Shopify.queryParams.page, b.addQueryConstraint(), b.getContent()
                })
            },
            changeColorFilter: function() {
                var b = this;
                delete Shopify.queryParams.page, a(".product-sidebar").on("click", ".product-color-filter", function(c) {
                    c.preventDefault();
                    var d = a(this),
                        e = d.siblings("input");
                    e.prop("checked") ? e.prop("checked", !1) : e.prop("checked", "checked");
                    delete Shopify.queryParams.page, b.addQueryConstraint(), b.getContent()
                })
            },
            changePriceSliderFilter: function() {
                a("#price-slider").length > 0 && (a("#price-slider").slider({
                    range: !0,
                    min: productPriceFilterMin,
                    max: productPriceFilterMax,
                    values: [productPriceFilterMin, productPriceFilterMax],
                    slide: function(b, c) {
                        a("#amount").val("$" + c.values[0] + " - $" + c.values[1]), a(".is-product .product-container").each(function(b, d) {
                            var e = parseInt(a(d).data("price"));
                            e >= c.values[0] && e <= c.values[1] ? a(d).removeClass("product-hidden") : a(d).addClass("product-hidden")
                        })
                    }
                }), a("#amount").val("$" + a("#price-slider").slider("values", 0) + " - $" + a("#price-slider").slider("values", 1)))
            },
            clearFilter: function() {
                var b = this;
                a(".product-sidebar").on("click", ".clear-filter", function(c) {
                    c.preventDefault();
                    var d = a(this),
                        e = d.data("filter");
                    a(".product-sidebar input[value='" + e + "']").prop("checked", !1), delete Shopify.queryParams.page, b.addQueryConstraint(), b.getContent()
                })
            },
            clearAllFilter: function() {
                var b = this;
                a(".product-sidebar").on("click", ".clear-all-filter", function(c) {
                    c.preventDefault(), a(".product-sidebar input").prop("checked", !1), delete Shopify.queryParams.page, b.addQueryConstraint(), b.getContent()
                })
            },
            changeViewType: function() {
                var b = this;
                "undefined" != typeof Shopify.queryParams.view && (a(".switch-layout a").removeClass("active"), a(".switch-layout a[data-action='" + Shopify.queryParams.view + "']").addClass("active")), a(".is-collection").on("click", ".switch-layout a", function(c) {
                    c.preventDefault();
                    var d = a(this);
                    a(".switch-layout a").removeClass("active"), d.addClass("active"), Shopify.queryParams.view = d.data("action"), b.getContent()
                })
            },
            changeSortingOrder: function() {
                var b = this;
                "undefined" != typeof sortOrder && a("#SortBy").val(sortOrder), a(".is-collection").on("change", "#SortBy", function() {
                    a(this);
                    delete Shopify.queryParams.page, Shopify.queryParams.sort_by = jQuery(this).val(), b.getContent()
                })
            },
            changePagination: function() {
                var b = this;
                a(".products").on("click", "ul.pagination a", function(c) {
                    c.preventDefault();
                    var d = a(this);
                    Shopify.queryParams.page = d.data("page"), b.getContent()
                })
            },
            getContent: function(c) {
                var d = this;
                a.ajax({
                    type: "GET",
                    url: d.processUrl(c),
                    beforeSend: function() {
                        a("body").addClass("filter-loading")
                    },
                    success: function(c) {
                        d.buildContent(c), b.getRating(), a("body").removeClass("filter-loading"), a("body").trigger("is-filter-success")
                    }
                })
            },
            buildContent: function(b) {
                var c = a(b);
                a("head title").html(b.substring(b.indexOf("<title>") + 7, b.indexOf("</title>"))), a(".site-main .products").html(c.find(".site-main .products").html()), a(".filter-container").html(c.find(".filter-container").html());
                Shopify.queryParams.sort_by ? a("#SortBy").val(Shopify.queryParams.sort_by) : a("#SortBy").val(sortOrder);
                a(".switch-layout a").removeClass("active");
                Shopify.queryParams.view ? a(".switch-layout a[data-action='" + Shopify.queryParams.view + "']").addClass("active") : a(".switch-layout a[data-action='grid']").addClass("active");
                this.hideFilter(), a('.widget-product-filter [data-toggle="tooltip"]').tooltip()
            },
            processUrl: function(b) {
                var c = a.param(Shopify.queryParams).replace(/%2B/g, "+");
                c = "" != c ? "?" + c : "";
                var d = void 0 != b ? b + c : location.pathname + c;
                return History.pushState({}, d, d), d
            },
            addQueryConstraint: function() {
                delete Shopify.queryParams.constraint;
                var b = [];
                a(".widget-product-filter input[type='checkbox']:checked").each(function(c, d) {
                    b.push(a(this).val())
                }), b.length > 0 && (Shopify.queryParams.constraint = b.join("+"))
            },
            hideFilter: function() {
                a(".widget-product-filter .widget-content ul").each(function(b, c) {
                    0 == a(this).find("li").length && a(this).parents(".widget-product-filter").addClass("hidden")
                })
            }
        },
        d = {
            cookie: {
                configuration: {
                    expires: 90,
                    path: "/",
                    domain: window.location.hostname
                },
                name: "shopify_recently_viewed",
                write: function(a) {
                    jQuery.cookie(this.name, a.join(" "), this.configuration)
                },
                read: function() {
                    var a = [],
                        b = jQuery.cookie(this.name);
                    return null !== b && (a = b.split(" ")), a
                },
                destroy: function() {
                    jQuery.cookie(this.name, null, this.configuration)
                },
                remove: function(a) {
                    var b = this.read(),
                        c = jQuery.inArray(a, b); - 1 !== c && (b.splice(c, 1), this.write(b))
                }
            },
            config: {
                howManyToShow: 3,
                howManyToStoreInMemory: 10,
                onComplete: null
            },
            init: function() {
                this.recordRecentlyViewed(), this.showRecentlyViewed()
            },
            recordRecentlyViewed: function(a) {
                var a = a || {},
                    b = this;
                jQuery.extend(b.config, a);
                var c = b.cookie.read();
                if (-1 !== window.location.pathname.indexOf("/products/")) {
                    var d = window.location.pathname.match(/\/products\/([a-z0-9\-]+)/)[1],
                        e = jQuery.inArray(d, c); - 1 === e ? (c.unshift(d), c = c.splice(0, b.config.howManyToStoreInMemory)) : (c.splice(e, 1), c.unshift(d)), b.cookie.write(c)
                }
            },
            showRecentlyViewed: function(b) {
                if (a(".is-collection").length > 0) {
                    var b = b || {},
                        c = this,
                        d = 0;
                    jQuery.extend(c.config, b);
                    var e = c.cookie.read();
                    c.config.howManyToShow = Math.min(e.length, c.config.howManyToShow), c.config.howManyToShow && c.showProduct(e, d)
                }
            },
            showProduct: function(a, c) {
                var d = this;
                a.length > 0 && c < d.config.howManyToShow && (a[0] ? jQuery.ajax({
                    dataType: "json",
                    url: "/products/" + a[0] + ".js",
                    cache: !1,
                    success: function(e) {
                        d.convertProductToHtml(e), b.getRating(), a.shift(), c++, d.showProduct(a, c)
                    },
                    error: function() {
                        d.cookie.remove(a[0]), a.shift(), d.showProduct(a, c)
                    }
                }) : (d.cookie.remove(a[0]), a.shift()))
            },
            convertProductToHtml: function(b) {
                var c = a(".widget-recent-product"),
                    d = c.find(".product_list_widget"),
                    e = _.template(a("#recent-product-template").html())({
                        image: Shopify.resizeImage(b.featured_image, "small"),
                        title: b.title,
                        product_id: b.id,
                        price: Shopify.formatMoney(b.price, moneyFormat),
                        url: b.url
                    });
                d.append(e), c.hasClass("hidden") && c.removeClass("hidden")
            },
            clearList: function() {
                this.cookie.destroy()
            }
        },
        e = function(a, b) {
            b = void 0 != b ? b : 10;
            var c = a.split(/\s+/, b),
                d = c.join(" ");
            return d
        };
    a(document).ready(function() {
        b.init(), c.init(), d.init()
    })
}(jQuery),
function(a) {
    "use strict";
    var b = {
        config: {},
        init: function() {},
        _onclick: function() {}
    };
    a(document).ready(function() {
        b.init()
    })
}(jQuery),
function(a) {
    "use strict";
    var b = {
        settings: {
            BackToTop: !1,
            AnimationScroll: !1,
            StickyMenu: !0
        },
        init: function(b) {
            var c = {};
            a.extend(c, this.settings, b), a('[data-toggle="tooltip"]').tooltip(), this.IsotopeFix(), this.OwlCarouselInit(), c.StickyMenu && this.InitStickyMenu(), c.BackToTop && this.BackToTop(), this.InitSelectInput(), this.VideoBanner(), this.InitSearchButton(), this.GoogleMapsInit(), this.fixSliderLoaded()
        },
        fixSliderLoaded: function() {
            a(window).load(function() {
                a(".is-carousel").addClass("is-loaded")
            })
        },
        InitSearchButton: function() {
            a(".search-icon").on("click", "a", function(b) {
                var c = a(".is-search-form");
                return c.hasClass("open") ? c.removeClass("open") : c.addClass("open").find('input[type="search"]').focus(), !1
            })
        },
        InitStickyMenu: function() {
            var b = a(".is-header");
            a(window).scroll(function() {
                var c = a(this).scrollTop();
                350 > c ? b.removeClass("fixed") : c > 350 && b.addClass("fixed")
            })
        },
        InitRowFullWidth: function() {
            var c = a('[data-is-full-width="true"]'),
                d = c.find(".is-main-no-sidebar");
            if (!d.length) {
                var e = a(".site-main").hasClass("is-main-right-sidebar"),
                    f = a(window).width(),
                    g = c.outerHeight(),
                    h = c.find(".is-row-full-width"),
                    i = c.find(".is-sidebar");
                h.after('<div class="is-row-full-container"></div>');
                var j = h.next();
                b.setCssRowFull(h, g, i, f, j, e), a(window).resize(function() {
                    f = a(window).width(), g = c.outerHeight(), b.setCssRowFull(h, g, i, f, j, e)
                }), a(window).load(function() {
                    f = a(window).width(), g = c.outerHeight(), b.setCssRowFull(h, g, i, f, j, e)
                })
            }
        },
        setCssRowFull: function(a, b, c, d, e, f) {
            var g = (d - e.width()) / 2 + c.outerWidth();
            f && (console.log("hello"), g = -1 * g), a.css({
                width: d,
                left: g,
                height: b
            })
        },
        VideoBanner: function() {
            a(".video-banner").each(function() {
                var b = a(this),
                    c = b.find("video")[0];
                b.on("click", function() {
                    c.paused ? (c.play(), b.addClass("playing")) : (c.pause(), b.addClass("pause"), b.removeClass("playing"))
                })
            })
        },
        InitSelectInput: function() {
            a(".form-shorting select,.footer select").each(function() {
                var b = a(this);
                b.after('<div class="is-select-custom"><div class="arrow"></div></div>'), b.prependTo(b.next())
            }), a(".is-select-custom .arrow").on("click", function() {
                b.selectArrowClick(a(this).prev())
            })
        },
        selectArrowClick: function(a) {
            if (document.createEvent) {
                var b = document.createEvent("MouseEvents");
                b.initMouseEvent("mousedown", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), a[0].dispatchEvent(b)
            } else element.fireEvent && a[0].fireEvent("onmousedown")
        },
        BackToTop: function() {
            var b = '<a class="scroll-to-top" href="#" id="scrollToTop"><i class="fa fa-angle-up"></i></a>';
            a("#wrapper").after(b);
            var c = !1;
            a("#scrollToTop").click(function(b) {
                return b.preventDefault(), a("body, html").animate({
                    scrollTop: 0
                }, 500), !1
            }), a(window).scroll(function() {
                c || (c = !0, a(window).scrollTop() > 150 ? (a("#scrollToTop").stop(!0, !0).addClass("visible"), c = !1) : (a("#scrollToTop").stop(!0, !0).removeClass("visible"), c = !1))
            })
        },
        OwlCarouselInit: function() {
            var b = a('[data-owl="slide"]'),
                c = b.data("ow-rtl");
            b.each(function(b, d) {
                var e = a(this),
                    f = e.data("item-slide"),
                    g = e.data("text-next") ? a(this).data("text-next") : "",
                    h = e.data("text-prev") ? a(this).data("text-prev") : "",
                    i = e.data("item-slide-mobile") ? e.data("item-slide-mobile") : 1;
                a(this).owlCarousel({
                    nav: e.data("nav"),
                    dots: e.data("dot"),
                    rtl: c,
                    items: f,
//                  loop: true,
//                    autoplay:true,
//                    autoplayTimeout:3000,
//                    autoplayHoverPause:true,
                    navText: ["<i class='fa fa-angle-left'></i><span>" + h + "</span>", "<span>" + g + "</span><i class='fa fa-angle-right'></i>"],
                    responsive: {
                        0: {
                            items: i
                        },
                        480: {
                            items: i
                        },
                        640: {
                            items: "1" == f ? f : 3
                        },
                        991: {
                            items: "1" == f ? f : 3
                        },
                        1199: {
                            items: f
                        }
                    }
                })
            }), a('a[data-toggle="tab"]').on("shown.bs.tab", function(b) {
                a(a(b.target).attr("href")).find(".owl-carousel").owlCarousel("invalidate", "width").owlCarousel("update")
            });
            var d = a(".is-carousel");
            d.owlCarousel({
                autoplay:true,
                autoplayTimeout:d.data("autoplay"),
                autoplayHoverPause:true,
                items: 1,
                nav: d.data("nav"),
                dots: d.data("dots"),
                loop: d.data("loop"),
                navText: ["<span class='icon-arrow-left' aria-hidden='true'></span><span class='sr-only'>Previous</span>", "<span class='sr-only'>Next</span><span class='icon-arrow-right' aria-hidden='true'</span>"]
            })
        },
        IsotopeFix: function() {
            a().isotope && (a('a[data-toggle="tab"]').on("shown.bs.tab", function(b) {
                a(".isotope").isotope("reLayout")
            }), a('[id*="accordion-"]').on("shown.bs.collapse", function(b) {
                a(".isotope").isotope("reLayout")
            }))
        },
        GoogleMapsInit: function() {
            var b, c = a("#google-maps");
            if (c.length > 0) {
                var d = {
                    lat: c.data("lat"),
                    lng: c.data("lng")
                };
                b = new google.maps.Map(document.getElementById("google-maps"), {
                    center: d,
                    scrollwheel: !1,
                    zoom: c.data("zoom")
                });
                new google.maps.Marker({
                    position: d,
                    map: b
                })
            }
        }
    };
    a.fn.InspiusFrontend = function(a) {
        b.init(a)
    }
}(jQuery);